<template>
    <v-container grid-list-sm fluid mt-5 pt-5 style="background: #fafafa !important;">
      <div role="tabpanel" id="Besoins3" aria-labelledby="step-Besoins3" class="wizard-tab-container"
        style="padding-top: 5%" v-if="isDesktop()">
        <div data-v-0d43d413="">
          <div data-v-0d43d413="" class="fields">
            <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
              {{ $t('paiement.numero_devis_label') }} :
              <span class="ml-1" style="color: #ffa409">{{
                Devis_pour_souscription.numeroDevis
              }}</span>
            </div>
          </div>
        </div>
      </div>
  
      <div role="tabpanel" id="Besoins3" aria-labelledby="step-Besoins3" class="wizard-tab-container"
        style="padding-top: 25%" v-if="isMobile()">
        <div data-v-0d43d413="">
          <div data-v-0d43d413="" class="fields">
            <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
              {{ $t('paiement.numero_devis_label') }} : :
              <span class="ml-1" style="color: #ffa409">{{
                Devis_pour_souscription.numeroDevis
              }}</span>
            </div>
          </div>
        </div>
      </div>
  
      <div v-if="isDesktop()">
        <div data-v-221edead="" class="w-100 Results" pricing="true" style="
            --custom-color-primary: #35ce7e;
            --custom-color-primary-light: #5cc7000d;
          ">
          <div data-v-221edead="" class="container">
            <div data-v-221edead="" class="results-deals">
              <div data-v-221edead="" id="results-table">
                <div data-v-221edead="" style="top: 0px; width: 100%">
                  <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                    <div data-v-221edead="" class="card-default-body">
                      <!-- LA PARTIE RESPONSIVE POUR LE DESKTOP
                                          LA PARTIE RESPONSIVE POUR LE DESKTOP
                                          LA PARTIE RESPONSIVE POUR LE DESKTOP -->
                      <div data-v-221edead="" class="row d-none d-lg-flex align-items-center">
                        <div data-v-221edead="" class="col-lg-2">
                          <div data-v-221edead="" class="logo-company logo-company-economy">
                            <div data-v-221edead="" class="logo-wrapper">
                              <img class="logo-wrapper elevation-10" :src="getImgUrl( Devis_pour_souscription.partenaireid.logo)" alt="sunu logo" height="66" width="100" style="border-radius: 5px" />
                            </div>
                          </div>
                        </div>
                        <div data-v-221edead="" class="
                            col-lg-5
                            align-items-lg-center
                            company-result-values
                          ">
                          <div data-v-221edead="" class="justify-content-center column">
                            <div data-v-221edead="" class="row ml-5">
                              <button data-v-221edead="" type="button" class="c-btn-blue" @click="
                                assistanceDialogManip(Devis_pour_souscription)
                                ">
                                <img data-v-221edead="" src="../assets/img/icones/phone.svg" alt="se faire rappeler" width="20"
                                  height="16px" class="mr-2 result-picto__picture" />{{ $t('paiement.etre_rappele_label') }}
                                :
                              </button>
                              <button data-v-221edead="" type="button" class="ml-3 c-btn-blue"
                                @click="devisParMail(Devis_pour_souscription)">
                                <img data-v-221edead="" src="../assets/img/icones/mail.svg" alt="devis par mail" width="20"
                                  height="16px" class="mr-2 result-picto__picture" />{{ $t('paiement.devis_par_mail') }} :
                              </button>
                            </div>
                            <div data-v-221edead="" class="row mt-3 ml-5">
                              <button data-v-221edead="" type="button" class="c-btn-blue" @click="
                                telecharger_le_devis(Devis_pour_souscription)
                                ">
                                <img data-v-221edead="" src="../assets/img/icones/download.svg" alt="Télécharger" width="20"
                                  height="16px" class="mr-2 result-picto__picture" />{{ $t('paiement.telecharger_label') }}
                                :
                              </button>
                            </div>
                          </div>
                        </div>
                        <div data-v-221edead="" class="col-lg-5">
                          <div data-v-221edead="" class="justify-content-center row">
                            <div data-v-221edead="" class="col-lg-12 d-flex justify-content-lg-end">
                              <div data-v-221edead="" class="result-monthly justify-content-center row">
                                <div data-v-221edead="" class="result-premium-monthly">
                                  {{
                                    Devis_pour_souscription.prime_ttc.toLocaleString()
                                  }}
                                </div>
                              </div>
                            </div>
                            <div data-v-221edead="" class="col-lg-12 d-flex justify-content-lg-end">
                              <div data-v-221edead="" class="result-monthly justify-content-center row">
                                <div data-v-221edead="" class="font-weight-bold ml-2"
                                  style="font-size: 2.9rem; color: #737373">
                                  TTC
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div v-if="isMobile()">
        <v-container class="border-radius" style="padding-right: 25px !important; padding-left: 25px !important">
          <div data-v-221edead="" class="w-100 Results" pricing="true" style="
              --custom-color-primary: #35ce7e;
              --custom-color-primary-light: #5cc7000d;
            ">
            <div data-v-221edead="" class="container">
              <div data-v-221edead="" class="results-deals">
                <div data-v-221edead="" id="results-table">
                  <div data-v-221edead="" style="top: 0px; width: 100%">
                    <div data-v-221edead="" class="
                        card-default
                        result
                        text-center
                        naoassur
                        elevation-10
                      ">
                      <div data-v-221edead="" class="card-default-body">
                        <div data-v-221edead="" class="d-lg-none" style="margin-top: 8%">
                          <div data-v-221edead="" class="logo-company mt-3" v-if="Devis_pour_souscription != null">
                            <img class="logo-wrapper elevation-10" :src="getImgUrl(Devis_pour_souscription.partenaireid.logo)" :title="Devis_pour_souscription.partenaireid.societe" alt="sunu logo" height="66" width="100" style="border-radius: 5px" />
                          </div>
                          <div data-v-221edead="" class="company-values justify-content-center row">
                            <div data-v-221edead="" class="
                                result-monthly
                                mt-3
                                justify-content-center
                                row
                                mr-5
                              " v-if="Devis_pour_souscription != null">
                              <div data-v-221edead="" class="result-premium-monthly">
                                {{
                                  Devis_pour_souscription.prime_ttc.toLocaleString()
                                }}
                              </div>
                            </div>
                          </div>
                          <div data-v-221edead="" class="col-lg-12 d-flex justify-content-lg-end mr-3"
                            style="margin-top: -20px">
                            <div data-v-221edead="" class="result-monthly justify-content-center row">
                              <div data-v-221edead="" class="font-weight-bold" style="font-size: 2.9rem; color: #737373">
                                TTC
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <!-- LA PARTIE RESPONSIVE POUR LE MOBILE
                                          LA PARTIE RESPONSIVE POUR LE MOBILE
                                          LA PARTIE RESPONSIVE POUR LE MOBILE -->
                      <div data-v-221edead="" class="
                          card-default-footer card-default-btn
                          d-lg-none
                          justify-content-center
                          row
                          mt-5
                        " style="margin-left: 10px; margin-right: 10px">
                        <button data-v-221edead="" type="button" class="c-btn-green"
                          @click="assistanceDialogManip(Devis_pour_souscription)">
                          <img data-v-221edead="" src="../assets/img/icones/phone.svg" alt="se faire rappeler" width="20"
                            height="16px" class="mr-2 result-picto__picture" />{{ $t('paiement.etre_rappele_label') }} :
                        </button>
  
                        <button data-v-221edead="" type="button" class="ml-2 c-btn-green"
                          @click="devisParMail(Devis_pour_souscription)">
                          <img data-v-221edead="" src="../assets/img/icones/mail.svg" alt="devis par mail" width="20"
                            height="16px" class="mr-2 result-picto__picture" />{{ $t('paiement.devis_par_mail') }} :
                        </button>
                      </div>
  
                      <div data-v-221edead="" class="
                          card-default-footer card-default-btn
                          d-lg-none
                          justify-content-center
                          row
                          mt-3
                        " style="margin-left: 10px; margin-right: 10px">
                        <button data-v-221edead="" type="button" class="c-btn-green"
                          @click="telecharger_le_devis(Devis_pour_souscription)">
                          <img data-v-221edead="" src="../assets/img/icones/download.svg" alt="Télécharger" width="20"
                            height="16px" class="mr-2 result-picto__picture" />{{ $t('paiement.telecharger_label') }} :
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!--========= Details Assurance cas Automobile MOBILE ================-->
          <!--========= Details Assurance cas Automobile MOBILE ================-->
          <!--========= Details Assurance cas Automobile MOBILE ================-->
          <!--========= Details Assurance cas Automobile MOBILE ================-->
          <div data-v-221edead="" v-if="Devis_pour_souscription.brancheid.branche == 'Automobile'" class="w-100 Results"
            pricing="true" style="
              --custom-color-primary: #35ce7e;
              --custom-color-primary-light: #5cc7000d;
            ">
            <paymentAuto></paymentAuto>
          </div>
  
          <!--========= Details Assurance cas Habitation MOBILE ================-->
          <!--========= Details Assurance cas Habitation MOBILE ================-->
          <!--========= Details Assurance cas Habitation MOBILE ================-->
          <!--========= Details Assurance cas Habitation MOBILE ================-->
          <div data-v-221edead="" v-if="Devis_pour_souscription.brancheid.branche == 'Habitation'" class="w-100 Results"
            pricing="true" style="
              --custom-color-primary: #35ce7e;
              --custom-color-primary-light: #5cc7000d;
            ">
            <paymentHabitation></paymentHabitation>
  
          </div>
  
          <!--========= Details Assurance cas Voyage MOBILE ================-->
          <!--========= Details Assurance cas Voyage MOBILE ================-->
          <!--========= Details Assurance cas Voyage MOBILE ================-->
          <!--========= Details Assurance cas Voyage MOBILE ================-->
          <div data-v-221edead="" v-show="showPaymentBLock == true" class="w-100 Results" pricing="true" style="
              --custom-color-primary: #35ce7e;
              --custom-color-primary-light: #5cc7000d;
            ">
            <othersPayment></othersPayment>
          </div>
  
          <!--========= Details Assurance cas Vie MOBILE ================-->
          <!--========= Details Assurance cas Vie MOBILE ================-->
          <!--========= Details Assurance cas Vie MOBILE ================-->
          <!--========= Details Assurance cas Vie MOBILE ================-->
          <div data-v-221edead="" v-if="Devis_pour_souscription.brancheid.branche == 'Vie'" class="w-100 Results"
            pricing="true" style="
              --custom-color-primary: #35ce7e;
              --custom-color-primary-light: #5cc7000d;
            ">
            <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="wizard-tab-container">
              <div data-v-0d43d413="">
                <div data-v-0d43d413="" class="fields">
                  <div data-v-0d43d413="" class="
                      font-weight-bold
                      field-title
                      mb-0
                      row
                      justify-content-center
                    ">
                    {{ $t('paiement.detail_assurance_label') }}
                  </div>
                </div>
              </div>
            </div>
  
            <div data-v-221edead="" class="container">
              <div data-v-221edead="" class="results-deals">
                <div data-v-221edead="" id="results-table">
                  <div data-v-221edead="" style="top: 0px; width: 100%">
                    <div data-v-221edead="" class="
                        card-default
                        result
                        text-center
                        naoassur
                        elevation-10
                      ">
                      <div data-v-221edead="" class="card-default-body">
                        <h1 class="field-title row justify-content-center">
                          {{ $t('paiement.objet_assure_title') }}
                        </h1>
                        <div data-v-221edead="" class="logo-company logo-company-economy">
                          <ul class="to-left policeLato" v-if="Devis_pour_souscription.partenaireid.societe ==
                            'SUNU-VIE'
                            ">
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.duree_cotisation') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  Devis_pour_souscription.education_plus.duree
                                }}
                                {{ $t('paiement.vie.objet_assure_colonne.an') }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.capital_a_terme') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  Devis_pour_souscription.education_plus.capital.toLocaleString()
                                }}
                                FCFA</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.rente_annuel') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  Devis_pour_souscription.education_plus.Rente.toLocaleString()
                                }}
                                FCFA</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.prime_mensuel') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  Devis_pour_souscription.education_plus.prime_mensuelle.toLocaleString()
                                }}
                                FCFA</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.date_effet') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  DateFormater(Devis_pour_souscription.dateEffet)
                                }}</span>
                            </li>
                          </ul>
  
                          <ul class="to-left policeLato" v-if="Devis_pour_souscription.partenaireid.societe ==
                              'NSIA-VIE'
                              ">
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.duree_cotisation') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  Devis_pour_souscription.education_plus.duree
                                }}
                                {{ $t('paiement.vie.objet_assure_colonne.an') }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.duree_service') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  Devis_pour_souscription.education_plus
                                    .duree_service
                                }}
                                {{ $t('paiement.vie.objet_assure_colonne.an') }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.bourse_annuel') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  Devis_pour_souscription.education_plus.capital.toLocaleString()
                                }}
                                FCFA</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.prime_mensuel') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  Devis_pour_souscription.education_plus.prime_mensuelle.toLocaleString()
                                }}
                                FCFA</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{ $t('paiement.vie.objet_assure_colonne.date_effet') }} :
                              <span class="field-sub-title to-right">
                                {{
                                  DateFormater(Devis_pour_souscription.dateEffet)
                                }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!--========= Details Checkout MOBILE ================-->
          <!--========= Details Checkout MOBILE ================-->
          <!--========= Details Checkout MOBILE ================-->
          <!--========= Details Checkout MOBILE ================-->
          <div data-v-221edead="" class="w-100 Results" pricing="true" style="
              --custom-color-primary: #35ce7e;
              --custom-color-primary-light: #5cc7000d;
            ">
            <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="wizard-tab-container">
              <div data-v-0d43d413="">
                <div data-v-0d43d413="" class="fields">
                  <div data-v-0d43d413="" class="
                      font-weight-bold
                      field-title
                      mb-0
                      row
                      justify-content-center
                    ">
                    {{ $t('paiement.checkout_label') }}
                  </div>
                </div>
              </div>
            </div>
  
            <div data-v-221edead="" class="container">
              <div data-v-221edead="" class="results-deals">
                <div data-v-221edead="" id="results-table">
                  <div data-v-221edead="" style="top: 0px; width: 100%">
                    <div data-v-221edead="" class="
                        card-default
                        result
                        text-center
                        naoassur
                        elevation-10
                      ">
                      <div data-v-221edead="" class="card-default-body">
                        <div data-v-221edead="" class="
                            ml-3
                            mr-3
                            mt-3
                            row
                            logo-company logo-company-economy
                          ">
                          <v-card width="100%" class="border-radius">
                            <v-toolbar card color="#ffa409" dark>
                              <v-toolbar-title class="policeLato field-title text-white">{{
                                $t('paiement.mode_livraison_colonne.livraison_title') }}</v-toolbar-title>
                            </v-toolbar>
                            <v-item-group style="margin-top: -15px">
                              <ul>
                                <v-radio-group full-width class="answer policeLato ml-3" v-model="mode_livraison">
                                  <v-radio color="#ffa409" class="highlight"
                                    :label="$t('paiement.mode_livraison_colonne.domicile')" value="a_domicile"
                                    @change="Popupadresse = true" :disabled="this.$store.state.devispayement.devis.brancheid.branche == 'Automobile' && this.mode_livraison =='talon_auto_digital'"></v-radio>
                                    <v-radio color="#ffa409" class="highlight"
                                    label="Talon Auto Digital (gratuit)" value="talon_auto_digital"
                                    :disabled="this.$store.state.devispayement.devis.brancheid.branche != 'Automobile'"></v-radio>
                                  <v-radio color="#ffa409" class="highlight"
                                    :label="$t('paiement.mode_livraison_colonne.reseau')" value="reseau_partenaire"
                                    disabled></v-radio>
                                  <v-flex class="ml-0 row">
                                  
  
                                      <v-radio color="#ffa409" class="highlight"
                                      :label="$t('paiement.mode_livraison_colonne.assur_store')"
                                      value="locaux_assuraf" :disabled="this.$store.state.devispayement.devis.brancheid.branche == 'Automobile' && this.mode_livraison =='talon_auto_digital'"></v-radio>
                                      
                                    <h6 class="field-sub-title pt-3" @click="aStorMap = true">
                                      {{ $t('paiement.mode_livraison_colonne.plan_label') }}
                                    </h6>
                                  </v-flex>
                                </v-radio-group>
                              </ul>
                            </v-item-group>
                          </v-card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div data-v-221edead="" class="container">
              <div data-v-221edead="" class="results-deals">
                <div data-v-221edead="" id="results-table">
                  <div data-v-221edead="" style="top: 0px; width: 100%">
                    <div data-v-221edead="" class="
                        card-default
                        result
                        text-center
                        naoassur
                        elevation-10
                      ">
                      <div data-v-221edead="" class="card-default-body">
                        <div data-v-221edead="" class="
                            ml-3
                            mr-3
                            mt-3
                            row
                            logo-company logo-company-economy
                          ">
                          <v-card width="100%" class="border-radius">
                            <v-toolbar card color="#ffa409" dark>
                              <v-toolbar-title class="policeLato field-title text-white">{{
                                $t('paiement.mode_paiement_colonne.paiement_title') }}</v-toolbar-title>
                            </v-toolbar>
                            <v-item-group style="margin-top: -15px">
                              <ul>
                                <v-radio-group @change="calculFraisPaiement()" full-width v-model="mode_payement"
                                  class="answer policeLato">
                                  <div class="row highlight paymentwalelet-container">
                                    <v-radio color="#ffa409" label="Orange money" value="mobile_money"
                                      style="width:50%"></v-radio>
                                    <img width="50" height="30" alt="orange-money-logo"
                                      src="../assets/img/logoPaiement/orange-money.png" />
                                  </div>
  
                                  <div class="row highlight paymentwalelet-container">
                                    <v-radio color="#ffa409" label="Wave" value="wave" style="width:50%"></v-radio>
                                    <img class="ml-2" width="30" height="30" alt="wave-logo"
                                      src="../assets/img/logoPaiement/wave.png" />
                                  </div>
  
                                  <div class="row highlight paymentwalelet-container">
                                    <v-radio color="#ffa409" label="Kpay" value="kpay" style="width:50%"></v-radio>
                                    <img class="ml-3" width="30" height="30" alt="kpay-logo"
                                      src="../assets/img/logoPaiement/kpay_logo.webp" />
                                  </div>
  
                                  <div class="row highlight paymentwalelet-container">
                                    <v-radio color="#ffa409" label="Free Money" value="free_money"
                                      style="width:50%"></v-radio>
                                    <img width="60" height="30" alt="free-money-logo" src="../assets/img/logoPaiement/freemoney.png" />
                                  </div>
  
                                  <div class="row highlight paymentwalelet-container">
                                    <v-radio color="#ffa409"
                                      :label="$t('paiement.mode_paiement_colonne.carte_bancaire_label')"
                                      value="carte_bancaire" style="width:50%"></v-radio>
                                    <img class="pt-1" width="60" height="25" alt="visa-logo"
                                      src="../assets/img/logoPaiement/visa.png" /> ||
                                    <img class="ml-1" width="60" height="30" alt="master-card-logo"
                                      src="../assets/img/logoPaiement/master-card.png" />
                                  </div>
  
                                  <div class="row highlight paymentwalelet-container">
                                    <v-radio color="#ffa409"
                                      :label="$t('paiement.mode_paiement_colonne.autre_paiement_label')"
                                      value="autre_paiement"></v-radio>
                                  </div>
  
                                  <div class="row highlight paymentwalelet-container">
                                    <v-radio color="#ffa409" :label="$t('paiement.mode_paiement_colonne.paiement_reseaux')"
                                      value="reseau_partenaire" disabled></v-radio>
                                  </div>
  
                                </v-radio-group>
                              </ul>
                            </v-item-group>
                          </v-card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <!-- Section html pour la reduction commercial appliquée sur le ttc du devis mobile ---
            ---- Section html pour la reduction commercial appliquée sur le ttc du devis mobile -->
            <div class="mt-5">
              <div class="fields">
                <div class="row">
                  <div>
                    <div class="switch">
                        <label for="coupon_switch_mobile"><span class="field-label">{{ $t('paiement.coupon_section.label_switch') }}</span>
                        <input :disabled="hideCoupon" style="margin-top:5px" @change="openCoupon()" v-model="couponswitch" type="checkbox" id="coupon_switch_mobile">
                        <span style="margin-top: 5px;" class="lever"></span>
                        </label>
                    </div>
                  </div>
                </div>
  
                <div class="row" v-if=showPopupCoupon>
                  <div class="col-sm-12">
                    <div class="field-group field-default">
                      <label for="code_reduction_mobile" class="field-label">
                        {{ $t('paiement.coupon_section.label_code_input') }}
                      </label>
                      <div class="input-group value-loan">
                        <input :disabled="hideCoupon" v-model="codeReduction" id="code_reduction_mobile" name="codeReductionMobile" class="field-input" />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                       <!-- A ne pas supprimer -->
                      </div>
                      <div class="wizard-footer-right">
                        <button :disabled="hideCoupon" @click="checkReductionCom()" type="button" class="wizard-btn">
                          {{ $t('paiement.coupon_section.bouton_valider') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fin de la section html pour la reduction commercial appliquée sur le ttc du devis mobile ---
            ---- Fin de la section html pour la reduction commercial appliquée sur le ttc du devis mobile -->
  
            <div role="tabpanel" id="Besoins3" aria-labelledby="step-Besoins3" class="mt-5 wizard-tab-container">
              <!-- Affichage de la prime sans la réduction pour information aux utilisateur mobile -->
              <div data-v-0d43d413="" class="fields" v-show='showReduction'>
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <div data-v-0d43d413="" class="field-title mb-0">
                      {{ $t('paiement.prime_ttc') }} :
                    </div>
                  </div>
  
                  <div class="wizard-footer-right">
                    <div data-v-0d43d413="" class="field-title mb-0" style="color: #ffa409" v-if="prime_ttc_before_reduc != null">
                      {{ prime_ttc_before_reduc.toLocaleString() }} FCFA
                    </div>
                  </div>
                </div>
              </div>
  
              <div data-v-0d43d413="" class="fields" style="margin-top: -45px !important" v-show="showReduction">
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <div data-v-0d43d413="" class="field-title mb-0">
                      {{ $t('paiement.coupon_section.label_reduction') }} :
                    </div>
                  </div>
  
                  <div class="wizard-footer-right">
                    <div data-v-0d43d413="" class="field-title mb-0" style="color: #ffa409" v-if="prime_ttc_before_reduc != null">
                      {{ reductionMount }} {{  typeReduction }}
                    </div>
                  </div>
                </div>
              </div>
  
              <div data-v-0d43d413="" style="margin-top: -45px !important" class="fields" v-show="mode_livraison">
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <div data-v-0d43d413="" class="field-title mb-0">
                      {{ $t('paiement.coupon_section.ttc_a_regler') }} :
                    </div>
                  </div>
  
                  <div class="wizard-footer-right">
                    <div data-v-0d43d413="" class="field-title mb-0" style="color: #ffa409">
                      {{ Devis_pour_souscription.prime_ttc.toLocaleString() }} FCFA
                    </div>
                  </div>
                </div>
              </div>
              
             
  
             
  
             
  
              <div data-v-0d43d413="" class="fields" style="margin-top: -45px !important" v-show="mode_livraison">
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <div data-v-0d43d413="" class="field-title mb-0">
                      {{ $t('paiement.frais_livraison') }} :
                    </div>
                  </div>
  
                  <div class="wizard-footer-right">
                    <div data-v-0d43d413="" class="field-title mb-0" style="color: #ffa409">
                      {{ fraisLiv }} FCFA
                    </div>
                  </div>
                </div>
              </div>
  
              <div data-v-0d43d413="" class="fields" style="margin-top: -45px !important" v-show="mode_livraison">
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <div data-v-0d43d413="" class="field-title mb-0">
                      {{ $t('paiement.frais_paiement') }} :
                    </div>
                  </div>
  
                  <div class="wizard-footer-right">
                    <div data-v-0d43d413="" class="field-title mb-0" style="color: #ffa409">
                      {{ Math.ceil(fraisPaiement) }} FCFA
                    </div>
                  </div>
                </div>
              </div>
  
              <div data-v-0d43d413="" class="fields" style="margin-top: -45px !important" v-show="mode_livraison">
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <div data-v-0d43d413="" class="field-title mb-0">{{ $t('paiement.total') }} :</div>
                  </div>
  
                  <div class="wizard-footer-right">
                    <div data-v-0d43d413="" class="field-title mb-0" style="color: #5b94bc">
                      {{ mention_ttc.toLocaleString() }} FCFA
                    </div>
                  </div>
                </div>
              </div>
  
              <div data-v-0d43d413="" class="fields" v-show="mode_livraison">
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left"></div>
                  <div class="wizard-footer-right mb-5"
                    v-if="$store.state.devispayement.devis.brancheid.branche == 'Caution'">
                    <!--Bouton de Paiement Avec les wallet dispo sur upay payement_end-->
                    <button type="button" class="wizard-btn"
                      v-show="mode_payement == 'autre_paiement' || mode_payement == 'carte_bancaire' || mode_payement == 'mobile_money' || mode_payement == 'wave' || mode_payement == 'intouch' || mode_payement == 'free_money'"
                      @click="checkBranchCaution">
                      {{ $t('paiement.bouton_payer_label') }}
                    </button>
                  </div>
  
                  <div class="wizard-footer-right mb-5"
                    v-if="$store.state.devispayement.devis.brancheid.branche != 'Caution'">
                    <!--Bouton de Paiement Avec les wallet dispo sur upay payement_end-->
                    <button type="button" class="wizard-btn" v-show="mode_payement == 'autre_paiement'"
                      @click="payement_start">
                      {{ $t('paiement.bouton_payer_label') }}
                    </button>
  
                    <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                    <button type="button" class="wizard-btn" v-show="mode_payement == 'carte_bancaire'"
                      @click="payment_Orabank">
                      {{ $t('paiement.bouton_payer_label') }}
                    </button>
  
                    <!-- boutton pour wave qui appelle la fonction de payement_wave_start -->
                    <button type="button" class="wizard-btn" v-show="mode_payement == 'wave'" @click="payement_wave_start">
                      {{ $t('paiement.bouton_payer_label') }}
                    </button>
  
                    <!--Bouton de Paiement Par OrangeMoney Assuraf-->
                    <button type="button" class="wizard-btn" v-show="mode_payement == 'mobile_money'"
                      @click="open_payment_om">
                      {{ $t('paiement.bouton_payer_label') }}
                    </button>
  
                    <button type="button" class="wizard-btn" v-show="mode_payement == 'free_money'" @click="payment_free">
                      {{ $t('paiement.bouton_payer_label') }}
                    </button>
  
                    <button type="button" class="wizard-btn" v-show="mode_payement == 'kpay'" @click="payement_kpay_start">
                      {{ $t('paiement.bouton_payer_label') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </div>
  
      <div v-if="isDesktop()">
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <div v-if="Devis_pour_souscription.brancheid.branche == 'Automobile'">
          <!--============ PAGE PAIEMENT DEVIS AUTO =============== -->
          <paymentAuto></paymentAuto>
        </div>
  
        <!--========= Details Assurance cas Habitation DESKTOP ================-->
        <!--========= Details Assurance cas Habitation DESKTOP ================-->
        <!--========= Details Assurance cas Habitation DESKTOP ================-->
        <!--========= Details Assurance cas Habitation DESKTOP ================-->
        <div v-if="Devis_pour_souscription.brancheid.branche == 'Habitation'">
          <!--============ PAGE PAIEMENT DEVIS HABITATION =============== -->
          <paymentHabitation></paymentHabitation>
        </div>
  
        <!--========= Details Assurance cas Voyage DESKTOP ================-->
        <!--========= Details Assurance cas Voyage DESKTOP ================-->
        <!--========= Details Assurance cas Voyage DESKTOP ================-->
        <!--========= Details Assurance cas Voyage DESKTOP ================-->
        <div v-show="showPaymentBLock == true">
          <othersPayment></othersPayment>
        </div>
  
        <!--========= Details Assurance cas Vie DESKTOP ================-->
        <!--========= Details Assurance cas Vie DESKTOP ================-->
        <!--========= Details Assurance cas Vie DESKTOP ================-->
        <!--========= Details Assurance cas Vie DESKTOP ================-->
        <div v-if="Devis_pour_souscription.brancheid.branche == 'Vie'">
          <div v-if="isDesktop()">
            <div data-v-221edead="" class="container">
              <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="wizard-tab-container">
                <div data-v-0d43d413="">
                  <div data-v-0d43d413="" class="fields">
                    <div data-v-0d43d413="" class="
                        font-weight-bold
                        field-title
                        mb-0
                        row
                        justify-content-center
                      ">
                      {{ $t('paiement.detail_assurance_label') }}
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-221edead="" class="results-deals">
                <div data-v-221edead="" id="results-table">
                  <div data-v-221edead="" style="top: 0px; width: 100%">
                    <div data-v-221edead="" class="
                        card-default
                        result
                        text-center
                        naoassur
                        elevation-10
                      ">
                      <div data-v-221edead="" class="card-default-body">
                        <div data-v-221edead="" class="row d-none d-lg-flex align-items-center"
                          style="height: 220px !important">
                          <div data-v-221edead="" class="
                              col-lg-12
                              align-items-lg-center
                              company-result-values
                            ">
                            <div data-v-221edead="" class="logo-company logo-company-economy">
                              <div class="justify-content-center column">
                                <div class="justify-content-center row" style="
                                    width: 100%;
                                    height: 100%;
                                    position: absolute;
                                    top: -10px;
                                    left: 0;
                                    opacity: 0.8;
                                  ">
                                  <h1 class="
                                      field-title
                                      text-center
                                      row
                                      justify-content-center
                                    ">
                                    {{ $t('paiement.objet_assure_title') }}
                                  </h1>
                                </div>
                                <div class="justify-content-center row" style="height: 300px">
                                  <ul class="ml-5 pl-5 mr-5 pr-5 to-left policeLato"
                                    style="margin-top: 5% !important; width: 50%" v-if="Devis_pour_souscription.partenaireid
                                      .societe == 'SUNU-VIE'
                                      ">
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.duree_cotisation') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          Devis_pour_souscription.education_plus
                                            .duree
                                        }}
                                        {{ $t('paiement.vie.objet_assure_colonne.an') }}</span>
                                    </li>
  
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.capital_a_terme') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          Devis_pour_souscription.education_plus.capital.toLocaleString()
                                        }}
                                        FCFA</span>
                                    </li>
  
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.rente_annuel') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          Devis_pour_souscription.education_plus.Rente.toLocaleString()
                                        }}
                                        FCFA</span>
                                    </li>
  
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.prime_mensuel') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          Devis_pour_souscription.education_plus.prime_mensuelle.toLocaleString()
                                        }}
                                        FCFA</span>
                                    </li>
  
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.date_effet') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          DateFormater(
                                            Devis_pour_souscription.dateEffet
                                          )
                                        }}</span>
                                    </li>
                                  </ul>
  
                                  <ul class="ml-5 pl-5 mr-5 pr-5 to-left policeLato"
                                    style="margin-top: 5% !important; width: 50%" v-if="Devis_pour_souscription.partenaireid
                                          .societe == 'NSIA-VIE'
                                        ">
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.duree_cotisation') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          Devis_pour_souscription.education_plus
                                            .duree
                                        }}
                                        {{ $t('paiement.vie.objet_assure_colonne.an') }}</span>
                                    </li>
  
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.duree_service') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          Devis_pour_souscription.education_plus
                                            .duree_service
                                        }}
                                        {{ $t('paiement.vie.objet_assure_colonne.an') }}</span>
                                    </li>
  
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.bourse_annuel') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          Devis_pour_souscription.education_plus.capital.toLocaleString()
                                        }}
                                        FCFA</span>
                                    </li>
  
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.prime_mensuel') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          Devis_pour_souscription.education_plus.prime_mensuelle.toLocaleString()
                                        }}
                                        FCFA</span>
                                    </li>
  
                                    <li class="field-sub-title">
                                      {{ $t('paiement.vie.objet_assure_colonne.date_effet') }} :
                                      <span class="field-sub-title to-right">
                                        {{
                                          DateFormater(
                                            Devis_pour_souscription.dateEffet
                                          )
                                        }}</span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!--========= Details Checkout DESKTOP ================-->
        <!--========= Details Checkout DESKTOP ================-->
        <!--========= Details Checkout DESKTOP ================-->
        <!--========= Details Checkout DESKTOP ================-->
        <div>
          <div>
            <div data-v-221edead="" class="container">
              <div role="tabpanel" id="Besoins3" aria-labelledby="step-Besoins3" class="wizard-tab-container" style="">
                <div data-v-0d43d413="" finalmodel="[object Object]">
                  <div data-v-0d43d413="" class="fields">
                    <div data-v-0d43d413="" class="
                        font-weight-bold
                        field-title
                        mb-0
                        row
                        justify-content-center
                      ">
                      {{ $t('paiement.checkout_label') }}
                    </div>
                    <!-- <p data-v-0d43d413="" class="field-sub-title mb-5">Maitrisez vos dépenses de santé en choisissant vos critères les plus importants, notre comparateur se chargera de trouver la meilleure offre !</p> -->
                  </div>
                </div>
              </div>
              <div data-v-221edead="" class="results-deals">
                <div data-v-221edead="" id="results-table">
                  <div data-v-221edead="" style="top: 0px; width: 100%">
                    <div data-v-221edead="" class="
                        card-default
                        result
                        text-center
                        naoassur
                        elevation-10
                      ">
                      <div data-v-221edead="" class="card-default-body">
                        <div data-v-221edead="" class="d-lg-none">
                          <div data-v-221edead="" class="logo-company" v-if="Devis_pour_souscription != null">
                            <img class="logo-wrapper elevation-10"
                              :src="getImgUrl(Devis_pour_souscription.partenaireid.logo)"
                              :title="Devis_pour_souscription.partenaireid.societe" alt="sunu logo" height="66" width="100" />
                          </div>
                          <div data-v-221edead="" class="company-values justify-content-center row">
                            <div data-v-221edead="" class="
                                result-monthly
                                mt-3
                                justify-content-center
                                row
                                mr-5
                              " v-if="Devis_pour_souscription != null">
                              <div data-v-221edead="" class="result-premium-monthly">
                                {{
                                  Devis_pour_souscription.prime_ttc.toLocaleString()
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-v-221edead="" class="row d-none d-lg-flex align-items-center">
                          <div data-v-221edead="" class="col-lg-6">
                            <v-card width="auto" class="ml-5 border-radius elevation-10" style="top: -62px">
                              <v-toolbar card color="#ffa409" dark>
                                <v-toolbar-title class="policeLato field-title text-white">{{
                                  $t('paiement.mode_livraison_colonne.livraison_title') }}
                                </v-toolbar-title>
                              </v-toolbar>
                              <v-item-group style="margin-top: -15px">
                                <ul>
                                  <v-radio-group full-width class="answer policeLato" v-model="mode_livraison">
                                      <v-radio color="#ffa409" class="highlight" :label="$t('paiement.mode_livraison_colonne.domicile')" value="a_domicile" @change="Popupadresse = true" :disabled="this.$store.state.devispayement.devis.brancheid.branche == 'Automobile' && this.mode_livraison == 'talon_auto_digital'"></v-radio>
                                      <v-radio color="#ffa409" class="highlight" label="Talon Auto Digital (gratuit)" value="talon_auto_digital" :disabled="this.$store.state.devispayement.devis.brancheid.branche != 'Automobile'"></v-radio>
                                      <v-radio color="#ffa409" class="highlight" :label="$t('paiement.mode_livraison_colonne.reseau')" value="reseau_partenaire" disabled></v-radio>
                                    <v-flex class="ml-0 row">
                                      <v-radio color="#ffa409" class="highlight" :label="$t('paiement.mode_livraison_colonne.assur_store')" value="locaux_assuraf" :disabled="this.$store.state.devispayement.devis.brancheid.branche == 'Automobile' && this.mode_livraison == 'talon_auto_digital'"></v-radio>
                                      <h6 class="field-sub-title pt-3" @click="aStorMap = true">
                                        {{ $t('paiement.mode_livraison_colonne.plan_label') }}
                                      </h6>
                                    </v-flex>
                                  </v-radio-group>
                                </ul>
                              </v-item-group>
                            </v-card>
                          </div>
                          <div data-v-221edead="" class="col-lg-6">
                            <v-card width="auto" class="ml-5 mr-5 border-radius elevation-10">
                              <v-toolbar card color="#ffa409" dark>
                                <v-toolbar-title class="policeLato field-title text-white">{{
                                  $t('paiement.mode_paiement_colonne.paiement_title') }}</v-toolbar-title>
                              </v-toolbar>
                              <v-item-group style="margin-top: -15px">
                                <ul>
                                  <v-radio-group @change="calculFraisPaiement()" full-width v-model="mode_payement"
                                    class="answer policeLato">
                                    <div class="row highlight">
                                      <v-radio color="#ffa409" label="Orange money" value="mobile_money"
                                        style="width:40%"></v-radio>
                                      <img width="50" height="30" alt="orange-moeny-logo"
                                        src="../assets/img/logoPaiement/orange-money.png" />
                                    </div>
  
                                    <div class="row highlight">
                                      <v-radio color="#ffa409" label="Wave" value="wave" style="width:40%"></v-radio>
                                      <img class="ml-2" width="30" height="30" alt="wave-logo"
                                        src="../assets/img/logoPaiement/wave.png" />
                                    </div>
  
                                    <div class="row highlight">
                                      <v-radio color="#ffa409" label="Kpay" value="kpay" style="width:40%"></v-radio>
                                      <img class="ml-3" width="30" height="30" alt="kpay-logo"
                                        src="../assets/img/logoPaiement/kpay_logo.webp" />
                                    </div>
  
                                    <div class="row highlight">
                                      <v-radio color="#ffa409" label="Free Money" value="free_money"
                                        style="width:40%"></v-radio>
                                      <img width="60" height="30" alt="free-money-logo"
                                        src="../assets/img/logoPaiement/freemoney.png" />
                                    </div>
  
                                    <div class="row highlight">
                                      <v-radio color="#ffa409"
                                        :label="$t('paiement.mode_paiement_colonne.carte_bancaire_label')"
                                        value="carte_bancaire" style="width:40%"></v-radio>
                                      <img class="pt-1" width="60" height="25" alt="visa-logo"
                                        src="../assets/img/logoPaiement/visa.png" /> ||
                                      <img class="ml-1" width="60" height="30" alt="master-card-logo"
                                        src="../assets/img/logoPaiement/master-card.png" />
                                    </div>
  
                                    <div class="row highlight">
                                      <v-radio color="#ffa409"
                                        :label="$t('paiement.mode_paiement_colonne.autre_paiement_label')"
                                        value="autre_paiement"></v-radio>
                                    </div>
  
                                    <div class="row highlight">
                                      <v-radio color="#ffa409"
                                        :label="$t('paiement.mode_paiement_colonne.paiement_reseaux')"
                                        value="reseau_partenaire" disabled></v-radio>
                                    </div>
                                  </v-radio-group>
                                </ul>
                              </v-item-group>
                            </v-card>
                          </div>
                        </div>
  
                        <!-- Section html pour la reduction commercial appliquée sur le ttc du devis desktop ---
                        ---- Section html pour la reduction commercial appliquée sur le ttc du devis desktop -->
                        <div>
                          <div class="fields">
                            <div class="row">
                              <div>
                                <div class="switch">
                                    <label for="switch_coupon_desktop"><span class="field-label"> {{ $t('paiement.coupon_section.label_switch') }}</span>
                                    <input :disabled="hideCoupon" style="margin-top:5px" @change="openCoupon()" v-model="couponswitch" type="checkbox" id="switch_coupon_desktop">
                                    <span style="margin-top: 5px;" class="lever"></span>
                                    </label>
                                </div>
                              </div>
                            </div>
                            <div class="ml-5 row" v-if=showPopupCoupon>
                              <div class="col-sm-4">
                                <div class="field-group field-default">
                                  <label for="code_reduction_desktop" class="field-label">
                                    {{ $t('paiement.coupon_section.label_code_input') }}
                                  </label>
                                  <div class="input-group value-loan">
                                    <input :disabled="hideCoupon" v-model="codeReduction" id="code_reduction_desktop" name="codeReductionDesktop" class="field-input" />
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-4">
                                <div class="wizard-card-footer clearfix">
                                  <div class="wizard-footer-right">
                                    <button :disabled="hideCoupon" @click="checkReductionCom()" type="button" class="wizard-btn" style="margin-top:-10px">
                                      {{ $t('paiement.coupon_section.bouton_valider') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <!-- Affichage de la prime sans la réduction pour information aux utilisateur -->
                            <!-- <div data-v-0d43d413="" class="ml-5 field-title mb-0 row" v-show="shownTextReduction">
                              {{ $t('paiement.coupon_section.prime_avant_reduc_label_desktop') }} : <span v-if="prime_ttc_before_reduc != null" class="font-weight-bold ml-1" style="color: #ffa409">{{ prime_ttc_before_reduc.toLocaleString() }} FCFA</span>
                            </div> -->
  
                          </div>
                        </div>
                        <!-- Fin de la section html pour la reduction commercial appliquée sur le ttc du devis desktop ---
                        ---- Fin de la section html pour la reduction commercial appliquée sur le ttc du devis desktop -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            
            <div class="ml-2 row" v-show='showReduction'>  
              <div data-v-0d43d413="" class="field-title mb-0">{{ $t('paiement.coupon_section.label_reduction') }} :
                <span class="font-weight-bold ml-1" style="color: #ffa409">{{ reductionMount}}{{
                  typeReduction}}</span>
              </div>
            </div>
  
            <div class="ml-2 row" v-show="mode_livraison">
                <div data-v-0d43d413="" class="mr-3 field-title mb-0" v-show="showReduction">
                  {{ $t('paiement.coupon_section.prime_avant_reduc_label_desktop') }}
                  <!-- {{ $t('paiement.prime_ttc') }} : -->
                  <span class="font-weight-bold ml-1" style="color: #ffa409">{{
                    this.prime_ttc_before_reduc.toLocaleString()
                  }}
                    FCFA -</span>
                  </div>
                <div data-v-0d43d413="" class="field-title mb-0" v-show='mode_livraison'>{{$t('paiement.coupon_section.ttc_a_regler')}} :
                    <span class="font-weight-bold ml-1" style="color: #ffa409">{{
                      Devis_pour_souscription.prime_ttc.toLocaleString()}} FCFA</span>
                  </div> 
            </div>
  
            <div class="ml-2 row" v-show="mode_livraison">
              <div data-v-0d43d413="" class="field-title mb-0">
                {{ $t('paiement.frais_livraison') }} :
                  <span class="font-weight-bold ml-1" style="color: #ffa409">{{ fraisLiv }} FCFA</span>
                </div>
  
                <div data-v-0d43d413="" class="ml-3 field-title mb-0">
                - {{ $t('paiement.frais_paiement') }} :
                  <span class="font-weight-bold ml-1" style="color: #ffa409">{{ Math.ceil(fraisPaiement) }} FCFA</span>
                </div>
            </div>
  
            <div class="ml-2 row" v-show="mode_livraison">  
              <div data-v-0d43d413="" class="field-title font-weight-bold mb-0">{{ $t('paiement.total') }} :
                <span class="font-weight-bold ml-1" style="color: #5b94bc">{{ mention_ttc.toLocaleString() }}
                  FCFA</span>
              </div>
          </div>
  
  
  
              <div role="tabpanel" id="Besoins3" aria-labelledby="step-Besoins3" class="wizard-tab-container">
                <div data-v-0d43d413="">
                  <div data-v-0d43d413="" class="fields" v-show="mode_livraison">
                    <div class="wizard-card-footer clearfix mb-5">
                      <div class="wizard-footer-left"></div>
                      <div class="wizard-footer-right mr-5 mb-5"
                        v-if="$store.state.devispayement.devis.brancheid.branche == 'Caution'">
                        <!--Bouton de Paiement Avec les wallet dispo sur upay payement_end-->
                        <button type="button" class="wizard-btn"
                          v-show="mode_payement == 'kpay' || mode_payement == 'autre_paiement' || mode_payement == 'carte_bancaire' || mode_payement == 'mobile_money' || mode_payement == 'wave' || mode_payement == 'intouch' || mode_payement == 'free_money'"
                          @click="checkBranchCaution">
                          {{ $t('paiement.bouton_payer_label') }}
                        </button>
                      </div>
  
                      <div class="wizard-footer-right mr-5 mb-5"
                        v-if="$store.state.devispayement.devis.brancheid.branche != 'Caution'">
                        <!--Bouton de Paiement Avec les wallet dispo sur upay payement_end-->
                        <button type="button" class="wizard-btn" v-show="mode_payement == 'autre_paiement'"
                          @click="payement_start">
                          {{ $t('paiement.bouton_payer_label') }}
                        </button>
  
                        <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                        <button type="button" class="wizard-btn" v-show="mode_payement == 'carte_bancaire'"
                          @click="payment_Orabank">
                          {{ $t('paiement.bouton_payer_label') }}
                        </button>
  
                        <!--Bouton de Paiement Par OrangeMoney Assuraf-->
                        <button type="button" class="wizard-btn" v-show="mode_payement == 'mobile_money'"
                          @click="open_payment_om">
                          {{ $t('paiement.bouton_payer_label') }}
                        </button>
  
                        <!--Bouton de Paiement Par Wave Assuraf-->
                        <button type="button" class="wizard-btn" v-show="mode_payement == 'wave'"
                          @click="payement_wave_start">
                          {{ $t('paiement.bouton_payer_label') }}
                        </button>
                        <!--Bouton de Paiement par Freemoney -->
                        <button type="button" class="wizard-btn" v-show="mode_payement == 'intouch'"
                          @click="payement_intouch_start">
                          {{ $t('paiement.bouton_payer_label') }}
                        </button>
  
                        <button type="button" class="wizard-btn" v-show="mode_payement == 'free_money'"
                          @click="payment_free">
                          {{ $t('paiement.bouton_payer_label') }}
                        </button>
  
                        <button type="button" class="wizard-btn" v-show="mode_payement == 'kpay'"
                          @click="payement_kpay_start">
                          {{ $t('paiement.bouton_payer_label') }}
                        </button>
  
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
      <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
      <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
      <!-- ========================================================================================= -->
      <v-layout row wrap justify-content-center pb-3 v-if="isDesktop()">
        <v-dialog v-model="aStorMap" fullscreen hide-overlay transition="dialog-bottom-transition" v-if="isDesktop()">
          <v-card>
            <v-toolbar card color="#ffa409">
              <span class="font-weight-black title" style="color: #fff">
                <v-icon color="#fff">&#xe55b;</v-icon>
                <span style="font-weight: bold; font-size: 14px !important">{{ $t('paiement.plan_acces_label') }}</span>
              </span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="aStorMap = false" class="float-lg-right">
                <v-icon>&#xe5cd;</v-icon>
              </v-btn>
            </v-toolbar>
  
            <v-card-text>
              <v-layout xs10 pa-3 justify-content-center row>
                <v-flex>
                  <!-- <iframe class="border-radius" width="100%" height="708" id="gmap_canvas_desktop"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3859.139432012536!2d-17.47175488515856!3d14.704705889736221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec1737dc820ac35%3A0xb99e05077a517255!2sAssuraf!5e0!3m2!1sfr!2ssn!4v1629212832445!5m2!1sfr!2ssn"
                    frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe> -->
                    <iframe class="border-radius" width="100%" height="708" id="gmap_canvas_desktop" 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4522.398327249517!2d-17.4763790248918!3d14.70618763579277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec173f437570609%3A0x17368a6a5855dec7!2sLA%20POINTE!5e1!3m2!1sfr!2ssn!4v1743592125718!5m2!1sfr!2ssn" 
                    frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
  
      <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     ================= -->
      <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
      <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
      <!-- ========================================================================================= -->
      <v-container style="padding-right: 25px !important; padding-left: 25px !important" v-if="isMobile()">
        <!-- ============================================================ -->
        <v-dialog v-model="aStorMap" fullscreen hide-overlay transition="dialog-bottom-transition" v-if="isMobile()">
          <v-card>
            <v-toolbar card color="#ffa409">
              <span class="font-weight-black title" style="color: #fff">
                <v-icon color="#fff">&#xe55b;</v-icon>
                <span style="font-weight: bold; font-size: 14px !important">{{ $t('paiement.plan_acces_label') }}</span>
              </span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="aStorMap = false" class="float-lg-right">
                <v-icon>&#xe5cd;</v-icon>
              </v-btn>
            </v-toolbar>
  
            <v-card-text>
              <v-layout xs10 pa-3 justify-content-center row>
                <v-flex>
                  <!-- <iframe class="border-radius" width="100%" height="700" id="gmap_canvas"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3859.139432012536!2d-17.47175488515856!3d14.704705889736221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec1737dc820ac35%3A0xb99e05077a517255!2sAssuraf!5e0!3m2!1sfr!2ssn!4v1629212832445!5m2!1sfr!2ssn"
                    frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe> -->
                    <iframe class="border-radius" width="100%" height="700" id="gmap_canvas" 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4522.398327249517!2d-17.4763790248918!3d14.70618763579277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec173f437570609%3A0x17368a6a5855dec7!2sLA%20POINTE!5e1!3m2!1sfr!2ssn!4v1743592125718!5m2!1sfr!2ssn" 
                    frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
  
      <!-- popup pour scanner qrcode wave pour wave -->
      <!-- popup pour scanner qrcode wave pour wave -->
      <v-dialog v-model="wave_qr_code" max-width="1000" max-height="700" v-if="isDesktop()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="modalQrCodeWave" aria-hidden="true" aria-labelledby="step-modalQrCodeWave"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0 row">
                    <div class="fields col-sm-6">
                      <img width="80%" height="auto" class="rounded" src="../assets/img/logoPaiement/wave_qr_code.jpg"
                        alt="wave_qr_code" />
                    </div>
                    <div class="fields col-sm-6">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <label for="nom_prenom_qr_code_wave" class="font-weight-bold h6">Nom et prénom</label>
                          <v-text-field id="nom_prenom_qr_code_wave" v-model="wave_nom_prenom" disabled></v-text-field>
                        </v-col>
  
                        <v-col cols="12" sm="6">
                          <label for="telephone_qr_code_wave" class="font-weight-bold h6">Numéro de téléphone wave
                            (*)</label>
                          <v-text-field id="telephone_qr_code_wave" v-model="wave_phone"></v-text-field>
                        </v-col>
  
                        <v-col cols="12" sm="6">
                          <label for="cni_qr_code_wave" class="font-weight-bold h6">Numéro de carte d'identité</label>
                          <v-text-field id="cni_qr_code_wave" v-model="wave_idcard"></v-text-field>
                        </v-col>
  
                        <v-col cols="12" sm="6">
                          <label for="montant_qr_code_wave" class="font-weight-bold h6">Montant</label>
                          <v-text-field id="montant_qr_code_wave" v-model="wave_amount"></v-text-field>
                        </v-col>
  
                        <v-col cols="12" sm="6">
                          <label for="wave_qr_code_wave" class="font-weight-bold h6">Devise</label>
                          <v-text-field id="wave_qr_code_wave" v-model="wave_currency" disabled></v-text-field>
                        </v-col>
  
                        <v-col cols="12" sm="6" class="wizard-footer-right mr-5 mb-5">
                          <button type="button" style="margin-left:33%" class="
                              wizard-btn
                              border
                              pl-5
                              pr-5
                              pt-2
                              pb-2
                              rounded
                              warning
                              outline
                              text-white
                            ">
                            Payer
                          </button>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- popup pour scanner qrcode wave pour wave -->
      <!-- popup pour scanner qrcode wave pour wave -->
      <v-dialog v-model="wave_qr_code" max-width="auto" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="modalQrCodeWaveMobile" aria-hidden="true"
                aria-labelledby="step-modalQrCodeWaveMobile" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="row">
                        <img width="100%" src="../assets/img/logoPaiement/wave_qr_code.jpg" alt="wave_qr_code" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- pop pour remplissage informations passagers Mobile-->
      <v-dialog v-model="dialogAlert" persistent>
        <v-card>
          <v-toolbar>
            <v-toolbar-title>
              <span class="headline">{{ $t('paiement.popup_alert.title') }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogAlert = false" class="float-lg-right" style="background: #ffa409">
              <v-icon>&#xe5cd;</v-icon>
            </v-btn>
          </v-toolbar>
  
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="nom_passager" label="Nom" hint="Nom" required></v-text-field>
                </v-flex>
              </v-layout>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn round outline color="success" flat>{{ $t('paiement.popup_alert.bouton_ajouter_label') }}</v-btn>
                <v-btn round outline color="blue darken-1" flat @click="dialogAlert = false">{{
                  $t('paiement.popup_alert.bouton_annuler_label') }}</v-btn>
              </v-card-actions>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- ========= pop pour remplissage informations passagers Desktop ============ -->
      <!-- ========= pop pour remplissage informations passagers Desktop ============ -->
      <v-dialog v-model="dialogInfoPassager" persistent
        v-if="Devis_pour_souscription.brancheid.branche == 'Voyage' && isDesktop()" max-width="1000">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content" v-show="passportStep">
              <div role="tabpanel" id="infos_passager" aria-labelledby="step-infos_passager" class="wizard-tab-container">
                <div>
                  <div class="fields">
                    <div class="field-title">{{ $t('paiement.voyage.popup_passager.title') }}&nbsp;:</div>
                    <div class="field-group justify-content-center row flex-column flex-sm-row">
                      <div class="btn-choice btn-choice-icon sm-no-change">
                        <input v-model="myPassports" value="mes_passport" type="radio" id="my_passport"
                          @click="getListPassport()" name="Step1_mobile" class="field-input">
                        <label for="my_passport" class="flex-row flex-md-column field-label">
                          <img src="../assets/img/icones/passport.png" alt="mes passeports" class="mr-4 mr-md-0">
                          <p>{{ $t('paiement.voyage.popup_passager.mes_passeport') }}</p>
                        </label>
                      </div>
                      <div class="btn-choice btn-choice-icon sm-no-change ml-3">
                        <input v-model="myPassports" type="radio" value="nouveau" id="new_passport" name="Step1_mobile"
                          class="field-input" @change="myPassportValidator()">
                        <label for="new_passport" class="flex-row flex-md-column field-label">
                          <img src="../assets/img/icones/newpassport.png" alt="nouveau passeport" class="mr-4 mr-md-0">
                          <p>{{ $t('paiement.voyage.popup_passager.nouveau_passeport') }}</p>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="wizard-tab-content" v-show="myPassportList">
              <div role="tabpanel" id="liste_passport" aria-hidden="true" aria-labelledby="step-liste_passport"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('paiement.voyage.popup_passager.mes_passeport')
                      }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <v-flex class="col-sm-5 offset-7">
                            <div class="col-sm-12">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <input v-model="searchPassportDesktop"
                                  :placeholder="$t('paiement.voyage.popup_passager.search_label')" id="search_passager"
                                  name="Step8" class="field-input">
                              </div>
                            </div>
                          </v-flex>
  
                          <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                            <v-data-table :headers="headerContrat" :items="listPassports" :search="searchPassportDesktop"
                              class="border-radius mt-2 mb-5" style="background-color: #FAFAFA!important">
                              <template slot="items" slot-scope="props">
                                <td>{{ props.item.prenom_passager }}</td>
                                <td>{{ props.item.nom_passager }}</td>
                                <td>{{ props.item.nationalite_passager }}</td>
                                <td>{{ props.item.numero_ci_passager }}</td>
                                <td>{{ DateFormater(props.item.dateNaissance) }}</td>
                                <td>{{ DateFormater(props.item.date_delivrance) }}</td>
                                <td>{{ DateFormater(props.item.date_expiration) }}</td>
                                <td>
                                  <ul class="list-boutons">
                                    <li class="justify-content-center row">
                                      <v-btn small icon @click="getPassportForDevis(props.item)">
                                        <img src="../assets/img/devis/toDevis.png" alt="bouton pour devis" width="60">
                                      </v-btn>
                                      <v-btn small icon @click="deletePassport(props.item)">
                                        <img src="../assets/img/devis/delete.png" alt="supprimer passeport" width="60">
                                      </v-btn>
                                    </li>
                                  </ul>
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="wizard-tab-content" v-show="newPassport">
              <div role="tabpanel" id="new_passport_form" aria-hidden="true" aria-labelledby="step-new_passport_form"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title">{{ $t('paiement.voyage.popup_passager.nouveau_passeport_title') }}</div>
                      <div class="field-title">
                        <small style="color: red" v-if="this.dateNaissance != null">
                          * {{ $t('paiement.voyage.popup_passager.info_texte') }}
                        </small>
  
                      </div>
  
                      <div class="row">
                        <div class="col-sm-4 mt-1">
                          <label class="field-label">{{ $t('paiement.voyage.popup_passager.genre_label') }}</label>
                          <div class="col-sm-12 field-radio field-radio-center">
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Femme" id="infos_passager_sexe_femme"
                                name="sexe_passager" class="field-input">
                              <label for="infos_passager_sexe_femme" class="field-label btn-choice-hide-dot">
                                {{ $t('paiement.voyage.popup_passager.madame_label') }}</label>
                            </div>
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Homme" id="infos_passager_sexe_homme"
                                name="sexe_passager" class="field-input">
                              <label for="infos_passager_sexe_homme" class="field-label btn-choice-hide-dot">{{
                                $t('paiement.voyage.popup_passager.monsieur_label') }}</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="infos_passager_prenom" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.prenom_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="prenom_passager"
                                :placeholder="$t('paiement.voyage.popup_passager.prenom_placeholder')"
                                id="infos_passager_prenom" name="infosPassager" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_nom" class="field-label">{{
                              $t('paiement.voyage.popup_passager.nom_label') }}</label>
                            <input v-model="nom_passager"
                              :placeholder="$t('paiement.voyage.popup_passager.nom_placeholder')" id="infos_passager_nom"
                              name="infosPassager" class="field-input" />
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="infos_passager_telephone" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.telephone_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input :placeholder="$t('paiement.voyage.popup_passager.telephone_placeholder')"
                                @keypress="onlyNumber" v-model="num_passager" id="infos_passager_telephone"
                                name="infosPassager" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_nationalite" class="field-label">{{
                              $t('paiement.voyage.popup_passager.nationalite_label') }}</label>
                            <select id="infos_passager_nationalite" name="Step1" class="field-select"
                              v-model="nationalite_passager">
                              <option v-for="item in countries" :key="item" :value="item.PAYS">
                                {{ item.PAYS }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="infos_passager_datenaissance" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.date_naissance_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan" style="margin-top: -3px">
                              <date-picker v-if="this.dateNaissance != null"
                                :disabled-date="disabledBeforeTodayDateNaissance" class="field-input ml-2 mb-1 mt-1"
                                :placeholder="$t('paiement.voyage.popup_passager.date_naissance_placeholder')"
                                id="infos_passager_datenaissance" v-model="dateNaissance" valueType="format"
                                format="YYYY-MM-DD" lang="fr-fr" disabled></date-picker>
                              <date-picker v-else :disabled-date="disabledBeforeTodayDateNaissance"
                                class="field-input ml-2 mb-1 mt-1"
                                :placeholder="$t('paiement.voyage.popup_passager.date_naissance_placeholder')"
                                id="infos_passager_datenaissance" v-model="dateNaissance" valueType="format"
                                format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_numero_passport" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.numero_passeport_label') }}*
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="numero_ci_passager"
                                :placeholder="$t('paiement.voyage.popup_passager.numero_passeport_placeholder')"
                                id="infos_passager_numero_passport" name="infosPassager" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_date_delivrance" class="field-label">{{
                              $t('paiement.voyage.popup_passager.date_delivrance_label') }}</label>
                            <div class="input-group value-loan" style="margin-top: -3px">
                              <date-picker :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1"
                                :editable="false"
                                :placeholder="$t('paiement.voyage.popup_passager.date_naissance_placeholder')"
                                id="infos_passager_date_delivrance" v-model="date_delivrance" valueType="format"
                                format="YYYY-MM-DD" lang="fr-fr" @change="yearsDiffDateDelivre()"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_date_expiration" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.date_expiration_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan" style="margin-top: -3px">
                              <date-picker :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1 mt-1"
                                :editable="false"
                                :placeholder="$t('paiement.voyage.popup_passager.date_naissance_placeholder')"
                                id="infos_passager_date_expiration" v-model="date_expiration" valueType="format"
                                format="YYYY-MM-DD" lang="fr-fr" @change="yearsDiffDateExpire()"></date-picker>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="dialogInfoPassager = false" type="button" class="wizard-btn" v-show="passportStep">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.voyage.popup_passager.bouton_fermer_label') }}
                </button>
                <button @click="backToPassportStep()" type="button" class="wizard-btn" v-show="newPassport">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.voyage.popup_passager.bouton_retour_label') }}
                </button>
                <button @click="backToPassportStep()" type="button" class="wizard-btn" v-show="myPassportList">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.voyage.popup_passager.bouton_retour_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="Detail_info_passager()" type="button" class="wizard-btn" v-show="newPassport">
                  {{ $t('paiement.voyage.popup_passager.bouton_ajouter_label') }}
                </button>
              </div>
              <!---->
            </div>
  
            <div v-responsive.lg.xl class="mt-3">
              <div class="row" v-show="continue_btn">
                <div class="col-sm-12">
                  <table class="table table-simple text-center">
                    <thead class="bg-light">
                      <tr>
                        <th>{{ $t('paiement.voyage.popup_passager.genre_label') }}</th>
                        <th>{{ $t('paiement.voyage.popup_passager.prenom_label') }}</th>
                        <th>{{ $t('paiement.voyage.popup_passager.nom_label') }}</th>
                        <th>{{ $t('paiement.voyage.popup_passager.telephone_label') }}</th>
                        <th>{{ $t('paiement.voyage.popup_passager.nationalite_label') }}</th>
                        <th>{{ $t('paiement.voyage.popup_passager.date_naissance_label') }}</th>
                        <th>{{ $t('paiement.voyage.popup_passager.numero_passeport_label') }}</th>
                        <th>{{ $t('paiement.voyage.popup_passager.date_delivrance_label') }}</th>
                        <th>{{ $t('paiement.voyage.popup_passager.date_expiration_label') }}</th>
                      </tr>
                    </thead>
  
                    <tbody v-for="item in tableau_info_passager" :key="item.numero_ci_passager">
                      <tr>
                        <td class="border">{{ item.genre }}</td>
                        <td class="border">{{ item.prenom_passager }}</td>
                        <td class="border">{{ item.nom_passager }}</td>
                        <td class="border">{{ item.num_passager }}</td>
                        <td class="border">{{ item.nationalite_passager }}</td>
                        <td class="border">{{ item.dateNaissance }}</td>
                        <td class="border">{{ item.numero_ci_passager }}</td>
                        <td class="border">{{ item.date_delivrance }}</td>
                        <td class="border">{{ item.date_expiration }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
  
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left"></div>
              <div class="wizard-footer-right" v-show="continue_btn">
                <button @click="ManipPaiement()" type="button" class="wizard-btn">
                  {{ $t('paiement.voyage.popup_passager.bouton_continuer_label') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- ========= pop pour remplissage informations passagers Desktop ============ -->
      <!-- ========= pop pour remplissage informations passagers Desktop ============ -->
      <v-dialog v-model="dialogInfoPassager" persistent
        v-if="Devis_pour_souscription.brancheid.branche == 'Voyage' && isMobile()" max-width="1000">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content" v-show="passportStep">
              <div role="tabpanel" id="infos_passager_mobile" aria-labelledby="step-infos_passager_mobile"
                class="wizard-tab-container">
                <div>
                  <div class="fields">
                    <div class="field-title">{{ $t('paiement.voyage.popup_passager.title') }}&nbsp;:</div>
                    <div class="field-group justify-content-center row flex-column flex-sm-row">
                      <div class="btn-choice btn-choice-icon sm-no-change">
                        <input v-model="myPassports" value="mes_passport" type="radio" id="my_passport_mobile"
                          name="Step1_mobile" @click="getListPassport" class="field-input">
                        <label for="my_passport_mobile" class="flex-row flex-md-column field-label">
                          <img src="../assets/img/icones/passport.png" alt="mes passeports" class="mr-4 mr-md-0">
                          <p>{{ $t('paiement.voyage.popup_passager.mes_passeport') }}</p>
                        </label>
                      </div>
                      <div class="btn-choice btn-choice-icon sm-no-change">
                        <input v-model="myPassports" type="radio" value="nouveau" id="new_passport_mobile"
                          name="Step1_mobile" class="field-input" @change="myPassportValidator()">
                        <label for="new_passport_mobile" class="flex-row flex-md-column field-label">
                          <img src="../assets/img/icones/newpassport.png" alt="nouveau passeport" class="mr-4 mr-md-0">
                          <p>{{ $t('paiement.voyage.popup_passager.nouveau_passeport') }}</p>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="wizard-tab-content" v-show="myPassportList">
              <div role="tabpanel" id="liste_passport_mobile" aria-hidden="true"
                aria-labelledby="step-liste_passport_mobile" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('paiement.voyage.popup_passager.mes_passeport')
                      }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="col-sm-12">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <input v-model="searchPassportDesktop"
                                :placeholder="$t('paiement.voyage.popup_passager.search_label')" id="search_passager_mobile"
                                name="Step8" class="field-input">
                            </div>
                          </div>
  
                          <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                            <v-data-table :headers="headerContratMobile" :items="listPassports"
                              :search="searchPassportDesktop" class="border-radius mt-2 mb-5"
                              style="background-color: #FAFAFA!important">
                              <template slot="items" slot-scope="props">
                                <td @click="getPassportForDevis(props.item)">{{ props.item.prenom_passager }}</td>
                                <td @click="getPassportForDevis(props.item)">{{ props.item.nom_passager }}</td>
                                <td @click="getPassportForDevis(props.item)">{{ props.item.numero_ci_passager }}</td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="wizard-tab-content" v-show="newPassport">
              <div role="tabpanel" id="new_passport_form_mobile" aria-hidden="true"
                aria-labelledby="step-new_passport_form_mobile" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title">{{ $t('paiement.voyage.popup_passager.nouveau_passeport_title') }}</div>
                      <div class="field-title">
                        <small style="color: red" v-if="this.dateNaissance != null">
                          * {{ $t('paiement.voyage.popup_passager.info_texte') }}
                        </small>
                      </div>
  
                      <div class="row">
                        <div class="col-sm-4">
                          <label class="mb-1 field-label">{{ $t('paiement.voyage.popup_passager.genre_label') }}</label>
                          <div class="mb-4 mb-sm-0 col-sm-12 field-radio field-radio-center">
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Femme" id="infos_passager_sexe_femme_mobile"
                                name="modalite" class="field-input">
                              <label for="infos_passager_sexe_femme_mobile" class="field-label btn-choice-hide-dot">
                                {{ $t('paiement.voyage.popup_passager.madame_label') }}</label>
                            </div>
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Homme" id="infos_passager_sexe_homme_mobile"
                                name="modalite" class="field-input">
                              <label for="infos_passager_sexe_homme_mobile" class="field-label btn-choice-hide-dot">{{
                                $t('paiement.voyage.popup_passager.monsieur_label') }}</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_prenom_mobile" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.prenom_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="prenom_passager"
                                :placeholder="$t('paiement.voyage.popup_passager.prenom_placeholder')"
                                id="infos_passager_prenom_mobile" name="infosPassager_mobile" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_nom_mobile" class="field-label">{{
                              $t('paiement.voyage.popup_passager.nom_label') }}</label>
                            <input v-model="nom_passager"
                              :placeholder="$t('paiement.voyage.popup_passager.nom_placeholder')"
                              id="infos_passager_nom_mobile" name="infosPassager_mobile" class="field-input" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_telephone_mobile" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.telephone_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input :placeholder="$t('paiement.voyage.popup_passager.telephone_placeholder')"
                                @keypress="onlyNumber" v-model="num_passager" id="infos_passager_telephone_mobile"
                                name="infosPassager_mobile" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_nationalite_mobile" class="field-label">{{
                              $t('paiement.voyage.popup_passager.nationalite_label') }}</label>
                            <select id="infos_passager_nationalite_mobile" name="Step1" class="field-select"
                              v-model="nationalite_passager">
                              <option v-for="item in countries" :key="item" :value="item.PAYS">
                                {{ item.PAYS }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_datenaissance_mobile" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.date_naissance_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan" style="margin-top: -3px">
                              <date-picker v-if="this.dateNaissance != null"
                                :disabled-date="disabledBeforeTodayDateNaissance" class="field-input ml-2 mb-1 mt-1"
                                :placeholder="$t('paiement.voyage.popup_passager.date_naissance_placeholder')"
                                id="infos_passager_datenaissance_mobile" v-model="dateNaissance" valueType="format"
                                format="YYYY-MM-DD" lang="fr-fr" disabled></date-picker>
                              <date-picker v-else :disabled-date="disabledBeforeTodayDateNaissance"
                                class="field-input ml-2 mb-1 mt-1"
                                :placeholder="$t('paiement.voyage.popup_passager.date_naissance_placeholder')"
                                id="infos_passager_datenaissance_mobile" v-model="dateNaissance" valueType="format"
                                format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_numero_passport_mobile" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.numero_passeport_label') }}*
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="numero_ci_passager"
                                :placeholder="$t('paiement.voyage.popup_passager.numero_passeport_placeholder')"
                                id="infos_passager_numero_passport_mobile" name="infosPassager_mobile"
                                class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_date_delivrance_mobile" class="field-label">{{
                              $t('paiement.voyage.popup_passager.date_delivrance_label') }}</label>
                            <div class="input-group value-loan" style="margin-top: -3px">
                              <date-picker :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1"
                                :editable="false"
                                :placeholder="$t('paiement.voyage.popup_passager.date_naissance_placeholder')"
                                id="infos_passager_date_delivrance_mobile" v-model="date_delivrance" valueType="format"
                                format="YYYY-MM-DD" lang="fr-fr" @change="yearsDiffDateDelivre()"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="infos_passager_date_expiration_mobile" class="field-label">
                              {{ $t('paiement.voyage.popup_passager.date_expiration_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan" style="margin-top: -3px">
                              <date-picker :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1 mt-1"
                                :editable="false"
                                :placeholder="$t('paiement.voyage.popup_passager.date_naissance_placeholder')"
                                id="infos_passager_date_expiration_mobile" v-model="date_expiration" valueType="format"
                                format="YYYY-MM-DD" lang="fr-fr" @change="yearsDiffDateExpire()"></date-picker>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="dialogInfoPassager = false" type="button" class="wizard-btn" v-show="passportStep">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.voyage.popup_passager.bouton_fermer_label') }}
                </button>
                <button @click="backToPassportStep()" type="button" class="wizard-btn" v-show="newPassport">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.voyage.popup_passager.bouton_retour_label') }}
                </button>
                <button @click="backToPassportStep()" type="button" class="wizard-btn" v-show="myPassportList">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.voyage.popup_passager.bouton_retour_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button v-show="newPassport" @click="Detail_info_passager()" type="button" class="wizard-btn">
                  {{ $t('paiement.voyage.popup_passager.bouton_ajouter_label') }}
                </button>
              </div>
              <!---->
            </div>
  
            <div v-responsive.sm.xs class="mt-5">
              <div class="row" v-show="continue_btn">
                <div class="col-sm-12">
                  <table class="table table-simple text-center">
                    <thead class="bg-light policeLato">
                      <tr>
                        <th>{{ $t('paiement.voyage.popup_passager.prenom_label') }}</th>
                        <th>{{ $t('paiement.voyage.popup_passager.nom_label') }}</th>
                      </tr>
                    </thead>
  
                    <tbody v-for="item in tableau_info_passager" :key="item.prenom_passager">
                      <tr style="background: #fff">
                        <td class="border">{{ item.prenom_passager }}</td>
                        <td class="border">{{ item.nom_passager }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
  
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left"></div>
              <div class="wizard-footer-right" v-show="continue_btn">
                <button @click="ManipPaiement()" type="button" class="wizard-btn">
                  {{ $t('paiement.voyage.popup_passager.bouton_continuer_label') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
  
      <!-- ========= pop pour remplissage fichiers caution Desktop ============ -->
      <!-- ========= pop pour remplissage fichiers caution Desktop ============ -->
      <v-dialog v-model="dialogFileCaution" persistent
        v-if="Devis_pour_souscription.brancheid.branche == 'Caution' && isDesktop()" max-width="1000">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="fileCaution" aria-hidden="true" aria-labelledby="step-fileCaution"
                class="wizard-tab-container">
                <div>
                  <div class="fields">
                    <p id="size"></p>
                    <div class="field-title font-weight-bold">{{ $t('paiement.sante.popup_file_caution.title') }}</div>
                    <div class="field-title">
                      <small style="color: red">
                        * {{ $t('paiement.sante.popup_file_caution.format_text[0]') }} <br>
                        * {{ $t('paiement.sante.popup_file_caution.format_text[1]') }}
                      </small>
                    </div>
                    <div class="mt-4 row">
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.ninea')">
                                <input id="nineaFile" @change="fileNineaValidation" name="file-upload-field" type="file"
                                  ref="Ninea" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
  
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.rc')">
                                <input id="fileRc" @change="fileRcValidation" name="file-upload-field" type="file" ref="Rc"
                                  class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
  
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.dao')">
                                <input id="fileDao" @change="fileDaoValidation" name="file-upload-field" type="file"
                                  ref="Dao" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <div class="mt-5 row">
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.cni')">
                                <input id="fileCni" @change="fileCniValidation" name="file-upload-field" type="file"
                                  ref="Cni" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper"
                                :data-text="$t('paiement.sante.popup_file_caution.lettre_type')">
                                <input id="fileLettre" @change="fileLettreValidation" name="file-upload-field" type="file"
                                  ref="LettreType" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper"
                                :data-text="$t('paiement.sante.popup_file_caution.reference')">
                                <input id="fileRef" @change="fileRefValidation" name="file-upload-field" type="file"
                                  ref="Reference" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <div class="mt-5 row">
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.statut')">
                                <input id="fileStatut" @change="fileStatusValidation" name="file-upload-field" type="file"
                                  ref="Statut" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="goToHome()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.sante.popup_file_caution.bouton_annuler_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="updatePaiementCaution()" type="button" class="wizard-btn">
                  {{ $t('paiement.sante.popup_file_caution.bouton_ajouter_label') }}
                </button>
              </div>
              <!---->
            </div>
  
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- ========= pop pour remplissage fichiers caution Mobile ============ -->
      <!-- ========= pop pour remplissage fichiers caution Mobile ============ -->
      <v-dialog v-model="dialogFileCaution" persistent
        v-if="Devis_pour_souscription.brancheid.branche == 'Caution' && isMobile()" max-width="1000">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="fileCautionMobile" aria-hidden="true" aria-labelledby="step-fileCautionMobile"
                class="wizard-tab-container">
                <div>
                  <div class="fields">
                    <p id="sizeMobile"></p>
                    <div class="field-title font-weight-bold">{{ $t('paiement.sante.popup_file_caution.title') }}</div>
                    <div class="field-title">
                      <small style="color: red">
                        * {{ $t('paiement.sante.popup_file_caution.format_text[0]') }} <br>
                        * {{ $t('paiement.sante.popup_file_caution.format_text[1]') }}
                      </small>
                    </div>
                    <div class="mt-4 row">
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.ninea')">
                                <input id="nineaFileMobile" @change="fileNineaValidation" name="file-upload-field"
                                  type="file" ref="Ninea" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
  
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.rc')">
                                <input id="fileRcMobile" @change="fileRcValidation" name="file-upload-field" type="file"
                                  ref="Rc" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
  
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.dao')">
                                <input id="fileDaoMobile" @change="fileDaoValidation" name="file-upload-field" type="file"
                                  ref="Dao" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
  
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.cni')">
                                <input id="fileCniMobile" @change="fileCniValidation" name="file-upload-field" type="file"
                                  ref="Cni" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
  
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper"
                                :data-text="$t('paiement.sante.popup_file_caution.lettre_type')">
                                <input id="fileLettreMobile" @change="fileLettreValidation" name="file-upload-field"
                                  type="file" ref="LettreType" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
  
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper"
                                :data-text="$t('paiement.sante.popup_file_caution.reference')">
                                <input id="fileRefMobile" @change="fileRefValidation" name="file-upload-field" type="file"
                                  ref="Reference" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
  
                      <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <div class="container_forma">
                            <form class="formm">
                              <div class="file-upload-wrapper" :data-text="$t('paiement.sante.popup_file_caution.statut')">
                                <input id="fileStatutMobile" @change="fileStatusValidation" name="file-upload-field"
                                  type="file" ref="Statut" class="file-upload-field">
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="goToHome()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.sante.popup_file_caution.bouton_annuler_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="updatePaiementCaution()" type="button" class="wizard-btn">
                  {{ $t('paiement.sante.popup_file_caution.bouton_ajouter_label') }}
                </button>
              </div>
              <!---->
            </div>
  
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- popup pour demande d'assistance -->
      <!-- popup pour demande d'assistance -->
      <v-dialog v-model="assistanceDialog" persistent max-width="1000">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosAssistance" aria-hidden="true" aria-labelledby="step-infosAssistance"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('list_devis.assistance_form.assistance_title') }}
                      </div>
  
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="HoraireRappel" class="field-label">{{
                              $t('list_devis.assistance_form.horaire_rappel_label') }}</label>
                            <select id="HoraireRappel" name="infosAssis" class="field-select" v-model="horaire">
                              <option v-for="(itm, index) in itema" :key="index" :value="itm">
                                {{ itm }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="CanalRappel" class="field-label">{{
                              $t('list_devis.assistance_form.canal_rappel_label') }}</label>
                            <select id="CanalRappel" name="infosAssis" class="field-select" v-model="canal">
                              <option v-for="(itm, index) in rappel" :key="index" :value="itm">
                                {{ itm }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="nom" class="field-label">{{ $t('list_devis.assistance_form.nom_label') }}</label>
                            <input v-model="name" :placeholder="$t('list_devis.assistance_form.nom_placeholder')" id="nom"
                              name="infosAssis" class="field-input" />
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="num" class="field-label">
                              {{ $t('list_devis.assistance_form.telephone_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input :placeholder="$t('list_devis.assistance_form.telephone_placeholder')"
                                @keypress="onlyNumber" v-model="tel" id="num" name="infosAssis" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="Object" class="field-label">
                              {{ $t('list_devis.assistance_form.objet_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input :placeholder="$t('list_devis.assistance_form.objet_placeholder')" v-model="objetRappel"
                                id="Object" name="infosAssis" readonly class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="Remarque" class="field-label">
                              {{ $t('list_devis.assistance_form.remarque_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <textarea rows="4" cols="50"
                                :placeholder="$t('list_devis.assistance_form.remarque_placeholder')" v-model="remarques"
                                id="Remarque" name="infosAssis" class="field-input"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="assistanceDialog = false" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('list_devis.assistance_form.bouton_fermer_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="AddAssistance()" type="button" class="wizard-btn">
                  {{ $t('list_devis.assistance_form.bouton_valider_label') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- Modal loader start-->
       <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('paiement.sante.popup_file_generator.title') }}</span>
    </div>

      <!-- <div class="text-xs-center">
        <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
          <v-card color="orange" dark>
            <v-card-text>{{ $t('paiement.sante.popup_file_generator.title') }}
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div> -->
  
      <!--========= Popup FreeMoney ==========-->
      <v-dialog v-model="freepayment" max-width="1000" v-if="isDesktop()" persistent>
        <div class="containerP scroll" style="min-width: 1000px; width: auto">
          <div class="icing">
            <h3>{{ this.description }}</h3>
            <ul class="order" style>
              <li>
                <span class="item-name" style="font-size: 12px">1 - {{
                  $t('paiement.sante.popup_free_money_paiement.info_numero') }}</span>
              </li>
              <br />
  
              <li>
                <span class="item-name" style="font-size: 12px">2 - {{
                  $t('paiement.sante.popup_free_money_paiement.info_diall') }}</span>
              </li>
              <br />
  
              <li>
                <span class="item-name" style="font-size: 12px">3 - {{
                  $t('paiement.sante.popup_free_money_paiement.info_paiement') }}<br /></span>
              </li>
            </ul>
  
            <div style="margin-top: -10px">
              <p>{{ $t('paiement.sante.popup_free_money_paiement.net_a_payer') }}</p>
            </div>
  
            <div class="total" style="font-size: 25px; margin-top: -10px">
              {{ mention_ttc.toLocaleString() }}
              <small>XOF</small>
            </div>
          </div>
  
          <div class="dough">
            <div class="col">
              <div>
                <h2>
                  {{ $t('paiement.sante.popup_free_money_paiement.payer_par') }}
                  <span><img src="../assets/img/freemoney.png" alt="free-money-logo" width="25%" /></span>
                </h2>
              </div>
            </div>
  
            <div class="inputs">
              <div class="row"></div>
              <div class="justify-content-center row rowFree mt-3">
                <v-flex md5 class="justify-content-center rowFree">
                  <div class="column card-group">
                    <div>
                      <label class="label">{{ $t('paiement.sante.popup_free_money_paiement.nom_label') }}</label>
                      <input class="text-input name-input" name="nom" :placeholder="placeholdernom" disabled />
                    </div>
                  </div>
                </v-flex>
  
                <v-flex md5 class="ml-5 justify-content-center rowFree">
                  <div class="column card-group">
                    <div>
                      <label class="label">{{ $t('paiement.sante.popup_free_money_paiement.prenom_label') }}</label>
                    </div>
                    <div>
                      <input class="text-input name-input" name="prenom" :placeholder="placeholderprenom" disabled />
                    </div>
                  </div>
                </v-flex>
              </div>
  
              <div class="row" style="margin-left: 30px">
                <v-flex md11 class="justify-content-center row rowFree">
                  <div class="column name-group">
                    <label class="label" for="telephone">{{ $t('paiement.sante.popup_free_money_paiement.telephone_label')
                    }}</label>
                    <input class="text-input card-input" name="phone" v-model="numTelephone" />
                  </div>
                </v-flex>
              </div>
  
              <div class="justify-center row mt-3"></div>
            </div>
  
            <div class="justify-center row mt-3">
              <rotate-loader v-show="snipperfree" :loading="loading" :color="color" :size="size"></rotate-loader>
            </div>
  
            <div class="justify-center rowFree mt-3" v-show="!snipperfree">
              <v-flex md7 class="ml-3 justify-content-center rowFree">
                <div class="column card-group">
                  <button class="order-button" @click="Gopayment_free">
                    {{ $t('paiement.sante.popup_free_money_paiement.bouton_confirme_label') }}
                  </button>
                </div>
              </v-flex>
  
              <v-flex md4 class="ml-4 justify-content-center rowFree">
                <button class="order-button" @click="cancelFree()">
                  {{ $t('paiement.sante.popup_free_money_paiement.bouton_annuler_label') }}
                </button>
              </v-flex>
            </div>
            <small style="color:red" v-show="snipperfree">
              (*) Vous disposez d'une minute pour effectuer votre règlement via USSD #150#
            </small>
          </div>
        </div>
      </v-dialog>
  
      <v-dialog v-model="freepayment" max-width="500" v-if="isMobile()">
        <v-card class="border-radius" color="white">
          <v-container>
            <v-layout class="column">
              <v-flex class="justify-content-center row ml-1 mt-3">
                <h2 class="justify-content-center row" style="font-size: 18px">
                  {{ $t('paiement.sante.popup_free_money_paiement.payer_par') }}
                  <img src="../assets/img/freemoney.png" alt="free-money-logo" width="20%" style="margin-top: -10px" />
                </h2>
              </v-flex>
  
              <v-flex class="mr-3">
                <ul class="font-weight-bold text-center" style="font-size: 12px">
                  <li>
                    1 - {{ $t('paiement.sante.popup_free_money_paiement.info_numero') }}
                  </li>
                  <li>
                    2 - {{ $t('paiement.sante.popup_free_money_paiement.info_diall_mobile') }}
                  </li>
                  <li>3 - {{ $t('paiement.sante.popup_free_money_paiement.info_paiement_mobile') }}</li>
                </ul>
              </v-flex>
  
              <div class="inputs">
                <v-layout class="ml-2 mr-3 row">
                  <v-flex md4 class="ml-4 justify-content-center row rowFreeMobile">
                    <div class="column card-group">
                      <div>
                        <label class="label">{{ $t('paiement.sante.popup_free_money_paiement.nom_label') }}</label>
                        <input class="text-input name-input" name="nom" :placeholder="placeholdernom" disabled />
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
  
                <v-layout class="ml-2 mr-3 row">
                  <v-flex md3 class="ml-4 justify-content-center row rowFreeMobile">
                    <div class="column card-group">
                      <div>
                        <label class="label">{{ $t('paiement.sante.popup_free_money_paiement.prenom_label') }}</label>
                        <input class="text-input name-input" name="prenom" :placeholder="placeholderprenom" disabled />
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
  
                <v-layout class="ml-2 mr-3 row">
                  <v-flex class="ml-4 justify-content-center row rowFreeMobile">
                    <div class="column name-group">
                      <label class="label" for="telephone">{{ $t('paiement.sante.popup_free_money_paiement.telephone_Label')
                      }}</label>
                      <input class="text-input card-input" name="phone" v-model="numTelephone" />
                    </div>
                  </v-flex>
                </v-layout>
  
                <div class="justify-center row mt-3">
                  <rotate-loader v-show="snipperfree" :loading="loading" :color="color" :size="size"></rotate-loader>
                </div>
              </div>
  
              <v-layout class="justify-content-center row ml-1 mr-1 mt-1 mb-3">
                <v-flex class="justify-content-center row">
                  <div class="card-group">
                    <button class="highlight buttonFRMobile" @click="Gopayment_free">
                      {{ $t('paiement.sante.popup_free_money_paiement.bouton_confirme_label') }}
                    </button>
                  </div>
                </v-flex>
  
                <v-flex class="justify-content-center row">
                  <div class="card-group">
                    <button class="order-button" @click="cancelFree()">
                      {{ $t('paiement.sante.popup_free_money_paiement.bouton_annuler_label') }}
                    </button>
                  </div>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
      <!--=================================== -->
  
      <!--===== Popup adresse livraison ===== -->
      <v-dialog v-model="Popupadresse" persistent max-width="500" v-if="isDesktop()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('paiement.sante.popup_livraison.title') }}</div>
                      <v-container>
                        <v-layout class="justify-content-center">
                          <p class="mr-5 mt-2 font-weight-bold policeLato">{{
                            $t('paiement.sante.popup_livraison.tarif_normal') }}</p>
                          <p class="mt-2 font-weight-bold policeLato" style="margin-left: -1% !important">
                            {{ $t('paiement.sante.popup_livraison.tarif_express') }}
                          </p>
                        </v-layout>
  
                        <v-layout class="justify-content-center">
                          <v-flex class="justify-content-center container">
                            <form class="form cf">
                              <v-flex class="justify-content-center row pt-4" style="margin-top: 50px">
                                <section class="ml-2 justify-conten-center row plan cf">
                                  <v-tooltip top class="ml-4 policeLato elevation-24">
                                    <template v-slot:activator="{ on }">
                                      <input type="radio" name="radio1" id="dakar_normal" value="dakar_normal"
                                        v-model="prix_livraison" @change="showListCity" />
                                      <label v-on="on" class="free-label" for="dakar_normal"
                                        style="padding-top: 30px; white-space: pre-wrap">Dakar
                                        <span class="font-weight-bold">1500 FCFA</span>
                                      </label>
                                    </template>
                                    <span>
                                      <strong class="font-weight-bold">{{
                                        $t('paiement.sante.popup_livraison.livraison_dakar_content[0]') }}<br />{{
      $t('paiement.sante.popup_livraison.livraison_dakar_content[1]') }}<br />{{
      $t('paiement.sante.popup_livraison.livraison_dakar_content[2]') }}</strong>
                                    </span>
                                  </v-tooltip>
  
                                  <v-tooltip top class="elevation-24">
                                    <template v-slot:activator="{ on }">
                                      <input :disabled="disable" type="radio" name="radio1" id="dakar_express"
                                        value="dakar_express" v-model="prix_livraison" @change="showListCity" />
                                      <label v-on="on" class="basic-label col" for="dakar_express"
                                        style="padding-top: 30px; white-space: pre-wrap">Dakar
                                        <span class="font-weight-bold">2000 FCFA</span>
                                      </label>
                                    </template>
                                    <span>
                                      <strong class="font-weight-bold">{{
                                        $t('paiement.sante.popup_livraison.livraison_dakar_content[3]') }}<br />
                                        {{ $t('paiement.sante.popup_livraison.livraison_dakar_content[4]') }}</strong>
                                    </span>
                                  </v-tooltip>
                                </section>
                              </v-flex>
  
                              <v-flex class="justify-content-center row pt-4">
                                <section class="ml-2 justify-conten-center row row plan cf">
                                  <v-tooltip bottom class="ml-4 elevation-24">
                                    <template v-slot:activator="{ on }">
                                      <input type="radio" name="radio1" id="banlieue_normal" value="banlieue_normal"
                                        v-model="prix_livraison" @change="showListCity" />
                                      <label v-on="on" class="premium-label col" for="banlieue_normal"
                                        style="padding-top: 30px; white-space: pre-wrap">{{
                                          $t('paiement.sante.popup_livraison.banlieue') }}
                                        <span class="font-weight-bold">2000 FCFA</span>
                                      </label>
                                    </template>
                                    <span>
                                      <strong class="font-weight-bold">{{
                                        $t('paiement.sante.popup_livraison.livraison_banlieue_content[0]') }}</strong>
                                    </span>
                                  </v-tooltip>
  
                                  <v-tooltip bottom class="elevation-24">
                                    <template v-slot:activator="{ on }">
                                      <input :disabled="disable" type="radio" name="radio1" id="banlieue_express"
                                        value="banlieue_express" v-model="prix_livraison" @change="showListCity" />
                                      <label v-on="on" class="optimium-label col" for="banlieue_express"
                                        style="padding-top: 30px; white-space: pre-wrap">{{
                                          $t('paiement.sante.popup_livraison.banlieue') }}
                                        <span class="span font-weight-bold">2500 FCFA</span>
                                      </label>
                                    </template>
                                    <span>
                                      <strong class="font-weight-bold">{{
                                        $t('paiement.sante.popup_livraison.livraison_banlieue_content[1]') }}<br />
                                        {{ $t('paiement.sante.popup_livraison.livraison_banlieue_content[2]') }}</strong>
                                    </span>
                                  </v-tooltip>
                                </section>
                              </v-flex>
                            </form>
                          </v-flex>
                        </v-layout>
  
                        <v-layout class="justify-content-center">
                          <v-flex class="ml-5 mr-5" style="z-index:10000">
                            <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier"
                              :label="$t('paiement.sante.popup_livraison.ville_input_label')" editable item-text="quartier"
                              item-value="quartier" color="#59595b"></v-overflow-btn>
                          </v-flex>
                        </v-layout>
  
                        <v-layout class="justify-content-center">
                          <v-flex>
                            <v-text-field class="ml-5 mr-5" prepend-inner-icon="map"
                              :label="$t('paiement.sante.popup_livraison.adresse_input_label')"
                              v-model="adresselivraison"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="cancelPaiement()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.sante.popup_livraison.bouton_annuler_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="getAdressLivraison()" type="button" class="wizard-btn">
                  {{ $t('paiement.sante.popup_livraison.bouton_valider_label') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <v-dialog v-model="Popupadresse" persistent max-width="500" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('paiement.sante.popup_livraison.title') }}</div>
                      <v-container>
                        <v-layout class="justify-content-center">
                          <p class="mr-5 mt-2 font-weight-bold policeLato">{{
                            $t('paiement.sante.popup_livraison.tarif_normal') }}</p>
                          <p class="mt-2 font-weight-bold policeLato" style="margin-left: -1% !important">
                            {{ $t('paiement.sante.popup_livraison.tarif_express') }}
                          </p>
                        </v-layout>
  
                        <v-layout class="justify-content-center">
                          <v-flex class="justify-content-center container">
                            <form class="form cf">
                              <v-flex class="justify-content-center row pt-4" style="margin-top: 50px">
                                <section class="ml-2 justify-conten-center row plan cf">
                                  <v-tooltip top class="ml-4 policeLato elevation-24">
                                    <template v-slot:activator="{ on }">
                                      <input type="radio" name="radio1" id="dakar_normal" value="dakar_normal"
                                        v-model="prix_livraison" @change="showListCity" />
                                      <label v-on="on" class="free-label" for="dakar_normal"
                                        style="padding-top: 30px; white-space: pre-wrap">Dakar
                                        <span class="font-weight-bold">1500 FCFA</span>
                                      </label>
                                    </template>
                                    <span>
                                      <strong class="font-weight-bold">{{
                                        $t('paiement.sante.popup_livraison.livraison_dakar_content[0]') }}<br />{{
      $t('paiement.sante.popup_livraison.livraison_dakar_content[1]') }}<br />{{
      $t('paiement.sante.popup_livraison.livraison_dakar_content[2]') }}</strong>
                                    </span>
                                  </v-tooltip>
  
                                  <v-tooltip top class="elevation-24">
                                    <template v-slot:activator="{ on }">
                                      <input :disabled="disable" type="radio" name="radio1" id="dakar_express"
                                        value="dakar_express" v-model="prix_livraison" @change="showListCity" />
                                      <label v-on="on" class="basic-label col" for="dakar_express"
                                        style="padding-top: 30px; white-space: pre-wrap">Dakar
                                        <span class="font-weight-bold">2000 FCFA</span>
                                      </label>
                                    </template>
                                    <span>
                                      <strong class="font-weight-bold">{{
                                        $t('paiement.sante.popup_livraison.livraison_dakar_content[3]') }}<br />
                                        {{ $t('paiement.sante.popup_livraison.livraison_dakar_content[4]') }}</strong>
                                    </span>
                                  </v-tooltip>
                                </section>
                              </v-flex>
  
                              <v-flex class="justify-content-center row pt-4">
                                <section class="ml-2 justify-conten-center row row plan cf">
                                  <v-tooltip bottom class="ml-4 elevation-24">
                                    <template v-slot:activator="{ on }">
                                      <input type="radio" name="radio1" id="banlieue_normal" value="banlieue_normal"
                                        v-model="prix_livraison" @change="showListCity" />
                                      <label v-on="on" class="premium-label col" for="banlieue_normal"
                                        style="padding-top: 30px; white-space: pre-wrap">{{
                                          $t('paiement.sante.popup_livraison.banlieue') }}
                                        <span class="font-weight-bold">2000 FCFA</span>
                                      </label>
                                    </template>
                                    <span>
                                      <strong class="font-weight-bold">{{
                                        $t('paiement.sante.popup_livraison.livraison_banlieue_content[0]') }}</strong>
                                    </span>
                                  </v-tooltip>
  
                                  <v-tooltip bottom class="elevation-24">
                                    <template v-slot:activator="{ on }">
                                      <input :disabled="disable" type="radio" name="radio1" id="banlieue_express"
                                        value="banlieue_express" v-model="prix_livraison" @change="showListCity" />
                                      <label v-on="on" class="optimium-label col" for="banlieue_express"
                                        style="padding-top: 30px; white-space: pre-wrap">{{
                                          $t('paiement.sante.popup_livraison.banlieue') }}
                                        <span class="span font-weight-bold">2500 FCFA</span>
                                      </label>
                                    </template>
                                    <span>
                                      <strong class="font-weight-bold">{{
                                        $t('paiement.sante.popup_livraison.livraison_banlieue_content[1]') }}<br />
                                        {{ $t('paiement.sante.popup_livraison.livraison_banlieue_content[2]') }}</strong>
                                    </span>
                                  </v-tooltip>
                                </section>
                              </v-flex>
                            </form>
                          </v-flex>
                        </v-layout>
  
                        <v-layout class="justify-content-center">
                          <v-flex class="ml-5 mr-5" style="z-index:10000">
                            <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier"
                              :label="$t('paiement.sante.popup_livraison.ville_input_label')" editable item-text="quartier"
                              item-value="quartier" color="#59595b"></v-overflow-btn>
                          </v-flex>
                        </v-layout>
  
                        <v-layout class="justify-content-center">
                          <v-flex>
                            <v-text-field class="ml-5 mr-5" prepend-inner-icon="map"
                              :label="$t('paiement.sante.popup_livraison.adresse_input_label')"
                              v-model="adresselivraison"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="cancelPaiement()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.sante.popup_livraison.bouton_annuler_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="getAdressLivraison()" type="button" class="wizard-btn">
                  {{ $t('paiement.sante.popup_livraison.bouton_valider_label') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--=================================== -->
  
      <!-- ========= Popup remplissage des beneficiaires Mobile ============ -->
      <!-- ========= Popup remplissage des beneficiaires Mobile ============ -->
      <v-dialog v-model="showPopUpBeneficiaireSante" persistent max-width="1000" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosBenefMobile" aria-hidden="true" aria-labelledby="step-infosBenefMobile"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title">{{ $t('paiement.sante.popup_beneficiaire.title') }}</div>
                      <div class="row">
                        <div class="col-sm-4 mt-5">
                          <div class="field-radio field-radio-center">
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Femme" id="Femme" name="infosPerso"
                                class="field-input" />
                              <label for="Femme" class="field-label btn-choice-hide-dot">{{
                                $t('paiement.sante.popup_beneficiaire.madame_label') }}</label>
                            </div>
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Homme" id="Homme" name="infosPerso"
                                class="field-input" />
                              <label for="Homme" class="field-label btn-choice-hide-dot">{{
                                $t('paiement.sante.popup_beneficiaire.monsieur_label') }}</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="prenom_benef" class="field-label">
                              {{ $t('paiement.sante.popup_beneficiaire.prenom_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="prenom"
                                :placeholder="$t('paiement.sante.popup_beneficiaire.prenom_placeholder')" id="prenom_benef"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="nom_benef" class="field-label">{{ $t('paiement.sante.popup_beneficiaire.nom_label')
                            }}</label>
                            <input v-model="nom" :placeholder="$t('paiement.sante.popup_beneficiaire.nom_placeholder')"
                              id="nom_benef" name="infosPerso" class="field-input" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="num_benef" class="field-label">
                              {{ $t('paiement.sante.popup_beneficiaire.telephone_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input :placeholder="$t('paiement.sante.popup_beneficiaire.telephone_placeholder')"
                                @keypress="onlyNumber" v-model="telephone" id="num_benef" name="infosPerso"
                                class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="adresseBenef" class="field-label">
                              {{ $t('paiement.sante.popup_beneficiaire.adresse_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="adresse"
                                :placeholder="$t('paiement.sante.popup_beneficiaire.adresse_placeholder')" id="adresseBenef"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="numeroPass" class="field-label">
                              {{ $t('paiement.sante.popup_beneficiaire.cni_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input @keypress="onlyNumber" v-model="numero_cni"
                                :placeholder="$t('paiement.sante.popup_beneficiaire.cni_placeholder')" id="numeroPass"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="Stepper3" class="field-label">{{
                              $t('paiement.sante.popup_beneficiaire.nationalite_label') }}</label>
                            <select id="Stepper3" name="Step1" class="field-select" v-model="pays">
                              <option v-for="itm in countries" :key="itm.PAYS" :value="itm.PAYS">
                                {{ itm.PAYS }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="goToHome()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.sante.popup_beneficiaire.bouton_annuler_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="Detail_info_beneficiaires()" type="button" class="wizard-btn">
                  {{ $t('paiement.sante.popup_beneficiaire.bouton_ajouter_label') }}
                </button>
              </div>
              <!---->
            </div>
            <div v-responsive.sm.xs class="mt-3">
              <div class="row" v-if="isMobile()">
                <div class="col-sm-12">
                  <table class="table table-simple text-center">
                    <thead class="bg-light policeLato">
                      <tr>
                        <th>{{ $t('paiement.sante.popup_beneficiaire.prenom_label') }}</th>
                        <th>{{ $t('paiement.sante.popup_beneficiaire.nom_label') }}</th>
                      </tr>
                    </thead>
  
                    <tbody v-for="item in tab_perso" :key="item">
                      <tr style="background: #fff">
                        <td class="border">{{ item.prenom }}</td>
                        <td class="border">{{ item.nom }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
  
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left"></div>
              <div class="wizard-footer-right" v-if="showValiderBtn">
                <button @click="ManipPaiement()" type="button" class="wizard-btn">
                  {{ $t('paiement.sante.popup_beneficiaire.bouton_continuer_label') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- ========= Popup remplissage des beneficiaires Desktop ============ -->
      <v-dialog v-model="showPopUpBeneficiaireSante" persistent max-width="1000" v-if="isDesktop()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosBenef" aria-hidden="true" aria-labelledby="step-infosBenef"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title">{{ $t('paiement.sante.popup_beneficiaire.title') }}</div>
                      <div class="row">
                        <div class="col-sm-4 mt-5">
                          <div class="field-radio field-radio-center">
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Femme" id="Femme" name="infosPerso"
                                class="field-input" />
                              <label for="Femme" class="field-label btn-choice-hide-dot">{{
                                $t('paiement.sante.popup_beneficiaire.madame_label') }}</label>
                            </div>
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Homme" id="Homme" name="infosPerso"
                                class="field-input" />
                              <label for="Homme" class="field-label btn-choice-hide-dot">{{
                                $t('paiement.sante.popup_beneficiaire.monsieur_label') }}</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default">
                            <label for="prenom_benef" class="field-label">
                              {{ $t('paiement.sante.popup_beneficiaire.prenom_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="prenom"
                                :placeholder="$t('paiement.sante.popup_beneficiaire.prenom_placeholder')" id="prenom_benef"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="nom_benef" class="field-label">{{ $t('paiement.sante.popup_beneficiaire.nom_label')
                            }}</label>
                            <input v-model="nom" :placeholder="$t('paiement.sante.popup_beneficiaire.nom_placeholder')"
                              id="nom_benef" name="infosPerso" class="field-input" />
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="field-group field-default">
                            <label for="num_benef" class="field-label">
                              {{ $t('paiement.sante.popup_beneficiaire.telephone_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input :placeholder="$t('paiement.sante.popup_beneficiaire.telephone_placeholder')"
                                @keypress="onlyNumber" v-model="telephone" id="num_benef" name="infosPerso"
                                class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="adresseBenef" class="field-label">
                              {{ $t('paiement.sante.popup_beneficiaire.adresse_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="adresse"
                                :placeholder="$t('paiement.sante.popup_beneficiaire.adresse_placeholder')" id="adresseBenef"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
  
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="numeroPass" class="field-label">
                              {{ $t('paiement.sante.popup_beneficiaire.cni_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input @keypress="onlyNumber()" v-model="numero_cni"
                                :placeholder="$t('paiement.sante.popup_beneficiaire.cni_placeholder')" id="numeroPass"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="Stepper3" class="field-label">{{
                              $t('paiement.sante.popup_beneficiaire.nationalite_label') }}</label>
                            <select id="Stepper3" name="Step1" class="field-select" v-model="pays">
                              <option v-for="itm in countries" :key="itm.PAYS" :value="itm.PAYS">
                                {{ itm.PAYS }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="goToHome()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.sante.popup_beneficiaire.bouton_annuler_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="Detail_info_beneficiaires()" type="button" class="wizard-btn">
                  {{ $t('paiement.sante.popup_beneficiaire.bouton_ajouter_label') }}
                </button>
              </div>
              <!---->
            </div>
  
            <div v-responsive.lg.xl class="mt-3">
              <div class="row" v-if="isDesktop()">
                <div class="col-sm-12">
                  <table class="table table-simple text-center">
                    <thead class="bg-light">
                      <tr>
                        <th>{{ $t('paiement.sante.popup_beneficiaire.genre_label') }}</th>
                        <th>{{ $t('paiement.sante.popup_beneficiaire.prenom_label') }}</th>
                        <th>{{ $t('paiement.sante.popup_beneficiaire.nom_label') }}</th>
                        <th>{{ $t('paiement.sante.popup_beneficiaire.telephone_label') }}</th>
                        <th>{{ $t('paiement.sante.popup_beneficiaire.adresse_label') }}</th>
                        <th>{{ $t('paiement.sante.popup_beneficiaire.cni_label') }}</th>
                        <th>{{ $t('paiement.sante.popup_beneficiaire.nationalite_label') }}</th>
                      </tr>
                    </thead>
  
                    <tbody v-for="item in tab_perso" :key="item">
                      <tr class="font-weight-bold">
                        <td class="border">{{ item.genre }}</td>
                        <td class="border">{{ item.prenom }}</td>
                        <td class="border">{{ item.nom }}</td>
                        <td class="border">{{ item.telephone }}</td>
                        <td class="border">{{ item.adresse }}</td>
                        <td class="border">{{ item.numero_cni }}</td>
                        <td class="border">{{ item.pays }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
  
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left"></div>
              <div class="wizard-footer-right" v-if="showValiderBtn">
                <button @click="ManipPaiement()" type="button" class="wizard-btn">
                  {{ $t('paiement.sante.popup_beneficiaire.bouton_continuer_label') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--=================================== -->
  
      <!-- ========= CHOIX PAIEMENT ORANGE MONEY ============ -->
      <!-- ========= CHOIX PAIEMENT ORANGE MONEY ============ -->
      <v-dialog v-model="choixOrangeMoneyPopup" persistent max-width="600px">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="valeurNeuf" aria-hidden="true" aria-labelledby="step-valeurNeuf" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div v-if="isDesktop()" class="fields">
                      <div class="field-title font-weight-bold mb-5">
                        {{ $t('paiement.om_popup.title_label') }}&nbsp;:
                      </div>
                      <div class="field-group row field-bank">
                        <div class="btn-choice col-sm-6 col-6 tool" data-tip="Scanner le QR Code avec l'application Orange Money" tabindex="2">
                          <input type="radio" v-model="choixOrangeMoney" value='app_mobile' id="pack_standard" name="Step09" class="field-input" @click="payement_om_start">
                          <label for="pack_standard" class="field-label">
                            <h3 class="mt-3 text-center">
                              <span>{{ $t('paiement.om_popup.pay_with_label') }} <br /> <span class="font-weight-bold">App
                                  Orange Money</span></span>
                            </h3>
                          </label>
                        </div>
  
                        <div class="btn-choice col-sm-6 col-6 tool" data-tip="Composer le #144#391# et suivez les instructions" tabindex="1">
                          <input type="radio" v-model="choixOrangeMoney" value="ussd" id="pack_inter" name="Step09" class="field-input" @click="payement_om_start">
                          <label for="pack_inter" class="field-label">
                            <h3 class="mt-3 text-center">
                              <span>{{ $t('paiement.om_popup.pay_with_label') }} <br /> <span
                                  class="font-weight-bold">#144#</span></span>
                            </h3>
                          </label>
                        </div>
                      </div>
                    </div>
  
                    <div v-if="isMobile()" class="fields">
                      <div class="field-title font-weight-bold mb-5">
                        {{ $t('paiement.om_popup.title_label') }}&nbsp;:
                      </div>
                      <div class="field-group row field-bank">
                        <div class="btn-choice col-sm-12 col-12 tool" data-tip="Scanner le QR Code avec l'application Orange Money" tabindex="1">
                          <input type="radio" v-model="choixOrangeMoney" value='app_mobile' id="pack_standard" name="Step09" class="field-input" @click="payement_om_start">
                          <label for="pack_standard" class="field-label">
                            <h3 class="mt-3 text-center">
                              <span>{{ $t('paiement.om_popup.pay_with_label') }} <br /> <span class="font-weight-bold">App
                                  Orange Money</span></span>
                            </h3>
                          </label>
                        </div>
  
                        <div class="btn-choice col-sm-12 col-12 tool" data-tip="Composer le #144#391# et suivez les instructions" tabindex="1">
                          <input type="radio" v-model="choixOrangeMoney" value="ussd" id="pack_inter" name="Step09" class="field-input" @click="payement_om_start">
                          <label for="pack_inter" class="field-label">
                            <h3 class="mt-3 text-center">
                              <span>{{ $t('paiement.om_popup.pay_with_label') }} <br /> <span
                                  class="font-weight-bold">#144#</span></span>
                            </h3>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="choixOrangeMoneyPopup = false" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <!-- DIV A NE PAS SUPPRIMER -->
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- =====================New Orange Money payment popup ================================ -->
      <v-dialog v-model="PopupOM" persistent max-width="700">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosBenef" aria-hidden="true" aria-labelledby="step-infosBenef"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title">{{ $t('paiement.om_popup.pay_by_om_label') }} :
                        <span style="color:#ffa409" v-if="this.choixOrangeMoney != 'ussd'"> App Mobile</span>
                        <span style="color:#ffa409" v-else> #144#</span>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="field-group field-default">
                            <label for="prenom_benef" class="field-label">
                              {{ $t('paiement.om_popup.numero_devis_label') }}
                            </label>
                            <div class="input-group value-loan">
                              <input readonly v-model="Devis_pour_souscription.numeroDevis" id="prenom_benef"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="nom_benef" class="field-label">
                              {{ $t('paiement.om_popup.prime_ttc_label') }}
                            </label>
                            <input readonly v-model="mention_ttc" id="nom_benef" name="infosPerso" class="field-input" />
                          </div>
                        </div>
                      </div>
  
                      <div class="row mt-3">
                        <div class="col-sm-6">
                          <div class="field-group field-default">
                            <label for="num_benef" class="field-label">
                              {{ $t('paiement.om_popup.numero_telephone_label') }}
                            </label>
                            <div class="input-group value-loan">
                              <input placeholder="Numéro de téléphone" @keypress="onlyNumber" v-model="telephone_client"
                                id="num_benef" name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6" v-if="this.choixOrangeMoney != 'app_mobile'">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="adresseBenef" class="field-label">
                              {{ $t('paiement.om_popup.code_otp_label') }} (#144#391*XXXX#)
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="code_otp" placeholder="Votre code de validation temporaire" id="adresseBenef"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
  
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="closePopupOm()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.om_popup.button_annuler_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button v-if="this.choixOrangeMoney == 'ussd'" @click="orange_money_payment_end()" type="button"
                  class="wizard-btn">
                  <!-- Payer par OTP -->
                  {{ $t('paiement.om_popup.button_valider_label') }}
                </button>
  
                <button v-else @click="orange_money_qrcode_payment_end()" type="button" class="wizard-btn">
                  <!-- Scanner le QRCode -->
                  {{ $t('paiement.om_popup.button_valider_label') }}
                </button>
              </div>
            </div>
  
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- ============== Popup for Orange Money QRCode payment ============== -->
      <v-dialog v-model="PopupOMQRcode" persistent max-width="600">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosBenef" aria-hidden="true" aria-labelledby="step-infosBenef"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title text-center">
                        {{ $t('paiement.om_popup.scan_label') }}
                      </div>
                      <div class="row border rounded">
                        <img :src="qrCodeImg" alt="orange-money-qr-code" width="50%" style="margin-left:25%" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="closeQrCodePopupOm()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <!-- DIV A NE PAS SUPPRIMER -->
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- ========= Popup remplissage des beneficiaires Desktop ============ -->
      <!-- ========= Popup remplissage des beneficiaires Desktop ============ -->
      <v-dialog v-model="showPopUpBeneficiaireExistantSante" persistent
        v-if="Devis_pour_souscription.brancheid.branche == 'Santé'" max-width="1000">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content" v-show="beneficiarieStep">
              <div role="tabpanel" id="infos_passager" aria-labelledby="step-infos_passager" class="wizard-tab-container">
                <div>
                  <div class="fields">
                    <div class="field-title">{{ $t('paiement.sante.popup_beneficiaire.title') }}</div>
                    <div class="field-group justify-content-center row flex-column flex-sm-row">
                      <div class="btn-choice btn-choice-icon sm-no-change">
                        <input v-model="myBeneficiaries" value="my_beneficiarie" type="radio" id="myBeneficiarie"
                          @click="getListBeneficiarie()" name="Step1_mobile" class="field-input">
                        <label for="myBeneficiarie" class="flex-row flex-md-column field-label">
                          <img src="../assets/img/icones/beneficiaire.png" alt="mes beneficaires" class="mr-4 mr-md-0">
                          <p>{{ $t('paiement.sante.popup_beneficiaire.mybeneficiarie_label') }}</p>
                        </label>
                      </div>
                      <div class="btn-choice btn-choice-icon sm-no-change ml-3">
                        <input v-model="myBeneficiaries" type="radio" value="new_beneficiarie" id="newBeneficiairie"
                          name="Step1_mobile" class="field-input" @change="myBeneficiarieValidator()">
                        <label for="newBeneficiairie" class="flex-row flex-md-column field-label">
                          <img src="../assets/img/icones/new_beneficiaire.png" alt="nouveau beneficiare" class="mr-4 mr-md-0">
                          <p>{{ $t('paiement.sante.popup_beneficiaire.newbeneficiarie_label') }}</p>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="showPopUpBeneficiaireExistantSante = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('paiement.sante.popup_info_assure.bouton_fermer_label') }}
                  </button>
                </div>
              </div>
            </div>
  
            <div class="wizard-tab-content" v-show="newBeneficiarie">
              <div role="tabpanel" id="infosAssure-Mobile" aria-hidden="true" aria-labelledby="step-infosPerso"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title">{{ $t('paiement.sante.popup_beneficiaire.newbeneficiarie_label') }}</div>
  
                      <div class="justify-content-center row">
                        <div class="switch">
                          <input :disabled="disable_switch_souscriptor" v-model="isAssure" type="checkbox"
                            id="switch_assure" @change="souscriptorIsAssure()">
                          <label for="switch_assure">{{ $t('paiement.sante.popup_beneficiaire.subscribe_to_assure_label') }}
                          </label>
                        </div>
                      </div>
  
  
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="prenom_assure_mobile" class="field-label">
                              {{ $t('paiement.sante.popup_info_assure.prenom_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="AssureFields.Prenom"
                                :placeholder="$t('paiement.sante.popup_info_assure.prenom_placeholder')"
                                id="prenom_assure_mobile" name="infosAssureMobile" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="nom_assure_mobile" class="field-label">{{
                              $t('paiement.sante.popup_info_assure.nom_label') }}</label>
                            <input v-model="AssureFields.Nom"
                              :placeholder="$t('paiement.sante.popup_info_assure.nom_placeholder')" id="nom_assure_mobile"
                              name="infosAssureMobile" class="field-input" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="dateNaiss_assure_mobile" class="field-label">
                              {{ $t('paiement.sante.popup_info_assure.date_naissance_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan" style="margin-top: -3px">
                              <date-picker :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1"
                                :placeholder="$t('paiement.sante.popup_info_assure.date_naissance_placeholder')"
                                id="dateNaiss_assure_mobile" v-model="AssureFields.dateNaissance" valueType="format"
                                format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mt-3 row">
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="cni_assure_mobile" class="field-label">
                              {{ $t('paiement.sante.popup_info_assure.cni_label') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="AssureFields.CNI"
                                :placeholder="$t('paiement.sante.popup_info_assure.cni_placeholder')" id="cni_assure_mobile"
                                name="infosAssureMobile" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="liste_assure_mobile" class="field-label">{{
                              $t('paiement.sante.popup_info_assure.assure_label') }}</label>
                            <select id="liste_assure_mobile" name="Step1" class="field-select" v-model="AssureFields.age">
                              <option></option>
                              <option :disabled="disabled_homme"
                                v-if="this.Devis_pour_souscription.details_pack_sante.assures.Adulte.Homme > 0"
                                value="Adulte_homme">{{ $t('paiement.sante.popup_info_assure.homme_label') }} <span
                                  style="color: #ffa409!important;">({{ NombreHomme }})</span></option>
                              <option :disabled="disabled_femme"
                                v-if="this.Devis_pour_souscription.details_pack_sante.assures.Adulte.Femme > 0"
                                value="Adulte_femme">{{ $t('paiement.sante.popup_info_assure.femme_label') }} <span
                                  style="color: #ffa409">({{ NombreFemme }})</span></option>
                              <option :disabled="disabled_garcon"
                                v-if="this.Devis_pour_souscription.details_pack_sante.assures.Enfant.Garcon > 0"
                                value="garcon">{{ $t('paiement.sante.popup_info_assure.garcon_label') }} <span
                                  style="color: #ffa409">({{ NombreGarcon }})</span></option>
                              <option :disabled="disabled_fille"
                                v-if="this.Devis_pour_souscription.details_pack_sante.assures.Enfant.Fille > 0"
                                value="fille">{{ $t('paiement.sante.popup_info_assure.fille_label') }} <span
                                  style="color: #ffa409">({{ NombreFille }})</span></option>
                              <option :disabled="disabled_homme_senior"
                                v-if="this.Devis_pour_souscription.details_pack_sante.assures.Senior.Homme > 0"
                                value="homme">{{ $t('paiement.sante.popup_info_assure.homme_senior') }} <span
                                  style="color: #ffa409">({{ NombreSeniorHomme }})</span></option>
                              <option :disabled="disabled_femme_senior"
                                v-if="this.Devis_pour_souscription.details_pack_sante.assures.Senior.Femme > 0"
                                value="femme">{{ $t('paiement.sante.popup_info_assure.femme_senior') }} <span
                                  style="color: #ffa409">({{ NombreSeniorFemme }})</span></option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="backToBeneficiarieStep()" type="button" class="wizard-btn" v-show="newBeneficiarie">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('paiement.sante.popup_info_assure.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button v-if="newBeneficiarie"
                    v-show="nbAssureAdded < Devis_pour_souscription.details_pack_sante.assures.nombre_assures"
                    @click="CreateListAssure()" type="button" class="wizard-btn">
                    {{ $t('paiement.sante.popup_info_assure.bouton_ajouter_label') }} ({{ nbAssureAdded }} / {{
                      Devis_pour_souscription.details_pack_sante.assures.nombre_assures }})
                  </button>
                  <button v-show="nbAssureAdded == Devis_pour_souscription.details_pack_sante.assures.nombre_assures"
                    @click="setListeAssureToUpdate()" type="button" class="wizard-btn">
                    {{ $t('paiement.sante.popup_info_assure.bouton_valider_label') }}
                  </button>
                  <button v-if="showValiderBtn" v-show="myBeneficiarieList" @click="ManipPaiement()" type="button"
                    class="wizard-btn">
                    {{ $t('paiement.sante.popup_beneficiaire.bouton_continuer_label') }}
                  </button>
                </div>
              </div>
            </div>
  
            <div class="wizard-tab-content mt-3" v-if="myBeneficiarieList">
              <div role="tabpanel" id="list_beneficiaries" aria-hidden="true" aria-labelledby="step-list_beneficiaries"
                class="wizard-tab-container">
  
                <div class="loan-group loan-group-0">
                  <div class="fields" v-if="isDesktop()">
                    <div class="field-title">{{ $t('paiement.sante.popup_beneficiaire.mybeneficiarie_label') }}</div>
                    <div class="row">
                      <div class="col-sm-12">
                        <v-flex class="col-sm-5 offset-7">
                          <div class="col-sm-12">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <input v-model="searchBeneficiarieDesktop"
                                :placeholder="$t('paiement.voyage.popup_passager.search_label')" id="search_beneficiarie"
                                name="Step8" class="field-input">
                            </div>
                          </div>
                        </v-flex>
  
                        <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                          <v-data-table :headers="headerBenef" :items="tab_perso" :search="searchBeneficiarieDesktop"
                            class="border-radius mt-2 mb-5" style="background-color: #FAFAFA!important">
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.prenom }}</td>
                              <td>{{ props.item.nom }}</td>
                              <td>{{ props.item.genre }}</td>
                              <td>{{ props.item.numero_cni }}</td>
                              <td>
                                <ul class="list-boutons">
                                  <li class="justify-content-center row">
                                    <v-btn small icon @click="DeleteBeneficiarie(props.item)">
                                      <img src="../assets/img/devis/delete.png" width="60" alt="suppression_beneficiaire">
                                    </v-btn>
                                    <v-btn small icon @click="SetBeneficiarieToUpdate(props.item)">
                                      <img src="../assets/img/icones/edit_beneficiaire.png" width="60"
                                        alt="modif_beneficiaire">
                                    </v-btn>
                                  </li>
                                </ul>
                              </td>
                              <td><input type="checkbox" v-model="selectionedBeneficiarie" :value="props.item"
                                  @change="updateCheckall()"></td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </div>
                    </div>
                  </div>
  
                  <div class="fields" v-else>
                    <div class="field-title">{{ $t('paiement.sante.popup_beneficiaire.mybeneficiarie_label') }}</div>
                    <div class="row">
                      <div class="col-sm-6">
                        <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                          <v-data-table :headers="headerBenefMobile" :items="tab_perso" :search="searchBeneficiarieDesktop"
                            class="border-radius mt-2 mb-5" style="background-color: #FAFAFA!important">
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.prenom }}</td>
                              <td>{{ props.item.genre }}</td>
                              <td>
                                <ul class="list-boutons">
                                  <li class="justify-content-center row">
                                    <v-btn small icon @click="DeleteBeneficiarie(props.item)">
                                      <img src="../assets/img/devis/delete.png" width="60" alt="suppression_beneficiaire">
                                    </v-btn>
                                    <v-btn small icon @click="SetBeneficiarieToUpdate(props.item)">
                                      <img src="../assets/img/icones/edit_beneficiaire.png" width="60"
                                        alt="modfi_beneficiaire">
                                    </v-btn>
                                  </li>
                                </ul>
                              </td>
                              <td><input type="checkbox" v-model="selectionedBeneficiarie" :value="props.item"
                                  @change="updateCheckall()"></td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="wizard-card-footer clearfix">
                  <div class="wizard-footer-left">
                    <button @click="backToBeneficiarieStep()" type="button" class="wizard-btn" v-show="myBeneficiarieList">
                      <span class="fas fa-arrow-left"></span>
                      {{ $t('paiement.sante.popup_info_assure.bouton_fermer_label') }}
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                    <button
                      v-show="BeneficiarieCible.length < Devis_pour_souscription.details_pack_sante.assures.nombre_assures"
                      @click="ajouterBenef()" type="button" class="wizard-btn">
                      {{ $t('paiement.sante.popup_info_assure.bouton_ajouter_label') }} ({{ BeneficiarieCible.length }} / {{
                        Devis_pour_souscription.details_pack_sante.assures.nombre_assures }})
                    </button>
                    <button
                      v-show="BeneficiarieCible.length == Devis_pour_souscription.details_pack_sante.assures.nombre_assures"
                      @click="setListeAssureToUpdate()" type="button" class="ml-2 wizard-btn">
                      {{ $t('paiement.sante.popup_info_assure.bouton_valider_label') }}
                    </button>
                    <button v-if="showValiderBtn" v-show="myBeneficiarieList" @click="ManipPaiement()" type="button"
                      class="wizard-btn">
                      {{ $t('paiement.sante.popup_beneficiaire.bouton_continuer_label') }}
                    </button>
                  </div>
                </div>
              </div>
  
  
            </div>
  
            <div class="mt-3" v-if="editBeneficiarieDialog">
              <div class="wizard-tab-content pa-6">
                <div role="tabpanel" id="infosBenef" aria-hidden="true" aria-labelledby="step-infosBenef"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title">{{ $t('paiement.sante.popup_beneficiaire.edited_beneficiarie_title') }}
                        </div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default">
                              <label for="prenom_benef" class="field-label">
                                {{ $t('paiement.sante.popup_beneficiaire.prenom_label') }}
                              </label>
                              <div class="input-group value-loan">
                                <input v-model="TheBeneficiarie.prenom"
                                  :placeholder="$t('paiement.sante.popup_beneficiaire.prenom_placeholder')"
                                  id="prenom_benef" name="infosPerso" class="field-input" />
                              </div>
                            </div>
                          </div>
  
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="nom_benef" class="field-label">{{
                                $t('paiement.sante.popup_beneficiaire.nom_label') }}</label>
                              <input v-model="TheBeneficiarie.nom"
                                :placeholder="$t('paiement.sante.popup_beneficiaire.nom_placeholder')" id="nom_benef"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
  
                          <div class="col-sm-4">
                            <div class="field-group field-default">
                              <label for="dateNaiss_assure_desktop" class="field-label">
                                {{ $t('paiement.sante.popup_info_assure.date_naissance_label') }}
                              </label>
                              <div class="input-group value-loan" style="margin-top: -3px">
                                <date-picker :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1"
                                  :placeholder="$t('paiement.sante.popup_info_assure.date_naissance_placeholder')"
                                  id="dateNaiss_assure_desktop" v-model="TheBeneficiarie.datenaissance" valueType="format"
                                  format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                              </div>
                            </div>
                          </div>
                        </div>
  
                        <div class="mt-3 row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="numeroPass" class="field-label">
                                {{ $t('paiement.sante.popup_beneficiaire.cni_label') }}
                              </label>
                              <div class="input-group value-loan">
                                <input @keypress="onlyNumber()" v-model="TheBeneficiarie.numero_cni"
                                  :placeholder="$t('paiement.sante.popup_beneficiaire.cni_placeholder')" id="numeroPass"
                                  name="infosPerso" class="field-input" />
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="liste_assure_desktop" class="field-label">{{
                                $t('paiement.sante.popup_info_assure.assure_label') }}</label>
                              <select id="liste_assure_desktop" name="Step1" class="field-select"
                                v-model="TheBeneficiarie.genre">
                                <option></option>
                                <option>{{ $t('paiement.sante.popup_info_assure.homme_label') }}</option>
                                <option>{{ $t('paiement.sante.popup_info_assure.femme_label') }}</option>
                                <option>{{ $t('paiement.sante.popup_info_assure.garcon_label') }}</option>
                                <option>{{ $t('paiement.sante.popup_info_assure.fille_label') }}</option>
                                <option>{{ $t('paiement.sante.popup_info_assure.homme_senior') }}</option>
                                <option>{{ $t('paiement.sante.popup_info_assure.femme_senior') }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="editBeneficiarieDialog = false, myBeneficiarieList = true" type="button"
                    class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('paiement.sante.popup_info_assure.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="UpdateBeneficiarie()" type="button" class="wizard-btn">
                    {{ $t('paiement.sante.popup_beneficiaire.bouton_modif_label') }}
                  </button>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- =================================== Kpay payment ===================================== -->
      <v-dialog v-model="Popupkpay" persistent max-width="700">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosBenef" aria-hidden="true" aria-labelledby="step-infosBenef"
                class="wizard-tab-container">
                <div v-if="!kpay_confirm">
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="field-group field-default">
                            <label for="prenom_benef" class="field-label">
                              {{ $t('paiement.om_popup.numero_devis_label') }}
                            </label>
                            <div class="input-group value-loan">
                              <input readonly v-model="Devis_pour_souscription.numeroDevis" id="prenom_benef"
                                name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="nom_benef" class="field-label">
                              {{ $t('paiement.om_popup.prime_ttc_label') }}
                            </label>
                            <input readonly v-model="mention_ttc" id="nom_benef" name="infosPerso" class="field-input" />
                          </div>
                        </div>
                      </div>
  
                      <div class="row mt-2">
                        <div class="col-sm-6">
                          <div class="field-group field-default">
                            <label for="num_benef" class="field-label">
                              {{ $t('paiement.om_popup.numero_telephone_label') }}
                            </label>
                            <div class="input-group value-loan">
                              <input placeholder="Numéro de téléphone" @keypress="onlyNumber" v-model="telephone_client"
                                id="num_benef" name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
  
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="kpay_confirm">
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group field-default">
                            <label for="prenom_benef" class="field-label">
                              Renseignez le code reçu par SMS
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="kpaycode" id="prenom_benef" name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                        <button v-if="kpay_confirm" @click="re_resen_otp()" type="button" class="resentotp-btn">
                            Renvoyer un nouveau code
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr/>
                <small style="color:red;">
                  (*) Vous disposez de 15 minutes pour valider le paiement sinon la transaction sera annulée ! 
                </small>
                
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="closePopup_kpay()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.om_popup.button_annuler_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button v-if="!kpay_confirm" @click="kpay_payment()" type="button" class="wizard-btn">
                  {{ $t('paiement.om_popup.button_valider_label') }}
                </button>
                <button v-if="kpay_confirm" @click="kpay_payment_confirmation()" type="button" class="wizard-btn">
                  {{ $t('paiement.om_popup.button_valider_label') }}
                </button>
                
  
              </div>
            </div>
  
          </v-card-text>
        </v-card>
      </v-dialog>
  
        <!-- ========= DIALOG COUPON DE REDUCTION ============ -->
        <!-- ========= DIALOG COUPON DE REDUCTION ============ -->
      <v-dialog v-model="ShowPopupCoupon" persistent max-width="700">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background: #fafafa">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosBenef" aria-hidden="true" aria-labelledby="step-infosBenef"
                class="wizard-tab-container">
                <div v-if="!kpay_confirm">
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group field-default">
                            <label for="num_benef" class="field-label">
                              Coupon de reduction
                            </label>
                            <div class="input-group value-loan">
                              <input placeholder="Numéro de téléphone" @keypress="onlyNumber" v-model="telephone_client"
                                id="num_benef" name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="kpay_confirm">
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group field-default">
                            <label for="prenom_benef" class="field-label">
                              Renseignez le code reçu par SMS
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="kpaycode" id="prenom_benef" name="infosPerso" class="field-input" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="closePopup_kpay()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('paiement.om_popup.button_annuler_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button v-if="!kpay_confirm" @click="kpay_payment()" type="button" class="wizard-btn">
                  {{ $t('paiement.om_popup.button_valider_label') }}
                </button>
                <button v-if="kpay_confirm" @click="kpay_payment_confirmation()" type="button" class="wizard-btn">
                  {{ $t('paiement.om_popup.button_valider_label') }}
                </button>
  
              </div>
            </div>
  
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <!-- <v-dialog v-model="dialogCouponLoading" persistent width="700">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FFA409">
            <div class="wizard-tab-content" style="background:#FFA409">
              <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0" style="background:#FFA409">
                    <div class="fields text-center" style="background:#FFA409">
                       <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular> 
                        <span class="field-title font-weight-bold" style="color:#fff">{{ $t('paiement.coupon_section.popup_loadin_label') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog> -->

       <div v-if="dialogCouponLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('paiement.coupon_section.popup_loadin_label') }}</span>
      </div>
    </v-container>
  </template>
  
  <script>
  import Api from "../services/Api";
  import store from "./../store/store";
  import getUpay from "../services/getUpay";
  import dayjs from "dayjs";
  import getOrabank from "../services/orabank";
  import ville from "./../common/ville";
  import RotateLoader from "vue-spinner/src/BounceLoader.vue";
  import PushInDataLayer from "../services/TagManager";
  import wavepayment from "../services/WaveServices"
  import MedicalQuestion from '../common/questionnaire_medical_assurcare.json'
  import $ from 'jquery'
  import paymentAuto from './payment_auto/payment'
  import paymentHabitation from './payment_habitation/payment'
  import othersPayment from './payment_others/payment'
  import FreeMoneyApi from "./../services/freemoneyapi";
  import Kpay from "./../services/kpay.service"
  
  export default {
    components: {
      RotateLoader,
      'paymentAuto': paymentAuto,
      'paymentHabitation': paymentHabitation,
      'othersPayment': othersPayment,
      //Coupon
    },
    data() {
      return {
        primeBeforeReduction : 0,
        shownTextReduction : false,
        typeReduction : "",
        reductionPurcent : "",
        reductionMount : "",
        textCouponFinale : "",
  
        showReduction : false,
  
  
  
        prime_ttc_before_reduc : 0,
        dialogCouponLoading : false,
        hideCoupon : false,
        codeReduction : null,
        couponswitch : false,
        ShowPopupCoupon : false,
        Kpay_resp: null,
        kpay_confirm: false,
        kpaycode: "",
        Popupkpay: false,
        beneficiarieStep: true,
        myBeneficiaries: null,
        newBeneficiarie: false,
        myBeneficiarieList: false,
        searchBeneficiarieDesktop: "",
        selectedBenef: false,
        showAddButton: true,
        selectionedBeneficiarie: [],
        BeneficiarieCible: [],
        TheBeneficiarie: null,
        editBeneficiarieDialog: false,
        showPopUpBeneficiaireExistantSante: false,
        valideSenior: false,
        valideEnfant: false,
        valideAdulte: false,
        NombreFemme: 0,
        NombreHomme: 0,
        NombreGarcon: 0,
        NombreFille: 0,
        NombreSeniorFemme: 0,
        NombreSeniorHomme: 0,
        disable_switch_souscriptor: false,
        isAssure: false,
        choixOrangeMoneyPopup: false,
        choixOrangeMoney: null,
        passagerIsOk: null,
        assureIsOk: null,
        ListAssure: [],
        listAssure: [],
        ageAssure: false,
        nbAssureAdded: 0,
        dialogInfoAssure: false,
        PopupOM: false,
        qrCodeImg: "",
        PopupOMQRcode: false,
        telephone_client: null,
        code_otp: null,
        // Assure fields
        AssureFields: {
          Nom: null,
          Prenom: null,
          dateNaissance: null,
          CNI: null,
          age: null,
        },
        showAdulte: true,
        showEnfant: true,
        showSenior: true,
        disabled_homme: false,
        disabled_femme: false,
        disabled_garcon: false,
        disabled_fille: false,
        disabled_homme_senior: false,
        disabled_femme_senior: false,
        nbreAdulteHomme: 0,
        nbreAdulteFemme: 0,
        nbreEnfantGarcon: 0,
        nbreEnfantFille: 0,
        nbreSeniorHomme: 0,
        nbreSeniorFemme: 0,
        foundForHomme: null,
        foundForFemme: null,
        foundForGarcon: null,
        foundForFille: null,
        foundForHommeSenior: null,
        foundForFemmeSenior: null,
        PassportDetails: {},
        headerContrat: [
          {
            text: "Prénom",
            sortable: false,
            value: "prenom_passager"
          },
          {
            text: "Nom",
            sortable: false,
            value: "nom_passager"
          },
          {
            text: "Nationalité",
            sortable: false,
            value: "nationalite_passager"
          },
          {
            text: "Num Passport",
            sortable: false,
            value: "numero_ci_passager"
          },
          {
            text: "date Naissance",
            sortable: false,
            value: "dateNaissance"
          },
          {
            text: "Date délivrance",
            sortable: false,
            value: "date_delivrance"
          },
          {
            text: "Date expiration",
            sortable: false,
            value: "date_expiration"
          },
          {
            text: "Action",
            value: "action"
          }
        ],
        headerBenef: [
          {
            text: "Prénom",
            sortable: false,
            value: "prenom"
          },
          {
            text: "Nom",
            sortable: false,
            value: "nom"
          },
          {
            text: "Genre",
            sortable: false,
            value: "age"
          },
          {
            text: "CNI/Passeport",
            sortable: false,
            value: "CNI"
          },
          {
            text: "Actions",
            sortable: false,
          },
          {
            text: "Choix",
            sortable: false,
          },
        ],
        headerBenefMobile: [
          {
            text: "Prénom",
            sortable: false,
            value: "prenom"
          },
          {
            text: "Genre",
            sortable: false,
            value: "age"
          },
          {
            text: "Actions",
            sortable: false,
          },
          {
            text: "Choix",
            sortable: false,
          },
        ],
        headerContratMobile: [
          {
            text: "Prénom",
            sortable: false,
            value: "prenom_passager"
          },
          {
            text: "Nom",
            sortable: false,
            value: "nom_passager"
          },
          {
            text: "Num passport",
            sortable: false,
            value: "numero_ci_passager"
          }
        ],
        searchPassportDesktop: "",
        listPassports: [],
        myPassportList: false,
        myPassports: null,
        newPassport: false,
        passportStep: true,
        usersPasseport: [],
        montant: 0,
        taxe: 0,
        accessoire: 25000,
        primeTTC: 0,
        prime_nette: 0,
        data: [],
        Structure_legale: null,
        Beneficiaire: null,
  
        // Contractant fields
        ContractantFields: {
          Cni: null,
          Genre: null,
          Situation: null,
          Nom: null,
          Prenom: null,
          dateNaissance: null,
          LieuNaissance: null,
          Profession: null,
          Adresse: null,
          Telephone: null,
          Email: null
        },
  
        wave_nom_prenom: null,
        wave_phone: null,
        wave_idcard: null,
        wave_amount: null,
        wave_currency: "XOF",
        /*====*/
        wave_qr_code: false,
        nom: null,
        prenom: null,
        adresse: null,
        telephone: null,
        numero_cni: null,
        pays: null,
        genre: null,
        showPopUpBeneficiaireSante: false,
        tab_perso: [],
        maxPersonne: null,
        //
        GtmAssistanceVal: {},
        addedInTheCard: null,
        aStorMap: false,
        disable: false,
        devis_price: null,
        placeholderprenom: store.state.user.prenom,
        placeholdernom: store.state.user.nom,
        numTelephone: store.state.user.telephone_port,
        passenger_birthady_age: null,
        snipperfree: false,
        description:
          "Paiement de l'assurance " +
          store.state.devispayement.devis.brancheid.branche +
          " No: " +
          store.state.devispayement.devis.numeroDevis +
          ". Assureur: " +
          store.state.devispayement.devis.partenaireid.societe,
        dialogom: false,
        iframe: {
          src: "",
          loaded: false,
        },
        // numTelephone : '' ,
        amenities: [1, 4],
        headers: [
          {
            text: "Marque & Modèle",
            value: "marque",
          },
          {
            text: "Immatriculation",
            value: "immatriculation",
          },
          {
            text: "Catégorie",
            value: "catégorie",
          },
          {
            text: "Force",
            value: "force",
          },
          {
            text: "Age",
            value: "age",
          },
          {
            text: "Valeur neuf",
            value: "valeur",
          },
          {
            text: "Valeur actuelle",
            value: "valeur_actuelle",
          },
          {
            text: "Nbr places",
            value: "nbplace",
          },
          {
            text: "Actions",
          },
        ],
        fraisLiv: 0,
        fraisPaiement: 0,
        Testons: false,
        itemsGenre: ["Homme", "Femme"],
        adresselivraison: "",
        autoHeight: true,
        x: null,
        dialogAlert: false,
        dialogPopupFileCaution: false,
        Devis_pour_souscription: [],
        mode_livraison: null,
        listVille: ville,
        mention_ttc: null,
        showPaymentBLock: false,
        menuDelivrance: false,
        dialogLoading: false,
        menuExpiration: false,
        mode_payement: null,
        notifDeviParMail: null,
        countries: null,
        ville: null,
        quartier: "",
        listegaranties: [],
        marque: null,
        tableau_info_passager: [],
        tableau_info_passager_from_list: [],
        nbPassager: null,
        frais_livraison: null,
        branche: null,
        continue_btn: false,
        dialogInfoPassager: false,
        dialogFileCaution: false,
        dialog: false,
        city: null,
        datePickerDateNais: false,
        IsPaid: false,
        contratToStore: null,
        nom_passager: null,
        num_passager: null,
        prenom_passager: null,
        nationalite_passager: null,
        numero_ci_passager: null,
        dateNaissance: null,
        date_delivrance: null,
        date_expiration: null,
        // listeVille: ville,
        Popupadresse: false,
        freepayment: false,
        orabankpayment: false,
        // selectedVille: null,
        notif: null,
        ExitByUser: true,
        Mano: null,
        show: false,
        ToastTabSucess: {
          // Customized options for success toast
          theme: "toasted-primary",
          position: "top-center",
          duration: 5000,
          fitToScreen: true,
          type: "success",
          className: "custom-success-class",
        },
        ToastTabError: {
          // Customized options for error toast
          theme: "toasted-primary",
          position: "top-center",
          duration: 5000,
          fitToScreen: true,
          type: "error",
        },
        assistanceDialog: false,
        itema: ["Le plus tôt possible", "Dans la matinée", "Dans la journée"],
        rappel: ["Whatsapp", "Appel", "Email"],
        objet: [
          "Devis",
          "Souscription",
          "Contrat",
          "Paiement",
          "Conseil",
          "Sinistre",
          "Autres",
        ],
        horaire: null,
        canal: null,
        name: null,
        tel: null,
        objetRappel: null,
        remarques: null,
        timer: "",
        DeliveryCost: null,
      };
    },
  
  
    created() {
      this.fetchEventsList();
      this.timer = setInterval(this.fetchEventsList, 60000);
  
      // EXECUTION AUTOMATIQUE ET PERIODIQUE DES FONCTIONS POUR
      // DESACTIVER LES CHOIX EXPRESS DU POPUP LIVRAISON
      let result = this.$crontab.addJob({
        name: "counter",
        interval: {
          hours: "17",
          day: "*",
        },
        job: this.disableExpress,
      });
  
      let stop = this.$crontab.addJob({
        name: "stop",
        interval: {
          hours: "8",
          day: "*",
        },
        job: this.enableExpress,
      });
    },
  
    methods: {
  
      re_resen_otp()
      {
        console.log( this.Kpay_resp)
        const dt = { correlationReference : this.Kpay_resp.correlationReference }
          Api().post("kpay/re_send_opt", dt)
            .then((result) => {
              if (result.data._id && result.data.correlationReference) {
                this.$toasted.show("Le code vous a été envoyé !", this.ToastTabSucess)
              } else {
                this.$toasted.show("L'opération a échoué veuillez réessayer !", this.ToastTabError)
              }
            })
            .catch((err) => {
              if(typeof err.response.data.error!='undefined'){
                this.$toasted.show(err.response.data.error, this.ToastTabError)
              }else{
                this.$toasted.show("L'opération a échoué veuillez réessayer !", this.ToastTabError)
              }
            })
      },
      
      checkReductionCom(){
        // {status: true, prime_apres: 277020, prime_avant: 307800, prime_ttc: 277020, coupon: {…}}
        if(this.mode_livraison){
            if (this.mode_payement){
                let couponFromDevis = this.$store.state.devispayement.devis
                if (this.codeReduction) {
                  let Coupon = {
                    brancheid: couponFromDevis.brancheid._id,
                    partenaireid : couponFromDevis.partenaireid._id,
                    courtierid: null,
                    numero_police: couponFromDevis.numeroDevis,
                    dateSouscription : couponFromDevis.dateSouscription,
                    code_coupon : this.codeReduction,
                    code_partenaire: couponFromDevis.codep,
                    prime_ttc : couponFromDevis.prime_ttc
                  }
  
                  Api().post("coupons/check/reduction", Coupon)
                    .then((result) => {
                      // Le coupon est valide, on affiche un message de succès et on effectue des actions supplémentaires
                      if(result.data.status == true){
                        this.dialogCouponLoading = true,
                        setTimeout(() => {
                          this.showReduction = true;
                          this.shownTextReduction = true;
                          let typeReductionType = result.data.coupon.type
                          this.dialogCouponLoading = false,
                          this.hideCoupon = true,
                          this.shownTextReduction = true,
                          this.Devis_pour_souscription.prime_ttc = result.data.prime_ttc
                          this.prime_ttc_before_reduc = result.data.prime_avant
                          this.reductionMount = result.data.coupon.reduction
  
                          if (typeReductionType == 'pourcentage') {
                        this.typeReduction = '%';
                        //showTypeReductionPourcent = true;
                      } else {
                        this.typeReduction = 'FCFA';
                        //showTypeReductionValeur = true;
                      }
  
  
                          this.$toasted.show("Coupon appliqué avec succés !", this.ToastTabSucess),
                          this.calculFraisPaiement()
                        }, 3000)
                        
                      }
                    }
                    )
                    .catch((err) => {
                      // Une erreur s'est produite lors de la requête, on affiche un message d'erreur
                      this.dialogCouponLoading = true,
                      setTimeout(() => {
                        this.shownTextReduction = false,
                          this.dialogCouponLoading = false,
                          this.$toasted.show("Le code saisi n'est pas valide !", this.ToastTabError)
                        }, 3000)
                        
                      
                    })
                } else {
                  this.$toasted.show("Le code est obligatoire !", this.ToastTabError)
                }
            }else {
              this.$toasted.show("Mode de paiement obligatoire!", this.ToastTabError)
            }
        }else {
          this.$toasted.show("Mode de livraison obligatoire!", this.ToastTabError)
        }
      },
  
      openCoupon(){
        this.showPopupCoupon = this.couponswitch === true;
      },
  
      async kpay_payment() {
        if (this.telephone_client) {
          if (this.telephone_client.length == 9) {
            this.Kpay_resp = await Kpay(this.mention_ttc, this.Devis_pour_souscription.numeroDevis, this.telephone_client)
            if (this.Kpay_resp && this.Kpay_resp != null) {
              this.kpay_confirm = true
            }
          } else {
            this.$toasted.show("Le numéro de téléphone n'est pas valide !", this.ToastTabError)
          }
        } else {
          this.$toasted.show("Le numéro de téléphone est obligatoire !", this.ToastTabError)
        }
  
      },
  
      payement_kpay_start: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
            if (this.Devis_pour_souscription.brancheid.branche == 'Voyage') {
              if (this.passagerIsOk != true) {
                this.dialogInfoPassager = true
              } else {
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "kpay");
                this.Popupkpay = true
              }
  
            } else if (this.Devis_pour_souscription.brancheid.branche == 'Santé') {
              if (this.assureIsOk != true) {
                this.getBeneficiaries(store.state.user._id)
              } else {
  
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "kpay");
                this.Popupkpay = true
              }
            } else {
              let montant = this.mention_ttc;
              localStorage.setItem("amount", montant);
              let numDevis = this.Devis_pour_souscription.numeroDevis;
              localStorage.setItem("numdevis", numDevis);
              localStorage.setItem("canal", "kpay");
              this.Popupkpay = true
            }
  
          } else {
            this.$toasted.show("Mode livraison obligatoire !", this.ToastTabError);
          }
        } else {
          this.$toasted.show("Mode de payement obligatoire !", this.ToastTabError);
        }
      },
  
      kpay_payment_confirmation() {
        if (this.kpaycode != "") {
          const dt = {
            otp: this.kpaycode,
            kpayReference: this.Kpay_resp.kpayReference,
            customerPhoneNumber: "221" + this.telephone_client.substring(this.telephone_client.length - 9)
          }
          Api().post("kpay/payment/confirmation", dt)
            .then((result) => {
              if (result.data.message && result.data.message == "Contrat cree et envoye par email") 
              {
                this.$router.push('/payment/orangemoneyrep')
              }else if(result.data.message && result.data.message == "Contrat cree mais non envoye par email"){
                this.$router.push('/payment/orangemoneyrep')
              }else {
                this.$toasted.show("L'opération a échoué veuillez réessayer !", this.ToastTabError)
              }
            })
            .catch((err) => {
              
              if(typeof err.response.data.error!='undefined')
              {
                if(err.response.data.error=="Votre transaction n'a pas pu être effectuée à cause d'entrées invalides dans la requête. Veuillez réessayer avec des valeurs correctes"){
                  this.$toasted.show("Le délai d'attente de validation est expiré, la transaction a été annulé !", this.ToastTabError)
                  this.kpay_confirm = false
                  this.Popupkpay = false
                  setTimeout(() => (this.$router.push('/home')), 5000)
                }else{
                  this.$toasted.show(err.response.data.error, this.ToastTabError)
                }
              
              }else{
                this.$toasted.show("L'opération a échoué veuillez réessayer !", this.ToastTabError)
              }
            })
        } else {
          this.$toasted.show("Le code est obligatoire !", this.ToastTabError)
        }
      },
  
      updateCheckall() {
        // récupère toutes les cases à cocher de la liste
        var checkboxes = document.querySelectorAll('input[type=checkbox]');
  
        // parcours toutes les cases à cocher et ajoute un gestionnaire d'événements "onclick"
        for (var i = 0; i < checkboxes.length; i++) {
          checkboxes[i].onclick = function () {
            // vérifie si la case est cochée
            if (this.checked) {
              // désactive toutes les autres cases à cocher de la liste
              for (var j = 0; j < checkboxes.length; j++) {
                if (checkboxes[j] != this) {
                  checkboxes[j].disabled = true;
                }
              }
            } else {
              // réactive toutes les cases à cocher de la liste
              for (var j = 0; j < checkboxes.length; j++) {
                checkboxes[j].disabled = false;
              }
            }
          }
        }
      },
  
      backToBeneficiarieStep() {
        this.myBeneficiarieList = false
        this.newBeneficiarie = false
        this.beneficiarieStep = true
        //this.myPassports = null
      },
  
      getListBeneficiarie() {
        this.beneficiarieStep = false;
        this.myBeneficiarieList = true;
      },
  
      myBeneficiarieValidator() {
        if (this.myBeneficiaries == 'new_beneficiarie') {
          this.newBeneficiarie = true
          this.beneficiarieStep = false
        }
      },
  
      ajouterBenef() {
        let Adulte = this.Devis_pour_souscription.details_pack_sante.assures.Adulte;
        let Enfant = this.Devis_pour_souscription.details_pack_sante.assures.Enfant;
        let Senior = this.Devis_pour_souscription.details_pack_sante.assures.Senior;
  
  
        if (this.BeneficiarieCible.length < this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
          for (let benef of this.selectionedBeneficiarie) {
            if (benef.genre == "Adulte_homme") {
              if (Adulte.Homme != 0) {
                this.BeneficiarieCible.push(benef);
                Adulte.Homme--
                this.$toasted.show("Bénéficiaire ajouté avec succès !", this.ToastTabSucess)
              } else {
                this.$toasted.show("Ajout comme bénéficiaire impossible pour ce devis !", this.ToastTabError)
              }
            }
  
            if (benef.genre == "Adulte_femme") {
              if (Adulte.Femme != 0) {
                this.BeneficiarieCible.push(benef);
                Adulte.Femme--
                this.$toasted.show("Bénéficiaire ajouté avec succès !", this.ToastTabSucess)
              } else {
                this.$toasted.show("Ajout comme bénéficiaire impossible pour ce devis !", this.ToastTabError)
              }
            }
  
            if (benef.genre == "garcon") {
              if (Enfant.Garcon != 0) {
                this.BeneficiarieCible.push(benef);
                Enfant.Garcon--
                this.$toasted.show("Bénéficiaire ajouté avec succès !", this.ToastTabSucess)
              } else {
                this.$toasted.show("Ajout comme bénéficiaire impossible pour ce devis !", this.ToastTabError)
              }
            }
  
            if (benef.genre == "fille") {
              if (Enfant.Fille != 0) {
                this.BeneficiarieCible.push(benef);
                Enfant.Fille--
                this.$toasted.show("Bénéficiaire ajouté avec succès !", this.ToastTabSucess)
              } else {
                this.$toasted.show("Ajout comme bénéficiaire impossible pour ce devis !", this.ToastTabError)
              }
            }
  
            if (benef.genre == "homme") {
              if (Senior.Homme != 0) {
                this.BeneficiarieCible.push(benef);
                Senior.Homme--
                this.$toasted.show("Bénéficiaire ajouté avec succès !", this.ToastTabSucess)
              } else {
                this.$toasted.show("Ajout comme bénéficiaire impossible pour ce devis !", this.ToastTabError)
              }
            }
  
            if (benef.genre == "femme") {
              if (Senior.Femme != 0) {
                this.BeneficiarieCible.push(benef);
                Senior.Femme--
                this.$toasted.show("Bénéficiaire ajouté avec succès !", this.ToastTabSucess)
              } else {
                this.$toasted.show("Ajout comme bénéficiaire impossible pour ce devis !", this.ToastTabError)
              }
            }
          }
        } else {
          this.$toasted.show("Vous avez ajouté le nombre d'assurés total pour ce devis !", this.ToastTabError)
          this.showAddButton = false;
        }
      },
  
      souscriptorIsAssure() {
        if (this.isAssure != true) {
          this.ClearFormAssure()
        } else {
          this.AssureFields.Prenom = this.$store.state.user.prenom
          this.AssureFields.Nom = this.$store.state.user.nom
          this.AssureFields.CNI = this.$store.state.user.numero_piece
          this.AssureFields.dateNaissance = this.$store.state.user.datenaissance
          this.yearsDiffAssure()
        }
      },
  
      closePopupOm() {
        this.mode_payement = null;
        this.PopupOM = false;
        this.choixOrangeMoney = null;
      },
  
      closePopup_kpay() {
        this.mode_payement = null
        this.telephone_client = null
        this.kpaycode = "",
          this.kpay_confirm = false,
          this.Popupkpay = false
      },
  
      closeQrCodePopupOm() {
        this.mode_payement = null;
        this.PopupOMQRcode = false;
        this.choixOrangeMoney = null;
      },
  
      checkToken() {
        Api().get('user/check/token')
          .then((resultat) => {
            // verifie si le token exist
            if (!resultat.data.ok) {
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          }).catch((err) => {
            // verifie  si le token est expiré
            if (err.response.data.ok === false) {
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          });
      },
  
      orange_money_payment_end() {
        if (this.telephone_client && this.code_otp) {
          const data = {
            primettc: this.build_data(this.mention_ttc), //this.mention_ttc,
            telephone_client: this.telephone_client,
            code_otp: this.code_otp,
            reference: this.Devis_pour_souscription.numeroDevis
          }
  
          Api().post("orangemoney/onestep", data)
            .then((result) => {
              this.$router.push('/payment/orangemoneyrep')
            }).catch((err) => {
              if (err.response.data.code != "" && err.response.data.detail != "") {
                this.$toasted.show(err.response.data.detail, this.ToastTabError)
              } else {
                this.$toasted.show("L'opération a échoué veuillez réessayer !", this.ToastTabError)
              }
            });
        } else {
          this.$toasted.show("Numéro téléphone et Code OTP obligatoire !", this.ToastTabError)
        }
  
      },
  
  
      orange_money_qrcode_payment_end() {
        if (this.telephone_client) {
          const data = {
            primettc: this.build_data(this.mention_ttc),
            reference: this.Devis_pour_souscription.numeroDevis
          }
          Api().post("orangemoney/qrcode", data)
            .then((result) => {
              if (this.isDesktop()) {
                this.qrCodeImg = "data:image/jpg;base64," + result.data.qrCode
                this.PopupOMQRcode = true
                this.PopupOM = false
                setTimeout(() => { this.$router.push('/payment/orangemoneyrep') }, 60000);
              } else {
                window.open(result.data.deepLink)
              }
  
            }).catch((err) => {
              if (err.response.data.code != "" && err.response.data.detail != "") {
                this.$toasted.show(err.response.data.detail, this.ToastTabError)
              } else {
                this.$toasted.show("L'opération a échoué veuillez réessayer !", this.ToastTabError)
              }
            });
        } else {
          this.$toasted.show("Numéro de téléphone obligatoire !", this.ToastTabError)
        }
  
      },
  
      build_data(prime){
        if(this.$store.state.user.email=="mowencleopas@assuraf.com" || this.$store.state.user.email=="cfall@assuraf.com"){
          return 10
        }else{
          return prime
        }
      },
  
      disabledAfterToday(date) {
        const today = new Date()
        return date < today
      },
  
      /*===Send of data to API to update assuré infos===*/
      setListeAssureToUpdate() {
        if (this.myBeneficiaries == "new_beneficiarie") {
          const ASSURE = {
            devisid: this.Devis_pour_souscription._id,
            ListAssure: this.ListAssure,
            //ListAssure : this.BeneficiarieCible,
          };
          Api().post('assurcare/set_liste_assure', ASSURE)
            .then((result) => {
              if (result.nModified = 1) {
                this.assureIsOk = true
                this.dialogInfoAssure = false
                this.showPopUpBeneficiaireExistantSante = false
                this.$toasted.show("Assuré(s) ajouté avec succés", this.ToastTabSucess);
              } else {
                this.$toasted.show("Ajout Assuré(s) échoué", this.ToastTabSucess);
              }
            }).catch((err) => {
              console.log(err)
            });
        } else if (this.myBeneficiaries == "my_beneficiarie") {
          const ASSURE = {
            devisid: this.Devis_pour_souscription._id,
            //ListAssure : this.ListAssure,
            ListAssure: this.BeneficiarieCible,
          };
          Api().post('assurcare/set_liste_assure', ASSURE)
            .then((result) => {
              if (result.nModified = 1) {
                this.assureIsOk = true
                this.dialogInfoAssure = false
                this.showPopUpBeneficiaireExistantSante = false
                this.$toasted.show("Assuré(s) ajouté avec succés", this.ToastTabSucess);
              } else {
                this.$toasted.show("Ajout Assuré(s) échoué", this.ToastTabSucess);
              }
            }).catch((err) => {
              console.log(err)
            });
        }
  
  
      },
  
  
      setListassure_tostore(item) {
        let listAssure = []
        for (let i of item) {
          listAssure.push({
            nom: i.Nom,
            prenom: i.Prenom,
            datenaissance: i.DateNaissance,
            numero_cni: i.CNI,
            genre: i.Age,
            questionnaire_medical: MedicalQuestion.questions
          })
        }
        return listAssure
      },
  
      ClearFormAssure: function () {
        this.AssureFields.Nom = null,
          this.AssureFields.Prenom = null,
          this.AssureFields.dateNaissance = null,
          this.AssureFields.CNI = null
        this.AssureFields.age = null
  
      },
  
      yearsDiffAssure() {
        const Date60 = dayjs(this.AssureFields.dateNaissance).add(+60, 'year').format('YYYY-MM-DD')
        const Date21 = dayjs(this.AssureFields.dateNaissance).add(+21, 'year').format('YYYY-MM-DD')
        const Date20 = dayjs(this.AssureFields.dateNaissance).add(+20, 'year').format('YYYY-MM-DD')
        const dateToday = dayjs(new Date()).format('YYYY-MM-DD');
  
        if (this.AssureFields.age == 'Adulte_homme' || this.AssureFields.age == 'Adulte_femme') {
          if (Date21 <= dateToday) {
            this.valideAdulte = true
          } else {
            this.valideAdulte = false
          }
        }
  
        if (this.AssureFields.age == 'homme' || this.AssureFields.age == 'femme') {
          if (Date60 <= dateToday) {
            this.valideSenior = true
          } else {
            this.valideSenior = false
          }
        }
  
        if (this.AssureFields.age == 'fille' || this.AssureFields.age == 'garcon') {
          const DateDiff = dayjs(dateToday).diff(dayjs(Date20), 'year')
          if (DateDiff <= 0) {
            this.valideEnfant = true
          } else {
            this.valideEnfant = false
          }
        }
      },
      /*=================Creation d'une liste de vehicules pour affichage Recap===============*/
      CreateListAssure() {
  
        if (this.AssureFields.Nom && this.AssureFields.Prenom && this.AssureFields.dateNaissance && this.AssureFields.age) {
          const Assure = {
            nom: this.AssureFields.Nom,
            prenom: this.AssureFields.Prenom,
            datenaissance: this.AssureFields.dateNaissance,
            numero_cni: this.AssureFields.CNI,
            age: this.AssureFields.age,
            userid: store.state.user._id
          };
  
          this.saveOneBeneficiaries(Assure)
  
          if (this.isAssure == true) {
            this.disable_switch_souscriptor = true
          } else {
            this.disable_switch_souscriptor = false
          }
  
          if (this.AssureFields.age == 'garcon') {
            this.yearsDiffAssure()
            if (this.valideEnfant == true) {
              this.ListAssure.push(Assure);
              this.getHommeAssure()
              this.nbAssureAdded = this.nbAssureAdded + 1;
  
              if (this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures > 0) {
                if (this.nbAssureAdded < this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Ajouté avec succés !', this.ToastTabSucess)
                  this.ClearFormAssure();
                  this.disableDateAssure = false
                  this.NombreGarcon--
                }
                if (this.nbAssureAdded == this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Assuré(s) avec succés !', this.ToastTabSucess)
                  this.NombreGarcon--
                }
              } else {
                this.voidField = true
              }
            } else {
              this.$toasted.show('Date de naissance choisie ne correspond pas à un enfant !', this.ToastTabError)
            }
          } if (this.AssureFields.age == 'fille') {
            this.yearsDiffAssure()
            if (this.valideEnfant == true) {
              this.ListAssure.push(Assure);
              this.getHommeAssure()
              this.nbAssureAdded = this.nbAssureAdded + 1;
  
              if (this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures > 0) {
                if (this.nbAssureAdded < this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Ajouté avec succés !', this.ToastTabSucess)
                  this.ClearFormAssure();
                  this.disableDateAssure = false
                  this.NombreFille--
                }
                if (this.nbAssureAdded == this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Assuré(s) avec succés !', this.ToastTabSucess)
                  this.NombreFille--
                }
              } else {
                this.voidField = true
              }
            } else {
              this.$toasted.show('Date de naissance choisie ne correspond pas à un enfant !', this.ToastTabError)
            }
          } else if (this.AssureFields.age == 'Adulte_homme') {
            this.yearsDiffAssure()
            if (this.valideAdulte == true) {
              this.ListAssure.push(Assure);
              this.getHommeAssure()
              this.nbAssureAdded = this.nbAssureAdded + 1;
  
              if (this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures > 0) {
                if (this.nbAssureAdded < this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Ajouté avec succés !', this.ToastTabSucess)
                  this.ClearFormAssure();
                  this.disableDateAssure = false
                  this.NombreHomme--
                }
                if (this.nbAssureAdded == this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Assuré(s) avec succés !', this.ToastTabSucess)
                  this.NombreHomme--
                }
              } else {
                this.voidField = true
              }
            } else {
              this.$toasted.show('Date de naissance choisie ne correspond pas à un adulte !', this.ToastTabError)
            }
          } else if (this.AssureFields.age == 'Adulte_femme') {
            //if(this.ageAssure >= 662256000 && this.ageAssure < 1892160000){
            this.yearsDiffAssure()
            if (this.valideAdulte == true) {
              this.ListAssure.push(Assure);
              this.getHommeAssure()
              this.nbAssureAdded = this.nbAssureAdded + 1;
              if (this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures > 0) {
                if (this.nbAssureAdded < this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Ajouté avec succés !', this.ToastTabSucess)
                  this.ClearFormAssure();
                  this.disableDateAssure = false
                  this.NombreFemme--
                }
                if (this.nbAssureAdded == this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Assuré(s) avec succés !', this.ToastTabSucess)
                  this.NombreFemme--
                }
              } else {
                this.voidField = true
              }
            } else {
              this.$toasted.show('Date de naissance choisie ne correspond pas à un adulte !', this.ToastTabError)
            }
          } else if (this.AssureFields.age == 'femme') {
            this.yearsDiffAssure()
            if (this.valideSenior == true) {
              this.ListAssure.push(Assure);
              this.getHommeAssure()
              this.nbAssureAdded = this.nbAssureAdded + 1;
  
              if (this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures > 0) {
                if (this.nbAssureAdded < this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
  
                  this.Devis_pour_souscription.details = this.setListassure_tostore(this.ListAssure)
  
  
                  this.$toasted.show('Ajouté avec succés !', this.ToastTabSucess)
                  this.ClearFormAssure();
                  this.disableDateAssure = false
                  this.NombreSeniorFemme--
                }
                if (this.nbAssureAdded == this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Assuré(s) avec succés !', this.ToastTabSucess)
                  this.NombreSeniorFemme--
                }
              } else {
                this.voidField = true
              }
            } else {
              this.$toasted.show('Date de naissance choisie ne correspond pas à un sénior !', this.ToastTabError)
            }
          } else if (this.AssureFields.age == 'homme') {
            this.yearsDiffAssure()
            if (this.valideSenior == true) {
              this.ListAssure.push(Assure);
              this.getHommeAssure()
              this.nbAssureAdded = this.nbAssureAdded + 1;
  
              if (this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures > 0) {
                if (this.nbAssureAdded < this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
  
                  this.Devis_pour_souscription.details = this.setListassure_tostore(this.ListAssure)
  
  
                  this.$toasted.show('Ajouté avec succés !', this.ToastTabSucess)
                  this.ClearFormAssure();
                  this.disableDateAssure = false
                  this.NombreSeniorHomme--
                }
                if (this.nbAssureAdded == this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                  this.$toasted.show('Assuré(s) avec succés !', this.ToastTabSucess)
                  this.NombreSeniorHomme--
                }
              } else {
                this.voidField = true
              }
            } else {
              this.$toasted.show('Date de naissance choisie ne correspond pas à un sénior !', this.ToastTabError)
            }
          }
  
  
        } else {
          this.$toasted.show('Tous les champs sont obligatoires sauf CNI !', this.ToastTabError)
        }
  
      },
  
      getHommeAssure() {
        if (this.AssureFields.age == 'Adulte_femme') {
          this.foundForFemme++
        }
  
        if (this.AssureFields.age == 'Adulte_homme') {
          this.foundForHomme++
        }
  
        if (this.AssureFields.age == 'garcon') {
          this.foundForGarcon++
        }
  
        if (this.AssureFields.age == 'fille') {
          this.foundForFille++
        }
  
        if (this.AssureFields.age == 'homme') {
          this.foundForHommeSenior++
        }
  
        if (this.AssureFields.age == 'femme') {
          this.foundForFemmeSenior++
        }
  
        if (this.foundForHomme == this.Devis_pour_souscription.details_pack_sante.assures.Adulte.Homme) {
          this.disabled_homme = true
        }
  
        if (this.foundForFemme == this.Devis_pour_souscription.details_pack_sante.assures.Adulte.Femme) {
          this.disabled_femme = true
        }
  
        if (this.foundForGarcon == this.Devis_pour_souscription.details_pack_sante.assures.Enfant.Garcon) {
          this.disabled_garcon = true
        }
  
        if (this.foundForFille == this.Devis_pour_souscription.details_pack_sante.assures.Enfant.Fille) {
          this.disabled_fille = true
        }
  
        if (this.foundForHommeSenior == this.Devis_pour_souscription.details_pack_sante.assures.Senior.Homme) {
          this.disabled_homme_senior = true
        }
  
        if (this.foundForFemmeSenior == this.Devis_pour_souscription.details_pack_sante.assures.Senior.Femme) {
          this.disabled_femme_senior = true
        }
  
      },
  
  
      deletePassport(item) {
        Api().post('mypassports/delete', { passportid: item._id })
          .then(response => {
            if (response.status == 200) {
              this.$toasted.show("Passeport supprimé avec succès !", this.ToastTabSucess);
              this.getUserPassport()
            }
          })
          .catch(err => { })
  
      },
  
      disabledBeforeToday(date) {
        const today = dayjs(new Date()).add(+0, 'day')
        this.date_expiration = null
        return date > today;
      },
  
  
      disabledBeforeTodayDateNaissance(date) {
        const today = dayjs(new Date()).add(-1, 'day')
        return date > today;
      },
  
      getPassportForDevis(item) {
        this.PassportDetails = item
        this.tableau_info_passager_from_list.push(this.PassportDetails)
        let datePassport = this.DateFormater(item.dateNaissance)
        let dateNaissDevis = this.DateFormater(this.Devis_pour_souscription.listPassager[0].dateNaissance)
  
        if (datePassport === dateNaissDevis) {
          const data = {
            devisid: this.Devis_pour_souscription._id,
            listPassager: this.tableau_info_passager_from_list,
          }
          Api()
            .post("/devis/voyage/setpassenger", data)
            .then((result) => {
              // if (result.data.status == 1) {
              //   this.$toasted.show(result.data.msg, this.ToastTabSucess);
              //   (this.dialogInfoPassager = false), (this.passagerIsOk = true), (this.showPaymentBLock = true);
              // } else {
              //   this.$toasted.show(result.data.msg, this.ToastTabError);
              // }
  
                if (result.data.msg == "Enregistrement réussi !") {
                this.$toasted.show(result.data.msg, this.ToastTabSucess);
                (this.dialogInfoPassager = false), (this.passagerIsOk = true), (this.showPaymentBLock = true);
              } else {
                this.$toasted.show(result.data.msg, this.ToastTabError);
              }
            })
            .catch((err) => { });
          this.dialogInfoPassager = false
        } else {
          this.$toasted.show('La date de naissance du passager est différente de celle du passeport', this.ToastTabError);
        }
      },
  
      myPassportValidator() {
        if (this.myPassports == 'nouveau') {
          this.newPassport = true
          this.passportStep = false
        }
      },
  
      backToPassportStep() {
        this.myPassportList = false
        this.newPassport = false
        this.passportStep = true
        this.myPassports = null
      },
  
  
      saveUserPassport() {
        const UserPassport = {
          userid: store.state.user._id,
          prenom_passager: this.prenom_passager,
          nom_passager: this.nom_passager,
          nationalite_passager: this.nationalite_passager,
          //nationalite_passager: "Sénégal",
          numero_ci_passager: this.numero_ci_passager,
          dateNaissance: this.dateNaissance,
          date_delivrance: this.date_delivrance,
          date_expiration: this.date_expiration,
          genre: this.genre
  
        }
  
        console.log(":::::::::::: utilisateur passport ::::::::::::::", UserPassport)
  
        Api().post("mypassports/save", UserPassport)
          .then(response => {
            this.$toasted.show("Passport enregistré avec succés !", this.ToastTabSucess)
          });
      },
  
      getUserPassport() {
        Api().post("mypassports/userpassport", { userid: store.state.user._id })
          .then(response => {
            this.listPassports = response.data.mespasseports
          });
      },
  
      getListPassport() {
        this.passportStep = false
        this.myPassportList = true
        this.listPassports = this.usersPasseport
        this.myPassports = 'mes_passport'
        this.getUserPassport()
      },
  
      fileNineaValidation() {
        $("form").on("change", ".file-upload-field", function () {
          $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, ''));
        });
  
        let fileInput = document.getElementById('nineaFile');
        let filePath = fileInput.value;
  
        // Controle du format du fichier
        let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
        if (!allowedExtensions.exec(filePath)) {
          this.$toasted.show("le format du fichier n'est pas accepté ! ", this.ToastTabError);
          fileInput.value = '';
          return false;
        } else {
          // Verfier si le fichier est selectioné.
          if (fileInput.files.length > 0) {
            for (let i = 0; i <= fileInput.files.length - 1; i++) {
              const fsize = fileInput.files.item(i).size;
              const file = Math.round((fsize / 1024));
              // Controle de la taille du fichier.
              if (file >= 1096) {
                this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 1 Mo ! ", this.ToastTabError)
                fileInput.value = '';
              } else {
                this.$toasted.show("Fichier ajouté avec succés ! ", this.ToastTabSucess)
              }
            }
          }
        }
      },
  
      fileRcValidation() {
        $("form").on("change", ".file-upload-field", function () {
          $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, ''));
        });
  
        let fileInput = document.getElementById('fileRc');
        let filePath = fileInput.value;
  
        // Controle du format du fichier
        let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
        if (!allowedExtensions.exec(filePath)) {
          this.$toasted.show("le format du fichier n'est pas accepté ! ", this.ToastTabError);
          fileInput.value = '';
          return false;
        } else {
          // Verfier si le fichier est selectioné.
          if (fileInput.files.length > 0) {
            for (let i = 0; i <= fileInput.files.length - 1; i++) {
              const fsize = fileInput.files.item(i).size;
              const file = Math.round((fsize / 1024));
              // Controle de la taille du fichier.
              if (file >= 1096) {
                this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 1 Mo ! ", this.ToastTabError)
                fileInput.value = '';
              } else {
                this.$toasted.show("Fichier ajouté avec succés ! ", this.ToastTabSucess)
              }
            }
          }
        }
      },
  
      fileDaoValidation() {
        $("form").on("change", ".file-upload-field", function () {
          $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, ''));
        });
  
        let fileInput = document.getElementById('fileDao');
        let filePath = fileInput.value;
  
        // Controle du format du fichier
        let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
        if (!allowedExtensions.exec(filePath)) {
          this.$toasted.show("le format du fichier n'est pas accepté ! ", this.ToastTabError);
          fileInput.value = '';
          return false;
        } else {
          // Verfier si le fichier est selectioné.
          if (fileInput.files.length > 0) {
            for (let i = 0; i <= fileInput.files.length - 1; i++) {
              const fsize = fileInput.files.item(i).size;
              const file = Math.round((fsize / 1024));
              // Controle de la taille du fichier.
              if (file >= 1096) {
                this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 1 Mo ! ", this.ToastTabError)
                fileInput.value = '';
              } else {
                this.$toasted.show("Fichier ajouté avec succés ! ", this.ToastTabSucess)
              }
            }
          }
        }
      },
  
      fileCniValidation() {
        $("form").on("change", ".file-upload-field", function () {
          $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, ''));
        });
  
        let fileInput = document.getElementById('fileCni');
        let filePath = fileInput.value;
  
        // Controle du format du fichier
        let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
        if (!allowedExtensions.exec(filePath)) {
          this.$toasted.show("le format du fichier n'est pas accepté ! ", this.ToastTabError);
          fileInput.value = '';
          return false;
        } else {
          // Verfier si le fichier est selectioné.
          if (fileInput.files.length > 0) {
            for (let i = 0; i <= fileInput.files.length - 1; i++) {
              const fsize = fileInput.files.item(i).size;
              const file = Math.round((fsize / 1024));
              // Controle de la taille du fichier.
              if (file >= 1096) {
                this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 1 Mo ! ", this.ToastTabError)
                fileInput.value = '';
              } else {
                this.$toasted.show("Fichier ajouté avec succés ! ", this.ToastTabSucess)
              }
            }
          }
        }
      },
  
      fileLettreValidation() {
        $("form").on("change", ".file-upload-field", function () {
          $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, ''));
        });
  
        let fileInput = document.getElementById('fileLettre');
        let filePath = fileInput.value;
  
        // Controle du format du fichier
        let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
        if (!allowedExtensions.exec(filePath)) {
          this.$toasted.show("le format du fichier n'est pas accepté ! ", this.ToastTabError);
          fileInput.value = '';
          return false;
        } else {
          // Verfier si le fichier est selectioné.
          if (fileInput.files.length > 0) {
            for (let i = 0; i <= fileInput.files.length - 1; i++) {
              const fsize = fileInput.files.item(i).size;
              const file = Math.round((fsize / 1024));
              // Controle de la taille du fichier.
              if (file >= 1096) {
                this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 1 Mo ! ", this.ToastTabError)
                fileInput.value = '';
              } else {
                this.$toasted.show("Fichier ajouté avec succés ! ", this.ToastTabSucess)
              }
            }
          }
        }
      },
  
      fileRefValidation() {
        $("form").on("change", ".file-upload-field", function () {
          $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, ''));
        });
  
        let fileInput = document.getElementById('fileRef');
        let filePath = fileInput.value;
  
        // Controle du format du fichier
        let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
        if (!allowedExtensions.exec(filePath)) {
          this.$toasted.show("le format du fichier n'est pas accepté ! ", this.ToastTabError);
          fileInput.value = '';
          return false;
        } else {
          // Verfier si le fichier est selectioné.
          if (fileInput.files.length > 0) {
            for (let i = 0; i <= fileInput.files.length - 1; i++) {
              const fsize = fileInput.files.item(i).size;
              const file = Math.round((fsize / 1024));
              // Controle de la taille du fichier.
              if (file >= 1096) {
                this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 1 Mo ! ", this.ToastTabError)
                fileInput.value = '';
              } else {
                this.$toasted.show("Fichier ajouté avec succés ! ", this.ToastTabSucess)
              }
            }
          }
        }
      },
  
      fileStatusValidation() {
        $("form").on("change", ".file-upload-field", function () {
          $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, ''));
        });
  
        let fileInput = document.getElementById('fileStatut');
        let filePath = fileInput.value;
  
        // Controle du format du fichier
        let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
        if (!allowedExtensions.exec(filePath)) {
          this.$toasted.show("le format du fichier n'est pas accepté ! ", this.ToastTabError);
          fileInput.value = '';
          return false;
        } else {
          // Verfier si le fichier est selectioné.
          if (fileInput.files.length > 0) {
            for (let i = 0; i <= fileInput.files.length - 1; i++) {
              const fsize = fileInput.files.item(i).size;
              const file = Math.round((fsize / 1024));
              // Controle de la taille du fichier.
              if (file >= 1096) {
                this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 1 Mo ! ", this.ToastTabError)
                fileInput.value = '';
              } else {
                this.$toasted.show("Fichier ajouté avec succés ! ", this.ToastTabSucess)
              }
            }
          }
        }
      },
  
      checkBranchCaution() {
        if (this.$store.state.devispayement.devis.brancheid.branche == "Caution") {
          this.dialogFileCaution = true
        }
      },
  
  
  
      updatePaiementCaution() {
        let fileNinea = this.$refs.Ninea.files[0];
        let fileRc = this.$refs.Rc.files[0];
        let fileDao = this.$refs.Dao.files[0]
        let fileCni = this.$refs.Cni.files[0]
        let fileLettreType = this.$refs.LettreType.files[0]
        let fileReference = this.$refs.Reference.files[0]
        let fileStatut = this.$refs.Statut.files[0]
  
        if (fileNinea && fileRc && fileDao && fileCni && fileLettreType && fileReference && fileStatut) {
          const Contractant = {
            Prenom: this.$store.state.devispayement.devis.details.Contractant.Prenom,
            Nom: this.$store.state.devispayement.devis.details.Contractant.Nom,
            Duree: this.$store.state.devispayement.devis.details.Contractant.Duree,
            Beneficiaire: this.$store.state.devispayement.devis.details.Contractant.Beneficiaire
          }
          let CAUTION = new FormData();
  
          CAUTION.append("devisid", this.Devis_pour_souscription._id);
          CAUTION.append("Prenom", Contractant.Prenom);
          CAUTION.append("Nom", Contractant.Nom);
          CAUTION.append("Duree", Contractant.Duree);
          CAUTION.append("Beneficiaire", Contractant.Beneficiaire);
          CAUTION.append("Montant", this.$store.state.devispayement.devis.details.Montant);
          CAUTION.append("Statut", this.$store.state.devispayement.devis.details.status_juridique);
          CAUTION.append("fileNinea", fileNinea);
          CAUTION.append("fileRc", fileRc);
          CAUTION.append("fileDao", fileDao);
          CAUTION.append("fileCni", fileCni);
          CAUTION.append("fileLettreType", fileLettreType);
          CAUTION.append("fileReference", fileReference);
          CAUTION.append("fileStatut", fileStatut);
  
          Api().post('sonac/push/document', CAUTION, { headers: { "Content-Type": "multipart/form-data" } })
            .then((result) => {
              if (result.data.msg == "OK") {
                if (this.mode_payement == 'mobile_money') {
                  this.payement_om_start()
                  this.dialogFileCaution = false
                }
  
                if (this.mode_payement == 'carte_bancaire') {
                  this.payment_Orabank()
                  this.dialogFileCaution = false
                }
  
                if (this.mode_payement == 'wave') {
                  this.payement_wave_start()
                  this.dialogFileCaution = false
                }
  
                if (this.mode_payement == 'free_money') {
                  this.Gopayment_free()
                  this.dialogFileCaution = false
                }
  
                if (this.mode_payement == 'intouch') {
                  this.payement_intouch_start()
                  this.dialogFileCaution = false
                }
  
                if (this.mode_payement == 'kpay') {
                  this.payement_kpay_start()
                  this.dialogFileCaution = false
                }
              }
            });
        } else {
          this.$toasted.show("Fichiers obligatoires ! ", this.ToastTabError);
        }
      },
  
      goToHome() {
        this.$router.push("/");
      },
      yearsDiffDateDelivre() {
        const date1 = dayjs(this.date_delivrance);
        const date2 = dayjs(this.Devis_pour_souscription.dateDepart);
        let daydiff = date2.diff(date1, "days");
        this.ageDepart = daydiff;
  
        if (this.ageDepart < 0) {
          this.ageDepart = null;
          this.annee_mois = "";
          this.$toasted.show(
            "Erreur, date postérieure à la date de départ! ",
            this.ToastTabError
          );
          this.date_delivrance = null;
        } else if (this.ageDepart <= 29) {
          this.an = this.annee_mois = "jour(s)";
        } else if ((this.ageDepart >= 30, this.ageDepart <= 360)) {
          let year = Math.floor(this.ageDepart / 30);
          this.ageDepart = year;
          this.an = this.annee_mois = "mois";
        } else if (this.date_delivrance >= 360) {
          let year = Math.floor(this.age / 360);
          this.ageDepart = year;
          this.annee = year;
          this.year = this.ageDepart;
          this.an = this.annee_mois = "an(s)";
        }
      },
      yearsDiffDateExpire() {
        const date1 = dayjs(this.date_expiration);
        const date2 = dayjs(this.date_delivrance);
        let daydiff = date2.diff(date1, "days");
  
        this.ageArrivee = daydiff;
  
        if (this.ageArrivee > 0) {
          this.ageArrivee = null;
          this.annee_mois = "";
          this.$toasted.show(
            "Erreur, date postérieure à la date de délivrance! ",
            this.ToastTabError
          );
          this.date_expiration = null;
        }
      },
  
      Detail_info_beneficiaires() {
        if (this.nom && this.prenom && this.adresse) {
          if (this.telephone && this.numero_cni && this.pays && this.genre) {
            let Un_beneficiaire = {
              nom: this.nom,
              prenom: this.prenom,
              adresse: this.adresse,
              telephone: this.telephone,
              numero_cni: this.numero_cni,
              pays: this.pays,
              genre: this.genre,
            };
  
            if (this.tab_perso.length + 1 <= this.maxPersonne) {
              this.tab_perso.push(Un_beneficiaire);
              this.$store.dispatch("setListeBeneficiaire", this.tab_perso);
              this.showValiderBtn = true;
              this.nom = "";
              this.prenom = "";
              this.adresse = "";
              this.telephone = "";
              this.numero_cni = "";
            } else {
              this.$toasted.show(
                "Le nombre maximum de personnes est atteind ! ",
                this.ToastTabError
              );
            }
          } else {
            this.$toasted.show(
              "Tous les (*) sont obligatoires ! ",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Tous les (*) sont obligatoires ! ",
            this.ToastTabError
          );
        }
      },
  
      /**
       * On applique un pourcentage au montant TTC
       * ce pourcentage est supporte par le client et reverse au partenaires
       * upay, intouch, orabank et free
       */
      calculFraisPaiement() {
        /**
         * Orange Money
         * Free Money
         * upay cash
         * wave
         */
        if (
          this.mode_payement == "mobile_money" ||
          this.mode_payement == "free_money" ||
          this.mode_payement == "reseau_partenaire" ||
          this.mode_payement == "wave" || this.mode_payement =="kpay"
        ) {
          let FP = ((this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * 0.01) / (1 - 0.01);
          this.fraisPaiement = Math.round(FP * 100) / 100;
          this.mention_ttc = Math.ceil(this.Devis_pour_souscription.prime_ttc + this.fraisPaiement + this.fraisLiv
          );
        } else if (
          /**
           * OraBank
           * Intouch
           */
          this.mode_payement == "carte_bancaire" ||
          this.mode_payement == "intouch"
        ) {
          let FP =
            ((this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * 0.02) / (1 - 0.02);
          this.fraisPaiement = Math.round(FP * 100) / 100;
          this.mention_ttc = Math.ceil(
            this.Devis_pour_souscription.prime_ttc +
            this.fraisPaiement +
            this.fraisLiv
          );
        } else if (this.mode_payement == "autre_paiement") {
          /**
           * Upay
           *
           */
          let FP =
            ((this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * 0.0125) /
            (1 - 0.0125);
          this.fraisPaiement = Math.round(FP * 100) / 100;
          this.mention_ttc = Math.ceil(
            this.Devis_pour_souscription.prime_ttc +
            this.fraisPaiement +
            this.fraisLiv
          );
        }
      },
  
      calculFraisLiv() {
        let ST = this.mention_ttc;
        //let SN = Math.trunc(this.Devis_pour_souscription.prime_ttc);
        let SN = this.svgTTC;
        let frais = ST - SN;
        this.fraisLiv = frais;
  
        console.log('======================== Frais de livraison =================', this.fraisLiv);
      },
  
      disableExpress() {
        this.disable = true;
      },
  
      enableExpress() {
        this.disable = false;
      },
  
      load: function () {
        this.iframe.loaded = true;
      },
  
      cancelPaiement() {
        this.Popupadresse = false
        this.adresse = false;
        this.mode_livraison = null;
        this.adresselivraison = "";
      },
  
      cancelFree() {
        (this.freepayment = false), (this.mode_livraison = null);
      },
  
      cancelOrab() {
        this.orabankpayment = false;
      },
  
      /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
      onlyNumber($event) {
        let NumOnly = $event.NumOnly ? $event.NumOnly : $event.which;
        if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
          $event.preventDefault();
        }
      },
  
      fetchEventsList() {
        this.Mano = this.Mano - 1;
        if (this.Mano == 0) {
          this.ExitByUser = false;
          //this.$router.push("/"));
        }
      },
  
      isMobile: function () {
        if (screen.width <= 760) {
          return true;
        } else {
          return false;
        }
      },
  
      isTablette() {
        if (screen.width > 425 && screen.width <= 768) {
          return true;
        } else {
          return false;
        }
      },
  
      isDesktop: function () {
        if (screen.width > 768) {
          return true;
        } else {
          return false;
        }
      },
  
      getImgUrl(pic) {
        if (pic) {
          return pic;
        } else {
          return require("../assets/img/assuraf_sm.png");
        }
      },
  
      // Get la liste des pays
      getListePays: function () {
        Api()
          .get("/pays/all")
          .then((response) => {
            this.countries = response.data;
          })
          .catch((err) => {
            err;
          });
      },
  
      showListCity() {
        if (
          this.prix_livraison == "dakar_normal" ||
          this.prix_livraison == "dakar_express"
        ) {
          this.dakar = true;
          this.ville = this.listVille.Dakar;
          this.quartier = null;
        } else if (
          this.prix_livraison == "banlieue_normal" ||
          this.prix_livraison == "banlieue_express"
        ) {
          this.dakar = true;
          this.ville = this.listVille.Banlieue;
          this.quartier = null;
        }
      },
  
      getAdressLivraison: function () {
        let delivery_cost = 0;
  
        if (this.prix_livraison) {
          if (this.prix_livraison == "dakar_normal") {
            this.mention_ttc = parseInt(this.svgTTC) + 1500;
            delivery_cost = 1500;
            this.DeliveryCost = 1500;
          } else if (this.prix_livraison == "dakar_express") {
            this.mention_ttc = parseInt(this.svgTTC) + 2000;
            delivery_cost = 2000;
            this.DeliveryCost = 2000;
          } else if (this.prix_livraison == "banlieue_normal") {
            this.mention_ttc = parseInt(this.svgTTC) + 2000;
            delivery_cost = 2000;
            this.DeliveryCost = 2000;
          } else if (this.prix_livraison == "banlieue_express") {
            this.mention_ttc = parseInt(this.svgTTC) + 2500;
            delivery_cost = 2500;
            this.DeliveryCost = 2500;
          }
          if (this.adresselivraison && this.quartier) {
            localStorage.setItem("adressliv", this.adresselivraison);
            localStorage.setItem("quartier", this.quartier);
            localStorage.setItem("typeLivraison", this.prix_livraison);
            localStorage.setItem("delivery_cost", delivery_cost);
            this.Popupadresse = false;
          } else {
            this.$toasted.show(
              "Adresse de livraison obligatoire ! ",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "veuillez choisir un mode de livraison ! ",
            this.ToastTabError
          );
        }
        this.calculFraisLiv();
        this.calculFraisPaiement();
      },
  
      AddAssistance() {
        if (
          this.horaire &&
          this.canal &&
          this.name &&
          this.tel &&
          this.objetRappel &&
          this.remarques
        ) {
          const assist = {
            horaire: this.horaire,
            canal: this.canal,
            name: this.name,
            tel: this.tel,
            objetRappel: this.objetRappel,
            remarques: this.remarques,
            userid: store.state.user._id,
          };
  
          let Gtm2 = {
            branche: this.GtmAssistanceVal.branche,
            schedule: this.horaire,
            insurer_name: this.GtmAssistanceVal.insurer_name,
            step: 2,
            price: this.devis_price,
            channel: this.canal,
            event: "receive_call_step2",
          };
  
          Api()
            .post("assistances/create", assist)
            .then((resp) => {
              PushInDataLayer(Gtm2);
              if (resp.data.info == "ok") {
                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                this.assistanceDialog = false;
                this.horaire = "";
                this.canal = "";
                this.name = "";
                this.tel = "";
                this.objetRappel = "";
                this.remarques = "";
              } else if (resp.data.info == "nok") {
                this.$toasted.show(resp.data.msg, this.ToastTabError);
              }
            });
        } else {
          this.$toasted.show(
            "Tous les champs sont obligatoires !",
            this.ToastTabError
          );
        }
      },
  
      devisParMail: function (params) {
        Api()
          .get("devis/mydevisbyemail/" + params._id)
          .then((response) => {
            this.notifDeviParMail = response.data.info;
            console.log('send devis par email', response)
          });
      },
  
      // chargement du popup pour les infos de payement avec UPAY
      payement_start: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
            if (this.Devis_pour_souscription.brancheid.branche == 'Voyage') {
              if (this.passagerIsOk != true) {
                this.dialogInfoPassager = true
              } else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Upay");
                getUpay(this.mention_ttc, this.mode_payement);
              }
            } else if (this.Devis_pour_souscription.brancheid.branche == 'Santé') {
              if (this.assureIsOk != true) {
                //this.dialogInfoAssure = true
                this.getBeneficiaries(store.state.user._id)
              } else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Upay");
                getUpay(this.mention_ttc, this.mode_payement);
              }
            } else {
              this.begin_checkoutPushin();
              let montant = this.mention_ttc;
              localStorage.setItem("amount", montant);
              let numDevis = this.Devis_pour_souscription.numeroDevis;
              localStorage.setItem("numdevis", numDevis);
              localStorage.setItem("canal", "Upay");
              getUpay(this.mention_ttc, this.mode_payement);
            }
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      payment_free: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
  
            if (this.Devis_pour_souscription.brancheid.branche == 'Voyage') {
              if (this.passagerIsOk != true) {
                this.dialogInfoPassager = true
              } else {
                this.freepayment = true;
              }
            } else if (this.Devis_pour_souscription.brancheid.branche == 'Santé') {
              if (this.assureIsOk != true) {
                //this.dialogInfoAssure = true
                this.getBeneficiaries(store.state.user._id)
              } else {
                this.freepayment = true;
              }
            } else {
              this.freepayment = true;
            }
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      /*================ Debut de la Transaction par Free Money =======================*/
      Gopayment_free: function () {
        localStorage.setItem("numdevis", this.Devis_pour_souscription.numeroDevis);
        localStorage.setItem("amount", this.mention_ttc);
        localStorage.setItem("canal", "FreeMoney");
        this.begin_checkoutPushin();
        this.snipperfree = true;
        FreeMoneyApi(this.mention_ttc, this.Devis_pour_souscription.numeroDevis, this.numTelephone)
      },
  
      payment_Orabank: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
            if (this.Devis_pour_souscription.brancheid.branche == 'Voyage') {
              if (this.passagerIsOk != true) {
                this.dialogInfoPassager = true
              } else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Orabank");
                getOrabank(this.mention_ttc, this.mode_payement);
              }
            } else if (this.Devis_pour_souscription.brancheid.branche == 'Santé') {
              if (this.assureIsOk != true) {
                //this.dialogInfoAssure = true
                this.getBeneficiaries(store.state.user._id)
              } else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Orabank");
                getOrabank(this.mention_ttc, this.mode_payement);
              }
            } else {
              this.begin_checkoutPushin();
              let montant = this.mention_ttc;
              localStorage.setItem("amount", montant);
              let numDevis = this.Devis_pour_souscription.numeroDevis;
              localStorage.setItem("numdevis", numDevis);
              localStorage.setItem("canal", "Orabank");
              getOrabank(this.mention_ttc, this.mode_payement);
            }
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      // chargement du popup pour les infos de payement avec inTouch
      payement_intouch_start: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
            if (this.Devis_pour_souscription.brancheid.branche == 'Voyage') {
              if (this.passagerIsOk != true) {
                this.dialogInfoPassager = true
              } else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "inTouch");
                inTouch(this.mention_ttc, this.mode_payement);
              }
            } else if (this.Devis_pour_souscription.brancheid.branche == 'Santé') {
              if (this.assureIsOk != true) {
                //this.dialogInfoAssure = true
                this.getBeneficiaries(store.state.user._id)
              } else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "inTouch");
                inTouch(this.mention_ttc, this.mode_payement);
              }
            } else {
              this.begin_checkoutPushin();
              let montant = this.mention_ttc;
              localStorage.setItem("amount", montant);
              let numDevis = this.Devis_pour_souscription.numeroDevis;
              localStorage.setItem("numdevis", numDevis);
              localStorage.setItem("canal", "inTouch");
              inTouch(this.mention_ttc, this.mode_payement);
            }
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      open_payment_om() {
        if (this.mode_payement) {
          if (this.mode_livraison) {
            this.choixOrangeMoneyPopup = true
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      payement_om_start: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
            if (this.choixOrangeMoney) {
              if (this.Devis_pour_souscription.brancheid.branche == 'Voyage') {
                if (this.passagerIsOk != true) {
                  this.dialogInfoPassager = true
                } else {
                  this.begin_checkoutPushin();
                  let montant = this.mention_ttc;
                  localStorage.setItem("amount", montant);
                  let numDevis = this.Devis_pour_souscription.numeroDevis;
                  localStorage.setItem("numdevis", numDevis);
                  localStorage.setItem("canal", "Orange Money");
                  this.choixOrangeMoneyPopup = false
                  this.PopupOM = true // getOm(this.mention_ttc, this.mode_payement);
                }
  
              } else if (this.Devis_pour_souscription.brancheid.branche == 'Santé') {
                if (this.assureIsOk != true) {
                  //this.dialogInfoAssure = true
                  this.getBeneficiaries(store.state.user._id)
                } else {
                  this.begin_checkoutPushin();
                  let montant = this.mention_ttc;
                  localStorage.setItem("amount", montant);
                  let numDevis = this.Devis_pour_souscription.numeroDevis;
                  localStorage.setItem("numdevis", numDevis);
                  localStorage.setItem("canal", "Orange Money");
                  this.choixOrangeMoneyPopup = false
                  this.PopupOM = true // getOm(this.mention_ttc, this.mode_payement);
                }
              } else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                //let montant = 100;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Orange Money");
                this.PopupOM = true // getOm(this.mention_ttc, this.mode_payement);
                this.choixOrangeMoneyPopup = false
              }
            }
  
  
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      payement_wave_start: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
            if (this.Devis_pour_souscription.brancheid.branche == 'Voyage') {
              if (this.passagerIsOk != true) {
                this.dialogInfoPassager = true
              } else {
                let montant = this.mention_ttc;
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("amount", montant);
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Wave");
                wavepayment(this.mention_ttc, this.Devis_pour_souscription.numeroDevis)
              }
            } else if (this.Devis_pour_souscription.brancheid.branche == 'Santé') {
              if (this.assureIsOk != true) {
                //this.dialogInfoAssure = true
                this.getBeneficiaries(store.state.user._id)
              } else {
                let montant = this.mention_ttc;
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("amount", montant);
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Wave");
                wavepayment(this.mention_ttc, this.Devis_pour_souscription.numeroDevis)
              }
            } else {
              let montant = this.mention_ttc;
              let numDevis = this.Devis_pour_souscription.numeroDevis;
              localStorage.setItem("amount", montant);
              localStorage.setItem("numdevis", numDevis);
              localStorage.setItem("canal", "Wave");
              wavepayment(this.mention_ttc, this.Devis_pour_souscription.numeroDevis)
            }
          } else {
            this.$toasted.show("Mode livraison obligatoire !", this.ToastTabError);
          }
        } else {
          this.$toasted.show("Mode de payement obligatoire !", this.ToastTabError);
        }
      },
  
      telecharger_le_devis: function (params) {
        this.dialogLoading = true;
        Api()
          .get("devis/download/" + params._id)
          .then((response) => {
            let url = response.data.lien;
            let WinOpener = null
            this.dialogLoading = false, WinOpener = window.open(), WinOpener.location = url
          })
      },
  
      assistanceDialogManip(devis) {
        this.devis_price = devis.prime_ttc;
        this.GtmAssistanceVal.branche = devis.brancheid.branche.toLowerCase();
        this.GtmAssistanceVal.insurer_name = devis.partenaireid.societe;
        this.GtmAssistanceVal.step = 1;
        this.GtmAssistanceVal.event = "receive_call_step1";
  
        PushInDataLayer(this.GtmAssistanceVal);
  
        this.objetRappel = "Devis : " + devis.numeroDevis;
        this.name =
          store.state.user.prenom.toUpperCase() +
          "-" +
          store.state.user.nom.toUpperCase();
        this.tel = store.state.user.telephone_port;
        this.assistanceDialog = true;
      },
  
      //  Ancienne fonction pour formattage de Date (:-)
      DateFormater: function (TheDate) {
        if (TheDate) {
          return dayjs(TheDate).format("DD-MM-YYYY");
        }
      },
  
      //Fonction permettant de fermer le popup liste passager et declencher popup Upay
      PayementSpecialVoyage() {
        this.dialogInfoPassager = false;
        getUpay(this.mention_ttc, this.mode_payement);
      },
  
      ManipPaiement() {
        if (this.$store.state.devispayement.devis.brancheid.branche == "Santé") {
          const data = {
            devisid: this.Devis_pour_souscription._id,
            listPassager: this.tab_perso,
          };
  
          Api()
            .post("/devis/voyage/setpassenger", data)
            .then((result) => {
              if (result.data.status == 1) {
                this.showPopUpBeneficiaireSante = false;
                this.showPopUpBeneficiaireExistantSante = false
              } else {
                this.$toasted.show(resp.data.msg, this.ToastTabError);
              }
            })
            .catch((err) => { });
        }
        else {
          const data = {
            userid: store.state.user._id,
            devisid: this.Devis_pour_souscription._id,
            listPassager: this.tableau_info_passager,
          };
  
  
              //console.log(':::::::::: resultat passport ::::::::::::', result.data)
              // if (result.data.status == 1) {
              //   (this.dialogInfoPassager = false), (this.passagerIsOk = true), (this.showPaymentBLock = true);
              //   this.saveUserPassport()
              // } else {
              //   this.$toasted.show(result.data.msg, this.ToastTabError);
              // }
  
          Api()
            .post("/devis/voyage/setpassenger", data)
            .then((result) => {
              if (result.data.msg == "Enregistrement réussi !") {
                (this.dialogInfoPassager = false), (this.passagerIsOk = true), (this.showPaymentBLock = true);
                this.saveUserPassport()
              } else {
                this.$toasted.show(result.data.msg, this.ToastTabError);
              }
            })
            .catch((err) => { });
        }
      },
  
      payement_end() {
        this.begin_checkoutPushin();
        store.dispatch("setOrderId", "IDO17102019-CNM");
        store.dispatch("setmodePaiement", this.mode_payement);
        this.$router.go(
          this.$router.push(
            "/payement/succes/?amanpay=1&apsuccess=1&aporderid=900032-78c8507&aptrxid=33778037902240883"
          )
        );
      },
  
      Detail_info_passager() {
        if (
          this.nom_passager &&
          this.prenom_passager &&
          //this.nationalite_passager &&
          this.num_passager
        ) {
          if (
            this.numero_ci_passager &&
            this.date_delivrance &&
            this.date_expiration &&
            this.dateNaissance
            //this.genre
          ) {
  
            if(this.genre)  {
              let Un_passager = {
              nom_passager: this.nom_passager,
              prenom_passager: this.prenom_passager,
              num_passager: this.num_passager,
              nationalite_passager: this.nationalite_passager,
              numero_ci_passager: this.numero_ci_passager,
              dateNaissance: this.dateNaissance,
              date_delivrance: this.date_delivrance,
              date_expiration: this.date_expiration,
              genre: this.genre,
            };
  
            if (this.nbPassager > 0) {
              this.tableau_info_passager.push(Un_passager);
              /*this.nom_passager = "";
              this.prenom_passager = "";
              this.num_passager = "";
              this.nationalite_passager = "";
              this.numero_ci_passager = "";
              this.date_delivrance = "";
              this.date_expiration = "";
              this.genre = "";*/
            }
  
            this.nbPassager = this.nbPassager - 1;
            if (this.nbPassager === 0) {
              this.$store.dispatch(
                "setListeBeneficiaire",
                this.tableau_info_passager
              );
              localStorage.setItem(
                "BeneficiaireArray",
                JSON.stringify(this.tableau_info_passager)
              );
              this.continue_btn = true;
            }
            }else {
              this.$toasted.show(
              "Le genre est obligatoire! ",
              this.ToastTabError
            );
            }
          } else {
            this.$toasted.show(
              "Tous les (*) sont obligatoires ! ",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Tous les (*) sont obligatoires ! ",
            this.ToastTabError
          );
        }
      },
  
      add_shipping_infoPushing() {
        let itemPushing = {
          event: "add_shipping_info",
          ecommerce: {
            shipping_tier: this.mode_livraison,
            items: this.addedInTheCard.ecommerce.items,
          },
        };
        PushInDataLayer(itemPushing);
      },
  
      /*=============================================================*/
      /*Prepare purchase data to Push purchase event in the dataLayer*/
      /*=============================================================*/
      purchasePushinPreparation() {
        let value =
          this.addedInTheCard.ecommerce.items[0].price +
          Math.round(this.DeliveryCost / 655.957);
        this.addedInTheCard.ecommerce.items[0].item_coupon = "";
  
        let purchasePushin = {
          event: "purchase",
          ecommerce: {
            transaction_id: null,
            affiliation: "",
            value: value,
            tax: Math.round(this.Devis_pour_souscription.taxe / 655.957),
            shipping: Math.round(this.DeliveryCost / 655.957),
            currency: "EUR",
            coupon: "",
            items: this.addedInTheCard.ecommerce.items,
          },
        };
        localStorage.setItem("purchasePushin", JSON.stringify(purchasePushin));
      },
  
      add_payment_infoPushing(Payment_Type) {
        let itemPushing = {
          event: "add_payment_info",
          ecommerce: {
            payment_type: Payment_Type,
            items: this.addedInTheCard.ecommerce.items,
          },
        };
        PushInDataLayer(itemPushing);
      },
  
      /*************************************************/
      /*Push begin_checkout Data and event to DataLayer*/
      /*************************************************/
      begin_checkoutPushin() {
        let itemPushing = {
          event: "begin_checkout",
          ecommerce: {
            items: this.addedInTheCard.ecommerce.items,
          },
        };
        PushInDataLayer(itemPushing);
      },
  
      SetBeneficiarieToUpdate(item) {
        this.TheBeneficiarie = item
        this.editBeneficiarieDialog = true
        this.myBeneficiarieList = false
      },
  
      UpdateBeneficiarie() {
        const data = this.TheBeneficiarie
        if (data.nom != null && data.nom != "") {
          if (data.prenom != null && data.prenom != "") {
            if (data.datenaissance != null && data.datenaissance != "") {
              if (data.genre != null) {
                if (data.userid != null && data.userid != "") {
                  data.datenaissance = dayjs(data.datenaissance).format("YYYY-MM-DD")
                  data.id = data._id
                  Api().post("beneficiaries/update", data)
                    .then(resp => {
                      this.editBeneficiarieDialog = false
                      this.myBeneficiarieList = true
                      this.getBeneficiaries(data.userid)
                      if (resp.data.nModified == 1) {
                        this.$toasted.show('Le bénéficiaire a été mis à jour !', this.ToastTabSucess);
                      } else {
                        this.$toasted.show('Le mis à jour du bénéficiaire a échoué  !', this.ToastTabError);
                      }
                    }).catch((err) => {
                      console.log(err)
                    })
                } else {
  
                }
              } else {
                this.$toasted.show('Le genre du béneficiaire est obligatoire !', this.ToastTabError);
              }
            } else {
              this.$toasted.show('La date de naissance du béneficiaire est obligatoire !', this.ToastTabError);
            }
          } else {
            this.$toasted.show('Le prénom du béneficiaire est obligatoire !', this.ToastTabError);
          }
        } else {
          this.$toasted.show('Le nom du béneficiaire est obligatoire !', this.ToastTabError);
        }
      },
  
      DeleteBeneficiarie(item) {
        if (item._id && item._id != null && item._id != "") {
          item.id = item._id
          Api().post("beneficiaries/delete", item)
            .then(resp => {
              this.editBeneficiarieDialog = false
              this.getBeneficiaries(item.userid)
              if (resp.data.deletedCount == 1) {
                this.$message.success('Le bénéficiaire a été supprimé !', this.AlertMessage)
              } else {
                this.$message.error('La suppression du bénéficiaire a échoué !', this.AlertMessage)
              }
            }).catch((err) => {
              console.log(err)
            })
        }
      },
  
      getBeneficiaries(id) {
        Api().post("beneficiaries/getone", { userid: id })
          .then((result) => {
            this.tableau_info_passager = result.data.beneficiaries
            this.tab_perso = result.data.beneficiaries
            this.showPopUpBeneficiaireExistantSante = true
          }).catch((err) => {
            console.log(err)
          });
      },
  
      async saveOneBeneficiaries(benef) {
        const benef_dt = {
          userid: benef.userid,
          nom: benef.nom,
          prenom: benef.prenom,
          genre: benef.age,
          age: benef.age,
          datenaissance: benef.datenaissance,
          numero_cni: benef.numero_cni,
          pays: benef.pays,
          adresse: benef.adresse,
          telephone: benef.telephone,
        }
        const returner = await Api().post("beneficiaries/create", benef_dt)
      },
      checkCodeReductionForDevis(){
                  let devis = this.$store.state.devispayement.devis;
                  let CouponReductionData = {
                      coupon_code : null,
                      brancheid: devis.brancheid._id,
                      partenaireid : devis.partenaireid._id,
                      courtierid: null,
                      numero_police: devis.numeroDevis,
                      dateSouscription : devis.dateSouscription,
                      code_partenaire: devis.codep,
                      prime_ttc : devis.prime_ttc,
                      plateforme : "Front",
                      clientid : this.$store.state.user._id,
                      dateEffet : devis.dateEffet
                  }
  
                  Api().post("coupons/check/reduction", CouponReductionData)
                    .then((result) => {
                      if(result.data.status == true){
                          this.showReduction = true;
                          this.shownTextReduction = true;
                          let typeReductionType = result.data.coupon.type
                          this.Devis_pour_souscription.prime_ttc = result.data.prime_ttc
                          this.prime_ttc_before_reduc = result.data.prime_avant
                          this.reductionMount = result.data.coupon.reduction
  
                          if (typeReductionType == 'pourcentage') {
                        this.typeReduction = '%';
                        //showTypeReductionPourcent = true;
                      } else {
                        this.typeReduction = 'FCFA';
                        //showTypeReductionValeur = true;
                      }
                          this.$toasted.show("Coupon appliqué avec succés !", this.ToastTabSucess)
                          this.calculFraisPaiement()
                        
                      }
                    }).catch((err) => {
                      this.showReduction = false;
                      //this.hideCoupon = false
                      //this.prime_ttc_before_reduc = this.Devis_pour_souscription.prime_ttc
                      this.shownTextReduction = false
                    })
              },
  
    },
  
    beforeDestroy() {
      this.purchasePushinPreparation();
      if (this.ExitByUser == true) {
        clearInterval(this.timer);
      } else {
        clearInterval(this.timer);
      }
    },
  
    watch: {
      notifDeviParMail: function () {
        if (this.notifDeviParMail == "ok") {
          this.$toasted.show(
            "Votre devis vous a été envoyé par mail",
            this.ToastTabSucess
          );
        } else {
          this.$toasted.show(
            "Le devis n'a pas pu être envoyé par mail",
            this.ToastTabError
          );
        }
      },
  
      mode_payement: function (val) {
        let PayType = "";
        switch (val) {
          case "mobile_money":
            PayType = "Orange Money";
            break;
          case "free_money":
            PayType = "Free Money";
            break;
          case "carte_bancaire":
            PayType = "Carte Bancaire";
            break;
          case "intouch":
            PayType = "Intouch";
            break;
          case "autre_paiement":
            PayType = "Autres paiements mobile";
            break;
        }
        this.add_payment_infoPushing(PayType);
      },
  
      mode_livraison: function () {
        this.add_shipping_infoPushing();
        this.mention_ttc = parseInt(this.svgTTC);
  
        if (this.mode_livraison == "a_domicile") {
          this.adresse = true;
          this.prix_livraison = null;
        } else if (this.mode_livraison == "reseau_partenaire") {
          this.mention_ttc = parseInt(this.svgTTC) + 500;
          localStorage.removeItem("adressliv");
  
        } else if (this.mode_livraison == "locaux_assuraf" || this.mode_livraison == "talon_auto_digital") {
          this.mention_ttc = parseInt(this.svgTTC);
          localStorage.removeItem("adressliv");
        }
        this.calculFraisLiv();
        this.calculFraisPaiement();
      }
  
  
    },
  
    mounted() {
      window.scrollTo(0, 0);
      this.checkToken()
      this.getListePays();
      this.getUserPassport()
  
      setTimeout(() => {
                          this.checkCodeReductionForDevis()
                        }, 3000)
  
      if (this.$store.state.user && this.$store.state.devispayement !== null) {
        this.wave_nom_prenom = this.$store.state.user.nom + " - " + this.$store.state.user.prenom
        this.mention_ttc = this.$store.state.devispayement.devis.prime_ttc;
        this.svgTTC = this.$store.state.devispayement.devis.prime_ttc;
        this.Devis_pour_souscription = this.$store.state.devispayement.devis;
        this.branche = this.$store.state.devispayement.devis.brancheid.branche;
        let view_itemPushing = {
          event: "add_to_cart",
          ecommerce: {
            items: [
              {
                item_name: "Assurance " + this.branche.toLowerCase(),
                item_id: this.Devis_pour_souscription.numeroDevis,
                price: Math.ceil(this.mention_ttc / 650),
                item_brand: this.Devis_pour_souscription.partenaireid.societe,
                item_category: this.branche,
                item_list_name: localStorage.getItem("item_list_name"),
                index: 1,
                quantity: "1",
              },
            ],
          },
        };
  
        this.addedInTheCard = view_itemPushing;
  
        if (document.readyState == "complete") {
          PushInDataLayer(view_itemPushing);
        }
  
        if (this.$store.state.devispayement.devis.brancheid.branche == "Automobile") {
          for (let index = 0; index < this.Devis_pour_souscription.vehicules.length; index++) {
            this.listegaranties.push(this.Devis_pour_souscription.vehicules[index].garanties);
            this.mode_livraison = "talon_auto_digital"
          }
        } else {
          this.listegaranties = this.Devis_pour_souscription.garanties;
        }
        if (this.$store.state.devispayement.devis.brancheid.branche == "Voyage") {
          this.nbPassager = this.$store.state.devispayement.devis.nbpassager;
          //this.dialogInfoPassager = true;
          this.passenger_birthady_age = JSON.parse(localStorage.getItem("passenger-birthady-age"));
          this.dateNaissance = this.passenger_birthady_age.dateNaissance;
        }
  
        if (this.$store.state.devispayement.devis.brancheid.branche == "Santé") {
          this.NombreFemme = this.Devis_pour_souscription.details_pack_sante.assures.Adulte.Femme;
          this.NombreHomme = this.Devis_pour_souscription.details_pack_sante.assures.Adulte.Homme;
          this.NombreGarcon = this.Devis_pour_souscription.details_pack_sante.assures.Enfant.Garcon;
          this.NombreFille = this.Devis_pour_souscription.details_pack_sante.assures.Enfant.Fille;
          this.NombreSeniorHomme = this.Devis_pour_souscription.details_pack_sante.assures.Senior.Homme;
          this.NombreSeniorFemme = this.Devis_pour_souscription.details_pack_sante.assures.Senior.Femme;
          if (this.$store.state.devispayement.devis.partenaireid.societe == "KERMEL") {
            this.maxPersonne = this.$store.state.devispayement.devis.details_pack_sante.packChoisis[0].nb_personne_max;
            this.showPopUpBeneficiaireSante = true;
          }
        }
        this.Mano = 20;
      } else {
        this.$router.push("/");
      }
    },
  };
  </script>
  
  <style lang="less" scoped>
  @import "../assets/css/liste_devis.css";
  @import "../assets/css/liste_devis_button.css";
  @import "../assets/css/devis_css.css";
  // @import "../assets/css/payment.css";
  
  .paymentwalelet-container {
      width: 100%;
      margin-left: 1px
    }
    
    .resentotp-btn{
      color: #ffa409 !important;
      margin-left: 1%;
      margin-top: 2%;
    }
    
    .action_btn {
      color: #ffa409 !important
    }
    
    /* .row-container {
        background: white;
    } */
    ::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      font-size: 15px;
    }
    
    .to-top {
      margin-top: -5%;
    }
    
    .to-left {
      text-align: left;
    }
    
    .to-right {
      float: right;
      padding-left: 50px;
    }
    
    .to-right-mobile {
      float: right;
      margin-right: 2%;
    }
    
    .to-right-tablet {
      float: right;
      font-size: 12px;
    }
    
    .to-left span {
      color: black;
      font-weight: bold;
    }
    
    .table-donnees {
      border-collapse: collapse;
    }
    
    .table-donnees tr td {
      border: 1px solid lightgrey !important;
    }
    
    .List-cout li {
      list-style: none;
    }
    
    .list-boutons li {
      list-style: none;
    }
    
    .logo-assureur {
      border: 1px solid lightgrey;
    }
    
    .right--texting {
      text-align: right;
    }
    
    .right--texting ul li .col-lg-6:hover {
      background: #ffa409;
      color: white;
      text-decoration: none;
    }
    
    .answer {
      position: relative;
      margin-right: 0;
      float: left;
      display: block;
      margin-right: 2.12766%;
      width: 100%;
    }
    
    .highlight {
      padding: 6px 12px;
      display: -ms-flexbox;
      display: flex;
      position: relative;
      font-size: 0.0625rem;
      cursor: pointer;
      color: #6d6d6d;
      border: solid 1px transparent;
      border-bottom: solid 1px #e9e9e9;
      border-radius: 3px;
      transition: background 0.4s;
    }
    
    .highlight:hover {
      background-color: rgba(255, 164, 9, 0.3);
      padding-left: 10px;
      transition-duration: 0.5s;
    }
    
    ul li {
      list-style: none;
      padding-top: 7px;
    }
    
    .container {
      padding: 0px !important;
    }
    
    .uppercase {
      font-weight: bold;
      color: #ffa409;
      text-transform: uppercase;
      font-size: 16px;
    }
    
    .head {
      background-color: rgb(91, 148, 188);
      color: white;
      font-size: 18px;
    }
    
    .selectatMobile {
      background: url(https://) no-repeat right;
      -webkit-appearance: none;
      background-position-x: 95%;
      border-bottom: 1px solid gray;
    }
    
    .selectatDesktop {
      background: url(https://) no-repeat right;
      -webkit-appearance: none;
      background-position-x: 90%;
      border-bottom: 1px solid gray;
    }
    
    .georgia {
      font-family: Georgia !important;
    }
    
    .border-radius {
      border-radius: 20px !important;
    }
    
    .card-desktop {
      height: 150px !important;
      width: 150px !important;
    }
    
    .form .plan input,
    .form .payment-plan input,
    .form .payment-type input {
      display: none;
    }
    
    .form label {
      /* margin-top: 15px; */
      width: 120px;
      position: relative;
      color: #333;
      font-family: Georgia !important;
      border-radius: 20px !important;
      background-color: #fff;
      font-size: 15px;
      text-align: center;
      height: 120px;
      display: block;
      cursor: pointer;
      border: 3px solid transparent;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
    
    .form .plan input:checked+label,
    .form .payment-plan input:checked+label,
    .form .payment-type input:checked+label {
      border-radius: 20px !important;
      background-color: #ffa409;
      color: #fff;
    }
    
    .form .plan input:checked+label:after,
    form .payment-plan input:checked+label:after,
    .form .payment-type input:checked+label:after {
      content: "\2713";
      width: 40px;
      height: 40px;
      line-height: 40px;
      border-radius: 100%;
      border: 2px solid #ffa409;
      background-color: #fff;
      color: #ffa409;
      z-index: 999;
      position: absolute;
      top: -10px;
      right: -10px;
    }
    
    /*================== CSS SELECT GLOBAL AUTO===================*/
    /* Reset Select */
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      appearance: none;
      outline: 0;
      box-shadow: none;
    
      background: #fff;
    }
    
    /* Remove IE arrow */
    select::-ms-expand {
      display: none;
    }
    
    select {
      flex: 1;
      padding: 0 0.5em;
      color: grey;
      cursor: pointer;
    }
    
    /*================== CSS SELECT DESKTOP AUTO===================*/
    /* Custom Select */
    .select {
      position: relative;
      display: flex;
      width: 100%;
      height: 3em;
      line-height: 3;
      background: #fff;
      overflow: hidden;
      border: 2px solid #d3d3d3 !important;
      border-radius: 35px;
    }
    
    /* Arrow */
    .select::after {
      content: "\2228";
      position: absolute;
      top: 0;
      right: 0;
      padding: 0 1em;
      background: #fff;
      cursor: pointer;
      pointer-events: none;
      -webkit-transition: 0.25s all ease;
      -o-transition: 0.25s all ease;
      transition: 0.25s all ease;
    }
    
    /* Transition */
    .select:hover::after {
      color: #f39c12;
    }
    
    /*css popup Free*/
    
    .containerP {
      margin-top: 15px;
      font-family: PT Sans, sans-serif;
      font-size: 18px;
      max-width: 500px;
      height: 500px;
      background: white;
      border-radius: 9px;
      overflow: hidden;
    }
    
    .icing,
    .dough {
      float: left;
      padding: 20px;
      box-sizing: border-box;
      height: 100%;
      display: -webkit-box;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      flex-direction: column;
      text-align: center;
    }
    
    .icing {
      width: 33%;
      position: relative;
      padding-right: 24px;
      background: -webkit-gradient(linear,
          left top,
          right top,
          from(#ffa409),
          color-stop(100%, #6c757d));
      background: linear-gradient(to right, #ffa409 100%, #6c757d 80%);
      color: white;
    }
    
    .icing:before {
      content: "";
      width: 36px;
      height: 36px;
      display: block;
      position: absolute;
      top: -18px;
      right: -7.2px;
      z-index: 1;
    }
    
    .dough {
      width: 67%;
      padding-left: 36px;
      color: black;
    }
    
    .order {
      -webkit-box-flex: 1;
      flex-grow: 1;
      /* padding: 20px 0;
            margin: 20px 0; */
      border: 1px solid white;
      border-color: white transparent;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
    }
    
    .order li {
      display: -webkit-box;
      display: flex;
      -webkit-box-pack: justify;
      justify-content: space-between;
      text-align: center;
    }
    
    h2 {
      font-size: 1.2em;
    }
    
    .total {
      font-size: 22px;
      text-align: center;
      font-weight: bold;
    }
    
    .inputs {
      -webkit-box-flex: 1;
      flex-grow: 1;
    }
    
    .rowFree {
      width: 100%;
      display: -webkit-box;
      display: flex;
      -webkit-box-align: end;
      align-items: flex-end;
      margin-bottom: 6px;
    }
    
    .rowFreeMobile {
      /* width: 100%; */
      display: -webkit-box;
      display: flex;
      -webkit-box-align: end;
      align-items: flex-end;
      margin-bottom: 6px;
    }
    
    .column {
      width: 100%;
    }
    
    .column:not(:last-child) {
      margin-right: 10px;
    }
    
    .label,
    .text-input {
      float: left;
      display: block;
      clear: both;
    }
    
    .label {
      font-size: 0.8em;
      margin-bottom: 0.2em;
    }
    
    .text-input {
      box-sizing: border-box;
      width: 90%;
      padding: 10px;
      font-size: 1em;
      font-family: inherit;
      background: white;
      border: 1px solid #ffa409;
      border-radius: 5px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) inset;
    }
    
    .name-group {
      -webkit-box-flex: 1;
      flex-grow: 1;
      flex-basis: 200px;
    }
    
    .order-button {
      padding: 10px 20px;
      width: 100%;
      box-sizing: border-box;
      font-size: 13px;
      font-family: inherit;
      color: inherit;
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid rgba(144, 81, 14, 0.3);
      box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
      border-radius: 5px;
      -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
      transition: background 0.1s, color 0.1s, border-color 0.1s;
    }
    
    .buttonFRMobile {
      padding: 10px 20px;
      width: 100%;
      box-sizing: border-box;
      font-size: 13px;
      font-family: inherit;
      color: inherit;
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid rgba(144, 81, 14, 0.3);
      box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
      border-radius: 5px;
      -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
      transition: background 0.1s, color 0.1s, border-color 0.1s;
    }
    
    .order-button:hover {
      background: #ffa409;
      color: white;
      border-color: transparent;
    }
    
    .policeLato {
      font-family: Lato, "Helvetica Neue", Arial, sans-serif;
    }
    
    /*
    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
      position: absolute;
      left: -9999px;
    }
    [type="radio"]:checked + label,
    [type="radio"]:not(:checked) + label {
      position: relative;
      padding-left: 28px;
      cursor: pointer;
      line-height: 20px;
      display: inline-block;
      color: #666;
    }
    [type="radio"]:checked + label:before,
    [type="radio"]:not(:checked) + label:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 18px;
      height: 18px;
      border: 1px solid #ddd;
      border-radius: 100%;
      background: #fff;
    }
    [type="radio"]:checked + label:after,
    [type="radio"]:not(:checked) + label:after {
      content: "";
      width: 12px;
      height: 12px;
      background: #ffa409;
      position: absolute;
      top: 4px;
      left: 4px;
      border-radius: 100%;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }
    [type="radio"]:not(:checked) + label:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    [type="radio"]:checked + label:after {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }*/
    
    
    
    
    
    
    
    .container_forma {
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
    
    .file-upload-wrapper {
      border: 1px solid #d9dee3;
      border-radius: 5px;
      position: relative;
      width: 100%;
      height: 55px;
    }
    
    .file-upload-wrapper:after {
      content: attr(data-text);
      font-size: 18px;
      position: absolute;
      top: 0;
      left: 0;
      background: #fff;
      padding: 10px 15px;
      display: block;
      width: calc(100% - 40px);
      pointer-events: none;
      z-index: 20;
      height: 40px;
      line-height: 40px;
      color: #999;
      border-radius: 5px 10px 10px 5px;
      font-weight: 300;
    }
    
    .file-upload-wrapper:before {
      content: 'Ajouter';
      position: absolute;
      top: -1px;
      right: -2px;
      display: inline-block;
      height: 55px;
      background: #acabab;
      color: #fff;
      font-weight: 700;
      z-index: 25;
      font-size: 16px;
      line-height: 60px;
      padding: 0 15px;
      text-transform: capitalize;
      pointer-events: none;
      border-radius: 0 5px 5px 0;
    }
    
    .file-upload-wrapper:hover:before {
      background: #ffa409;
    }
    
    .file-upload-wrapper input {
      opacity: 0;
      border: 2px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 99;
      height: 40px;
      margin: 0;
      padding: 0;
      display: block;
      cursor: pointer;
      width: 100%;
    }
    
    
    
    
    
    
    
    .middle {
      width: auto;
      text-align: center;
      /* Made by */
    }
    
    .middle h1 {
      font-family: "Inter", sans-serif;
      color: #fff;
    }
    
    .middle input[type="radio"] {
      display: none;
    }
    
    .middle input[type="radio"]:checked+.box {
      background-color: rgba(255, 164, 9, 0.07);
      transition: all .33s ease;
      border: 2px solid #ffa409;
      color: #29323a;
    }
    
    .middle input[type="radio"]:checked+.box span {
      color: #29323a;
      transform: translateY(70px);
    }
    
    .middle input[type="radio"]:checked+.box span:before {
      transform: translateY(0px);
      opacity: 1;
    }
    
    .middle .box {
      width: 220px;
      height: 150px;
      border-radius: 12px;
      background-color: #fff;
      transition: all 250ms ease;
      will-change: transition;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      position: relative;
      box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
      font-size: 10px;
      border: 1px solid #d9dee3;
      font-family: Open Sans, sans-serif;
      font-weight: 900;
    }
    
    .middle .box:hover {
      background-color: rgba(255, 164, 9, 0.07);
      transition: all .33s ease;
      border: 2px solid #ffa409;
    }
    
    .middle .box:hover span {
      color: #29323a;
    }
    
    .middle .box:active {
      transform: translateY(10px);
    }
    
    .middle .box span {
      position: absolute;
      transform: translate(0, 60px);
      left: 0;
      right: 0;
      padding-top: 15%;
      transition: all 300ms ease;
      font-size: 1.5em;
      user-select: none;
      color: #29323a;
    }
    
    .middle .box span:before {
      font-size: 1.2em;
      font-family: FontAwesome;
      display: block;
      transform: translateY(-80px);
      opacity: 0;
      transition: all 300ms ease-in-out;
      font-weight: normal;
      color: #fff;
    }
    
    .middle p {
      color: #fff;
      font-family: "Inter", sans-serif;
      font-weight: 400;
    }
    
    .middle p a {
      text-decoration: underline;
      font-weight: bold;
      color: #fff;
    }
    
    .middle p span:after {
      content: "\f0e7";
      font-family: FontAwesome;
      color: yellow;
    }
    
    
    /*== common styles for both parts of tool tip ==*/
    .tool::before,
    .tool::after {
      left: 50%;
      opacity: 0;
      position: absolute;
      z-index: -100;
    }
    
    .tool:hover::before,
    .tool:focus::before,
    .tool:hover::after,
    .tool:focus::after {
      opacity: 1;
      transform: scale(1) translateY(0);
      z-index: 100;
    }
    
    
    /*== pointer tip ==*/
    .tool::before {
      border-style: solid;
      border-width: 1em 0.75em 0 0.75em;
      border-color: #565C61 transparent transparent transparent;
      bottom: 105%;
      content: "";
      margin-left: -0.5em;
      transition: all .65s cubic-bezier(.84,-0.18,.31,1.26), opacity .65s .5s;
      transform:  scale(.6) translateY(-90%);
    }
    
    .tool:hover::before,
    .tool:focus::before {
      transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
    }
    
    
    
    /*== speech bubble ==*/
    .tool::after {
      background: #565C61;
      border-radius: .25em;
      bottom: 120%;
      color: #EDEFF0;
      font-size:15px;
      content: attr(data-tip);
      margin-left: -8.75em;
      padding: 1em;
      transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
      transform:  scale(.6) translateY(50%);
      width: 17.5em;
    
    }
    
    .tool:hover::after,
    .tool:focus::after  {
      transition: all .65s cubic-bezier(.84,-0.18,.31,1.26);
    }
    
    @media (max-width: 760px) {
      .tool::after {
        font-size: .75em;
        margin-left: -5em;
        width: 10em;
      }
    }
    
    
    
    
    
    .switch, *::before, *::after {
      box-sizing: border-box;
      margin-bottom: 20px !important;
    }
    
    .switch input[type='checkbox'] {
      appearance: none;
      display: block;
      margin: 0;
    }
    
    .switch label {
      color: #29323a;
      font-size: 17px !important;
      display: block;
      height: 2.375rem;
      position: relative;
      cursor: pointer;
      padding-left: 7rem;
      padding-top: 3px !important;
    }
    
    .switch input[type='checkbox']+label::before {
      content: 'Non';
      text-align: right;
      font-size: 1.3rem;
      padding: 0.375rem 0.5rem;
      color: #fff;
      display: block;
      height: 2.5rem;
      width: 5.5rem;
      border-radius: 9999px;
      position: absolute;
      top: calc(0.375rem - 1px);
      left: 5px;
      background-color: #8f8f8f;
      box-shadow: 0 0 0 1px #e0e0e0;
      transition: all 0.3s cubic-bezier(0.72, 0.26, 0.26, 0.82), visibility 0s;
    }
    
    .switch input[type='checkbox']+label::after {
      content: '';
      display: block;
      height: 2.5rem;
      width: 2.5rem;
      border: solid 0.25rem #8f8f8f;
      border-radius: 9999px;
      position: absolute;
      top: calc(0.375rem - 1px);
      left: 5px;
      background-color: #fff;
      transition: all 0.3s cubic-bezier(0.72, 0.26, 0.26, 0.82), visibility 0s;
    }
    
    .switch input[type='checkbox']:checked+label::before {
      content: 'Oui';
      text-align: left;
      background-color: #ffa409;
    }
    
    .switch input[type='checkbox']:checked+label::after {
      left: 3.5rem;
      border-color: #ffa409;
    }

    // css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
  </style>